import React, { useState, useEffect, useCallback, useRef, useContext, createContext } from "react";
import { createClient } from "@supabase/supabase-js";

const supabase = createClient(
  "https://mvwhqgqohwlqurmerntf.supabase.co",
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im12d2hxZ3FvaHdscXVybWVybnRmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzU0NzU1MTAsImV4cCI6MjA5MTA1MTUxMH0.GQsaa786KC4kOYnIlgm2WD7JVTSQ_M3r2-ZqgOe7MME"
);
const API = process.env.REACT_APP_API_URL || "https://api.antifragilsociety.es";

// JSONB defensivo a nivel de módulo (Supabase a veces devuelve JSONB como string).
// Usado por los helpers top-level (computeWeekStats, etc.) que no ven el _parseJSONB
// del componente Dashboard.
const _pjb=(v)=>{if(!v)return null;if(typeof v==="object")return v;try{return JSON.parse(v);}catch(e){return null;}};

// Paleta refresh 29-abr — mucho más punch. Cards elevadas sobre fondo, accents vivos
// (lima para integrado/done, coral para fricción/urgente) y oro como acento premium.
const T = {
  bg:"#0a0a0a",                              // fondo principal
  bgCard:"#141414",                           // bg de card — elevación visible sobre bg
  bgCardSoft:"#181818",                       // hover/inner
  crema:"#f5f0e8",                            // texto principal
  oro:"#C6A670",                              // acento premium / títulos / hashtag — oro canónico muestreado del logo (champán apagado)
  oroBg:"rgba(201,168,76,0.10)",              // fondo de card "gold"
  oroBorder:"rgba(201,168,76,0.28)",          // border de card "gold"
  oroGlow:"rgba(201,168,76,0.04)",            // glow ultra suave
  // Acentos vivos nuevos
  lima:"#9FE870",                             // verde lima — integrado / energy / done
  coral:"#FF6B4A",                            // coral — fricción / urgente / costó
  // Aliases para no romper código existente que usa T.verde / T.rojo
  verde:"#9FE870",
  rojo:"#FF6B4A",
  gris:"#6b6560",grisL:"#9e9790",
  glass:"rgba(255,255,255,0.04)",gb:"rgba(255,255,255,0.07)",
  font:"'DM Sans',system-ui,sans-serif",serif:"'Playfair Display',Georgia,serif",
};

const P_DIMS=[
  {id:"O",name:"Curiosidad",icon:"🔮",color:"#9b59b6"},
  {id:"C",name:"Constancia",icon:"🎯",color:"#27ae60"},
  {id:"E",name:"Energía social",icon:"\u26A1",color:"#f39c12"},
  {id:"A",name:"Conexión",icon:"🤝",color:"#3498db"},
  {id:"N",name:"Sensibilidad",icon:"🌊",color:"#e74c3c"},
];
const V_DIMS=[
  {id:"REG",name:"Regulación",icon:"🫁",color:"#1abc9c"},
  {id:"EMO",name:"Emoción",icon:"💧",color:"#e74c3c"},
  {id:"VIN",name:"Vínculo",icon:"🤲",color:"#2980b9"},
  {id:"CUI",name:"Cuidado",icon:"🏠",color:"#27ae60"},
  {id:"PRO",name:"Propósito",icon:"🧭",color:"#f39c12"},
  {id:"EXP",name:"Exploración",icon:"🔭",color:"#9b59b6"},
  {id:"IDE",name:"Identidad",icon:"🪞",color:"#e67e22"},
  {id:"DIS",name:"Disfrute",icon:"☀️",color:"#f1c40f"},
];

// Las 4 fases del arco. Cycle_number 5+ vuelve a empezar el arco sobre el siguiente reto.
// `headline` = una frase punchy. `desc` = bloque narrativo formato (· El reto: / · El proceso: / · El resultado:).
// Si desc es vacío, en el dashboard se muestra solo "Bloqueado" sin texto. Por ahora solo
// el ciclo 1 tiene copy completo; los demás se rellenarán a medida que Vanessa los escriba.
const CYCLE_PHASES=[
  {n:"Arrancar",
   headline:"Fin a la dependencia de la motivación. Fin a las excusas.",
   desc:"· El reto: Romper la inercia y configurar tu sistema operativo mental para ejecutar sin esperar a tener ganas, a otros, a lo que sea que te dijeras hasta hoy y en función de tus propios objetivos.\n\n· El proceso: 28 días de entrenamiento en ejecución deliberada. Actúas cuando tu cerebro te boicotea. Actúas cuando tu cuerpo se subleva. Actúas.\n\n· El resultado: Sustituye la \"fuerza de voluntad\" —un recurso que se agota— por un protocolo de acción automática."},
  {n:"Integrar",   headline:"", desc:""},
  {n:"Materializar", headline:"", desc:""},
  {n:"Elegir",     headline:"", desc:""},
];
const phaseFor=cn=>CYCLE_PHASES[(((cn||1)-1)%4)];

const WEEK_DESCRIPTIONS={
  // Cycle 1 — Arrancar (renombrado desde "Resistir" el 28-abr)
  Arrancar:["Romper inercia","Aguantar el peso","Patrones visibles","Cierre y siguiente nivel"],
  Integrar:["Repetir sin pensar","Profundizar","Conectar","Cierre y siguiente nivel"],
  Materializar:["Salir al mundo","Sostener bajo presión","Eustrés","Cierre y siguiente nivel"],
  Elegir:["Mirar hacia dentro","Probar opciones","Decidir","Diseñar el siguiente arco"],
};

const CAT_MAP={
  "regulacion":{l:"Regulación",c:"#1abc9c"},"emocion":{l:"Emoción",c:"#e74c3c"},
  "vinculo":{l:"Vínculo",c:"#2980b9"},"cuidado":{l:"Cuidado",c:"#27ae60"},
  "proposito":{l:"Propósito",c:"#f39c12"},"exploracion":{l:"Exploración",c:"#9b59b6"},
  "identidad":{l:"Identidad",c:"#e67e22"},"disfrute":{l:"Disfrute",c:"#f1c40f"},
  "compromiso":{l:"Compromiso",c:"#c0392b"},
};

function getCat(m){const raw=(m.category||m.meta?.tag||"").toLowerCase().replace(/micro-cambio\s*/,"").trim();return CAT_MAP[raw]||{l:raw||"—",c:T.grisL};}

function Radar({scores,dims,size=180,color=null}){
  const pad=35,full=size+pad*2,cx=full/2,cy=full/2,r=size*0.34,n=dims.length;
  const pt=(i,v)=>{const a=(Math.PI*2*i)/n-Math.PI/2,d=(v/100)*r;return{x:cx+d*Math.cos(a),y:cy+d*Math.sin(a)};};
  const sc=color||T.oro;
  return(<svg width={full} height={full} viewBox={`0 0 ${full} ${full}`} style={{maxWidth:"100%"}}>
    {[25,50,75,100].map(l=><polygon key={l} points={dims.map((_,i)=>pt(i,l)).map(p=>`${p.x},${p.y}`).join(" ")} fill="none" stroke="rgba(255,255,255,0.06)" strokeWidth={1}/>)}
    {dims.map((_,i)=>{const p=pt(i,100);return<line key={i} x1={cx} y1={cy} x2={p.x} y2={p.y} stroke="rgba(255,255,255,0.08)" strokeWidth={1}/>;})}
    {(()=>{const pts=dims.map((d,i)=>pt(i,scores[d.id]||0));return<><polygon points={pts.map(p=>`${p.x},${p.y}`).join(" ")} fill={`${sc}20`} stroke={sc} strokeWidth={2}/>{pts.map((p,i)=><circle key={i} cx={p.x} cy={p.y} r={3.5} fill={dims[i].color} stroke={T.bg} strokeWidth={1.5}/>)}</>;})()}
    {dims.map((d,i)=>{const p=pt(i,125);return<text key={i} x={p.x} y={p.y} textAnchor="middle" dominantBaseline="middle" fill={d.color} fontSize={n>6?"8":"10"} fontFamily={T.font} fontWeight="500">{d.icon} {d.name}</text>;})}
  </svg>);
}

// Context para coordinar el botón global "Desplegar todo / Replegar todo".
// Cada vez que el botón se pulsa, forceCounter++ y forceMode = true|false; los Sec
// colapsables resetean su estado local. Después el user puede tocar cada sección
// individualmente y se respeta hasta el siguiente botón global.
const SecCtx = createContext({forceCounter:0, forceMode:null});

// BlockHeader — separador grande entre los 3 bloques narrativos del ciclo.
// La estructura RETO / PROCESO / RESULTADO replica las tres fases del producto.
const BlockHeader=({title,subtitle})=>(<div style={{marginTop:36,marginBottom:18,paddingTop:18,borderTop:`1px solid ${T.gb}`}}>
  <p style={{fontSize:10,letterSpacing:3.5,color:T.oro,textTransform:"uppercase",fontWeight:500,marginBottom:4}}>{title}</p>
  <p style={{fontFamily:T.serif,fontSize:18,fontStyle:"italic",color:T.grisL,lineHeight:1.3}}>{subtitle}</p>
</div>);

// Glyphs por sección — minimalistas, sin ilustraciones humanas. Adultos.
const SEC_GLYPHS = {
  "Mi objetivo":"◎",
  "Mi visión":"✦",
  "Quién soy":"◐",
  "Mi calendario":"▦",
  "Compromisos":"⊥",
  "Mis micro-cambios":"⚡",
  "Mi espacio":"◇",
  "Mis cimientos":"⊕",
  "Mis semanas":"◑",
  "Mi progreso":"▲",
  "Mi cuenta":"⊙",
};

const Sec=({title,sub,summary,collapsible=false,defaultOpen=true,glyph,id,children})=>{
  const{forceCounter,forceMode}=useContext(SecCtx);
  // Si la URL trae ?section=<id> que coincide con el id de la seccion, la abrimos
  // automaticamente y hacemos scroll. Vanessa (27jun26): el /diario del bot genera
  // un magic link con ?section=mi-espacio y queremos que al aterrizar el user vea
  // ya la seccion abierta y centrada — sin scroll manual. Usamos query param (no
  // hash) porque Supabase strip los fragments al hacer redirect del magic link.
  const sectionMatches = typeof window!=="undefined" && id && (()=>{
    try{return new URLSearchParams(window.location.search).get("section")===id;}catch{return false;}
  })();
  const[open,setOpen]=useState(defaultOpen||sectionMatches);
  const sectionRef=useRef(null);
  // Cuando cambia el counter del botón global, alinear el local al modo forzado.
  useEffect(()=>{if(forceMode!==null)setOpen(forceMode);},[forceCounter,forceMode]);
  // Section match al montar: scroll suave a la seccion para que el user la vea.
  useEffect(()=>{
    if(!sectionMatches) return;
    const t=setTimeout(()=>{
      if(sectionRef.current) sectionRef.current.scrollIntoView({behavior:"smooth",block:"start"});
    },300);
    return ()=>clearTimeout(t);
  },[sectionMatches]);
  // Glyph: explícito en prop, o derivado del título canónico (matching prefijo).
  const g=glyph||(()=>{const k=Object.keys(SEC_GLYPHS).find(x=>title?.startsWith(x));return k?SEC_GLYPHS[k]:null;})();

  // Header abierto: Playfair grande color crema, glyph translúcido oro al fondo.
  const openHeader=(<div style={{position:"relative",marginBottom:sub?4:18}}>
    {g&&<span style={{position:"absolute",right:-4,top:-12,fontSize:72,color:T.oro,opacity:0.07,fontFamily:T.serif,pointerEvents:"none",lineHeight:1,userSelect:"none"}}>{g}</span>}
    <p style={{fontFamily:T.serif,fontSize:22,fontWeight:400,color:T.crema,letterSpacing:0,position:"relative"}}>{title}</p>
  </div>);

  if(!collapsible){
    return<div ref={sectionRef} id={id} style={{marginBottom:36,scrollMarginTop:20}}>
      {openHeader}
      {sub&&<p style={{fontSize:12,color:T.grisL,marginTop:-12,marginBottom:14}}>{sub}</p>}
      {children}
    </div>;
  }
  // Cerrada: row-card con bg ligeramente elevado, padding cómodo, chevron oro.
  if(!open){
    return<button ref={sectionRef} id={id} onClick={()=>setOpen(true)} style={{width:"100%",background:T.bgCard,border:`1px solid ${T.gb}`,borderRadius:14,padding:"14px 18px",cursor:"pointer",fontFamily:T.font,textAlign:"left",display:"flex",alignItems:"center",gap:12,marginBottom:10,transition:"background 0.15s",scrollMarginTop:20}}
      onMouseEnter={e=>e.currentTarget.style.background=T.bgCardSoft}
      onMouseLeave={e=>e.currentTarget.style.background=T.bgCard}>
      {g&&<span style={{fontSize:18,color:T.oro,opacity:0.55,minWidth:18,textAlign:"center",fontFamily:T.serif}}>{g}</span>}
      <span style={{fontFamily:T.serif,fontSize:15,color:T.crema,fontWeight:400,flex:0,whiteSpace:"nowrap"}}>{title}</span>
      {summary&&<span style={{fontSize:11,color:T.grisL,flex:1,fontWeight:400,letterSpacing:0,lineHeight:1.4,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",marginLeft:6}}>{summary}</span>}
      <span style={{fontSize:18,color:T.oro,marginLeft:"auto",flex:0,transition:"transform 0.2s",lineHeight:1}}>›</span>
    </button>;
  }
  // Abierta colapsable: header tipo "no colapsable" + chevron a la derecha que cierra
  return<div ref={sectionRef} id={id} style={{marginBottom:36,scrollMarginTop:20}}>
    <button onClick={()=>setOpen(false)} style={{width:"100%",background:"none",border:"none",padding:0,cursor:"pointer",fontFamily:T.font,textAlign:"left",display:"block",position:"relative"}}>
      <div style={{display:"flex",alignItems:"baseline",gap:12,position:"relative"}}>
        {g&&<span style={{position:"absolute",right:-4,top:-12,fontSize:72,color:T.oro,opacity:0.07,fontFamily:T.serif,pointerEvents:"none",lineHeight:1,userSelect:"none"}}>{g}</span>}
        <p style={{fontFamily:T.serif,fontSize:22,fontWeight:400,color:T.crema,flex:1,position:"relative"}}>{title}</p>
        <span style={{fontSize:18,color:T.oro,flex:0,transform:"rotate(90deg)",lineHeight:1,position:"relative"}}>›</span>
      </div>
      {sub&&<p style={{fontSize:12,color:T.grisL,marginTop:4,textAlign:"left"}}>{sub}</p>}
    </button>
    <div style={{height:18}}/>
    {children}
  </div>;
};
// Card con elevación visible — bg más claro que el body, radius grande, padding generoso.
// "gold" para cards destacadas (objetivo, hero, mensaje semanal). Sombra muy sutil para
// flotar sin caer en skeumorfismo.
const Card=({children,gold,style})=><div style={{background:gold?T.oroBg:T.bgCard,border:`1px solid ${gold?T.oroBorder:T.gb}`,borderRadius:18,padding:"20px 20px",boxShadow:gold?"0 1px 0 rgba(201,168,76,0.06)":"0 1px 0 rgba(255,255,255,0.02)",...style}}>{children}</div>;
const Div=()=><div style={{height:1,background:"rgba(201,168,76,0.15)",margin:"32px 0"}}/>;
const Stat=({n,label})=><div style={{background:T.glass,border:`1px solid ${T.gb}`,borderRadius:10,padding:"12px 8px",textAlign:"center",flex:1}}><div style={{fontSize:24,fontWeight:500,color:T.crema}}>{n}</div><div style={{fontSize:10,color:T.grisL,marginTop:3}}>{label}</div></div>;
// Chip de estado — más visible que la versión antigua: padding y tipografía mayores,
// border sutil del color para que no se sienta plano sobre la card oscura.
const Tg=({label,color})=><span style={{fontSize:11,padding:"4px 10px",borderRadius:8,background:`${color}1f`,color,border:`1px solid ${color}33`,fontWeight:500,letterSpacing:0.2,whiteSpace:"nowrap"}}>{label}</span>;
// DOW corto para weekly_dow chips
const DOW_SHORT={1:"lun",2:"mar",3:"mié",4:"jue",5:"vie",6:"sáb",7:"dom"};

// DTg — chip "cuándo aplica" del micro/compromiso. Una línea por pattern del modelo nuevo.
// Si no hay pattern (user antiguo aún en legacy), cae al cálculo viejo desde schedules/days.
// Hora real de un micro con MOMENTO según el turno del día — espejo del bot (_time_for_momento).
// Para turnos rotativos: "antes_trabajo" sale a 21:45 en turno noche (empieza 22:00) y a 05:45 en
// mañana. El dashboard antes mostraba la hora fija `times` (como si fuera mañana) — Vanessa 10-ago.
const _SCHED_PX={workday:"wk",work_am:"am",work_pm:"pm",work_night:"nt",dayoff:"do",day_off:"do",vacation:"vc",special:"sp"};
const _momentoHour=(momento,ds,dayType)=>{
  if(!momento||!ds||typeof ds!=="object") return null;
  const px=_SCHED_PX[dayType]||"wk";
  const _pm=(key)=>{const v=ds[`${px}_${key}`];if(!v||!String(v).includes(":"))return null;const p=String(v).split(":");const h=parseInt(p[0],10),m=parseInt(p[1],10);return(isNaN(h)||isNaN(m))?null:h*60+m;};
  let wake=_pm("wake"),start=_pm("start"),end=_pm("end"),sleep=_pm("sleep");
  if(wake==null) wake=8*60;
  if(sleep==null) sleep=23*60;
  const hhmm=(mins)=>{mins=((mins%1440)+1440)%1440;return `${String(Math.floor(mins/60)).padStart(2,"0")}:${String(mins%60).padStart(2,"0")}`;};
  if(momento==="al_despertar") return hhmm(wake);
  if(momento==="antes_dormir") return hhmm(sleep-15);
  if(momento==="antes_trabajo") return start!=null?hhmm(start-15):hhmm(wake);
  if(momento==="salir_trabajo") return end!=null?hhmm(end):hhmm(sleep-60);
  if(momento==="en_trabajo"){if(start!=null&&end!=null){const dur=(((end-start)%1440)+1440)%1440;return hhmm(start+Math.floor(dur/2));}const rng=(((sleep-wake)%1440)+1440)%1440;return hhmm(wake+Math.floor(rng/2));}
  if(momento==="libre"){if(end!=null){const gap=(((sleep-end)%1440)+1440)%1440;return hhmm(end+Math.floor(gap/2));}const rng=(((sleep-wake)%1440)+1440)%1440;return hhmm(wake+Math.floor(rng*0.66));}
  return null;
};
// Hora del radar de un situacional adaptada al turno (2h tras despertar). Espejo de _situational_anchor
// del bot. null en día sin turno (workday genérico) → se usa la hora fija del LLM. Vanessa 10-ago.
const _radarHour=(ds,dayType)=>{
  if(!ds||typeof ds!=="object") return null;
  const px=_SCHED_PX[dayType]||"wk";
  if(!["am","pm","nt","do"].includes(px)) return null;
  const v=ds[`${px}_wake`];if(!v||!String(v).includes(":"))return null;
  const p=String(v).split(":");const wake=parseInt(p[0],10)*60+parseInt(p[1],10);
  if(isNaN(wake))return null;
  const mins=(((wake+120)%1440)+1440)%1440;
  return `${String(Math.floor(mins/60)).padStart(2,"0")}:${String(mins%60).padStart(2,"0")}`;
};
// day_type del día en que el micro APLICA (para calcular su hora de momento con el turno correcto):
// daily/interval → hoy; weekly_dow → el día de esta semana que cae en su dow.
const _microApplyDayType=(m,cd,calDays,cycleStart)=>{
  const dtOf=(day)=>(((calDays||[]).find(d=>d.cycle_day===day)||{}).day_type)||"workday";
  if(m.pattern==="weekly_dow"&&Array.isArray(m.dows)&&m.dows.length&&cycleStart){
    const cs=new Date((""+cycleStart).slice(0,10)+"T00:00:00");
    const wkStart=Math.floor((cd-1)/7)*7+1;
    for(let d=wkStart;d<=Math.min(wkStart+6,28);d++){
      const dt=new Date(cs);dt.setDate(dt.getDate()+(d-1));const dow=((dt.getDay()+6)%7)+1;
      if(m.dows.includes(dow))return dtOf(d);
    }
  }
  return dtOf(cd);
};
const DTg=({pattern,day_types,dows,weekly_target,interval_days,days,schedules,times,radarHour})=>{
  let label="📅 Todos";
  if(pattern==="situational") label=`💭 Cuando surja · radar ${radarHour||(Array.isArray(times)&&times[0])||"12:00"}h`;
  else if(pattern==="weekly_count"){const _s=new Set(day_types||["workday","dayoff"]);const _w=[..._s].some(t=>t==="workday"||String(t).startsWith("work_"));const _o=_s.has("dayoff")||_s.has("vacation");const _al=(_w&&_o)?"todos":(_w?"laborables":"libres");label=`💭 Cuando surja · mín ${weekly_target||2}/sem (${_al})`;}
  else if(pattern==="monthly") label="📆 Mensual";
  else if(pattern==="interval") label=`🔁 Cada ${interval_days||3}d`;
  else if(pattern==="weekly_dow"){
    const dws=Array.isArray(dows)?dows:[];
    if(dws.length===0) label="📅 Semanal";
    else if(dws.length===1) label=`📅 ${DOW_SHORT[dws[0]]||"vie"}`;
    else if(dws.length<=3) label=`📅 ${dws.map(d=>DOW_SHORT[d]||"?").join("/")}`;
    else label=`📅 ${dws.length}d/sem`;
  }
  else if(pattern==="daily"){
    // Vanessa (7-jun): daily = todos los días salvo special. day_types ya no
    // filtra en runtime — el chip refleja eso. Un solo label coherente.
    label="📅 Todos los días";
  } else {
    // Fallback legacy (sin pattern): usa schedules/days viejos.
    const lblOf=(t)=>({workday:"🏢 Lab",dayoff:"🛋 Libre",vacation:"🏖 Vacas",special:"⭐ Esp",work_am:"🌅 Mañana",work_pm:"☀️ Tarde",work_night:"🌙 Noche"})[t]||t;
    if(schedules&&typeof schedules==="object"){
      const active=Object.entries(schedules).filter(([,v])=>v&&v.active).map(([k])=>k);
      if(active.length===0) label="📅 —";
      else if(active.length===1) label=lblOf(active[0]);
      else if(active.length===Object.keys(schedules).length) label="📅 Todos";
      else if(active.every(t=>t.startsWith("work")||t==="workday")) label="🏢 Solo lab";
      else if(active.includes("dayoff")&&!active.some(t=>t.startsWith("work")||t==="workday")) label="🛋 Solo libre";
      else label=`📅 ${active.length} tipos`;
    } else {
      const d=days||"all";
      if(d==="workday") label="🏢 Lab";
      else if(d==="dayoff") label="🛋 Libre";
      else if(d==="vacation") label="🏖 Vacas";
      else label="📅 Todos";
    }
  }
  return<span style={{fontSize:9,padding:"2px 7px",borderRadius:4,background:T.oroBg,color:T.oro}}>{label}</span>;
};

// ── Exportar compromisos (y opcionalmente micros) al calendario del user vía .ics ──
// iCalendar universal (Google / Apple / Outlook). Puro cliente, sin OAuth ni backend.
// weekly_dow -> evento recurrente hasta el deadline; deadline suelto -> dia completo en la
// fecha; daily/interval -> recurrente hasta fin de ciclo. Fechas en hora LOCAL (floating)
// para no desfasar por UTC (mismo cuidado que en App.jsx con ymd()).
const ICS_DOW={1:"MO",2:"TU",3:"WE",4:"TH",5:"FR",6:"SA",7:"SU"};
const _p2=n=>String(n).padStart(2,"0");
const _icsStamp=()=>{const d=new Date();return `${d.getUTCFullYear()}${_p2(d.getUTCMonth()+1)}${_p2(d.getUTCDate())}T${_p2(d.getUTCHours())}${_p2(d.getUTCMinutes())}${_p2(d.getUTCSeconds())}Z`;};
const _icsLocal=d=>`${d.getFullYear()}${_p2(d.getMonth()+1)}${_p2(d.getDate())}T${_p2(d.getHours())}${_p2(d.getMinutes())}00`;
const _icsDay=dstr=>(dstr||"").replace(/-/g,"");
const _addDaysStr=(dstr,n)=>{const d=new Date(dstr+"T00:00:00");d.setDate(d.getDate()+n);return `${d.getFullYear()}-${_p2(d.getMonth()+1)}-${_p2(d.getDate())}`;};
const _esc=s=>String(s||"").replace(/\\/g,"\\\\").replace(/;/g,"\\;").replace(/,/g,"\\,").replace(/\r?\n/g,"\\n");
const _jsDow=dw=>dw===7?0:dw;
function _firstOnOrAfter(startStr,dows){
  const start=new Date(startStr+"T00:00:00");let best=null;
  (dows||[]).forEach(dw=>{const t=_jsDow(dw);const d=new Date(start);d.setDate(d.getDate()+((t-d.getDay()+7)%7));if(!best||d<best)best=d;});
  return best||start;
}
function _icsEvent(m,startFrom,cycleEnd){
  const deadline=m.meta?.deadline||cycleEnd;
  const [hh,mm]=String((Array.isArray(m.times)&&m.times[0])||"").split(":").map(Number);
  const H=Number.isFinite(hh)?hh:(m.pattern==="weekly_dow"?20:9), M=Number.isFinite(mm)?mm:0;
  const uid=`${m.id||Math.random().toString(36).slice(2)}@antifragilsociety`;
  const L=["BEGIN:VEVENT",`UID:${uid}`,`DTSTAMP:${_icsStamp()}`,`SUMMARY:${_esc(m.title||"Compromiso")}`,`DESCRIPTION:${_esc((m.desc||"")+" — Antifrágil")}`];
  if(m.pattern==="weekly_dow"&&Array.isArray(m.dows)&&m.dows.length){
    const first=_firstOnOrAfter(startFrom,m.dows);first.setHours(H,M,0,0);
    const end=new Date(first);end.setMinutes(end.getMinutes()+30);
    const byday=m.dows.map(d=>ICS_DOW[d]).filter(Boolean).join(",");
    L.push(`DTSTART:${_icsLocal(first)}`,`DTEND:${_icsLocal(end)}`,`RRULE:FREQ=WEEKLY;BYDAY=${byday};UNTIL=${_icsDay(deadline)}T235900`);
    L.push("BEGIN:VALARM","ACTION:DISPLAY","DESCRIPTION:Compromiso Antifrágil","TRIGGER:-PT30M","END:VALARM");
  } else if(m.pattern==="daily"||m.pattern==="interval"){
    const first=new Date(startFrom+"T00:00:00");first.setHours(H,M,0,0);
    const end=new Date(first);end.setMinutes(end.getMinutes()+20);
    const rule=m.pattern==="interval"?`FREQ=DAILY;INTERVAL=${m.interval_days||3}`:"FREQ=DAILY";
    L.push(`DTSTART:${_icsLocal(first)}`,`DTEND:${_icsLocal(end)}`,`RRULE:${rule};UNTIL=${_icsDay(cycleEnd)}T235900`);
  } else if(m.meta?.deadline){
    L.push(`DTSTART;VALUE=DATE:${_icsDay(m.meta.deadline)}`,`DTEND;VALUE=DATE:${_icsDay(_addDaysStr(m.meta.deadline,1))}`);
  } else {
    return null;  // situational / weekly_count / monthly sin fecha fija: no agendable
  }
  L.push("END:VEVENT");
  return L.join("\r\n");
}
function _buildICS(items,startFrom,cycleEnd){
  const evs=(items||[]).map(m=>_icsEvent(m,startFrom,cycleEnd)).filter(Boolean);
  return ["BEGIN:VCALENDAR","VERSION:2.0","PRODID:-//Antifragil//ES","CALSCALE:GREGORIAN","METHOD:PUBLISH",...evs,"END:VCALENDAR"].join("\r\n");
}
function _downloadICS(name,content){
  const blob=new Blob([content],{type:"text/calendar;charset=utf-8"});
  const url=URL.createObjectURL(blob);const a=document.createElement("a");
  a.href=url;a.download=name;document.body.appendChild(a);a.click();
  document.body.removeChild(a);setTimeout(()=>URL.revokeObjectURL(url),1500);
}
function CalendarExport({comps,mcs,cycleStart}){
  const [done,setDone]=useState("");
  if(!comps||!comps.length) return null;
  const t=new Date();const todayStr=`${t.getFullYear()}-${_p2(t.getMonth()+1)}-${_p2(t.getDate())}`;
  const start=cycleStart||todayStr;
  const startFrom=todayStr>start?todayStr:start;              // no agendar en el pasado
  const cycleEnd=_addDaysStr(start,27);
  const go=(items,file)=>{_downloadICS(file,_buildICS(items,startFrom,cycleEnd));setDone(file);setTimeout(()=>setDone(""),3500);};
  return (
    <div style={{marginTop:14,paddingTop:14,borderTop:`1px solid ${T.line||"rgba(255,255,255,.08)"}`}}>
      <button onClick={()=>go(comps,"compromisos-antifragil.ics")}
        style={{width:"100%",padding:"11px 14px",borderRadius:10,border:`1px solid ${T.oroBorder||T.oro}`,background:T.oroBg||"transparent",color:T.oro,fontSize:13,fontWeight:600,cursor:"pointer",letterSpacing:.3}}>
        📅 Añadir mis compromisos al calendario
      </button>
      {mcs&&mcs.length>0&&<button onClick={()=>go([...comps,...mcs],"compromisos-y-micros-antifragil.ics")}
        style={{marginTop:8,width:"100%",padding:"8px 14px",borderRadius:8,border:"none",background:"transparent",color:T.grisL,fontSize:11,cursor:"pointer",textDecoration:"underline"}}>
        …o incluir también los micro-cambios
      </button>}
      {done&&<p style={{margin:"8px 0 0",fontSize:11,color:T.lima,textAlign:"center"}}>✓ Descargado — ábrelo para añadirlo a tu calendario</p>}
      <p style={{margin:"8px 0 0",fontSize:10,color:T.gris,textAlign:"center",lineHeight:1.5}}>Compatible con Google Calendar, Apple y Outlook. Los compromisos con día fijo se añaden como evento recurrente hasta su fecha límite.</p>
    </div>
  );
}

function Login({onLogin}){
  const[email,setEmail]=useState("");const[pass,setPass]=useState("");const[err,setErr]=useState("");const[ld,setLd]=useState(false);
  const go=async e=>{e.preventDefault();setLd(true);setErr("");try{const{data,error}=await supabase.auth.signInWithPassword({email,password:pass});if(error)throw error;onLogin(data.user);}catch(e){setErr("Email o contraseña incorrectos");}setLd(false);};
  return(<div style={{minHeight:"100vh",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",padding:"48px 24px",background:T.bg}}>
    <p style={{color:T.oro,fontSize:11,letterSpacing:4,marginBottom:8,textTransform:"uppercase"}}>ANTIFRÁGIL</p>
    <h1 style={{fontFamily:T.serif,fontSize:"1.8rem",color:T.crema,marginBottom:6}}>Tu programa</h1>
    <p style={{color:T.grisL,fontSize:14,marginBottom:32}}>Entra con tu cuenta</p>
    <form onSubmit={go} style={{width:"100%",maxWidth:320,display:"flex",flexDirection:"column",gap:10}}>
      <input type="email" placeholder="Email" value={email} onChange={e=>setEmail(e.target.value)} style={{padding:"12px 16px",borderRadius:10,border:`1px solid ${T.gb}`,background:T.glass,color:T.crema,fontSize:14,fontFamily:T.font,outline:"none"}}/>
      <input type="password" placeholder="Contraseña" value={pass} onChange={e=>setPass(e.target.value)} style={{padding:"12px 16px",borderRadius:10,border:`1px solid ${T.gb}`,background:T.glass,color:T.crema,fontSize:14,fontFamily:T.font,outline:"none"}}/>
      {err&&<p style={{color:T.rojo,fontSize:12,textAlign:"center"}}>{err}</p>}
      <button type="submit" disabled={ld} style={{padding:14,borderRadius:10,border:"none",background:T.oro,color:T.bg,fontSize:14,fontWeight:500,cursor:"pointer",opacity:ld?0.5:1,fontFamily:T.font,letterSpacing:1,textTransform:"uppercase",marginTop:4}}>{ld?"Entrando...":"Entrar"}</button>
    </form>
  </div>);
}

export default function Dashboard(){
  const[user,setUser]=useState(null);const[authOk,setAuthOk]=useState(false);const[data,setData]=useState(null);const[loading,setLoading]=useState(true);const[fetchErr,setFetchErr]=useState(null);const[retryCount,setRetryCount]=useState(0);
  // arcSelected y secForce deben declararse ANTES de cualquier early return para no
  // violar las Rules of Hooks. arcSelected inicia en 1 y se sincroniza con cycleNum real
  // vía useEffect. secForce controla el botón global "Desplegar todo / Replegar todo".
  const[arcSelected,setArcSelected]=useState(1);
  const[secForce,setSecForce]=useState({counter:0,mode:null,allOpen:false});
  const toggleAllSections=useCallback(()=>setSecForce(s=>({counter:s.counter+1,mode:!s.allOpen,allOpen:!s.allOpen})),[]);

  // Detecta errores que Supabase pone en el hash tras un magic link caducado/inválido
  const urlHash=typeof window!=="undefined"?window.location.hash:"";
  const linkErr=urlHash.includes("error_code=otp_expired")?"otp_expired":(urlHash.includes("error=access_denied")?"access_denied":null);

  useEffect(()=>{supabase.auth.getSession().then(({data:{session}})=>{if(session?.user)setUser(session.user);setAuthOk(true);});},[]);

  const fetchData=useCallback(async uid=>{
    setLoading(true);setFetchErr(null);
    try{
      // Auth (P0 IDOR 26-jul): el endpoint ahora exige el JWT del user (el dashboard tiene
      // sesión via magic link). Sin token → 401 y mensaje de sesión expirada.
      const {data:{session}}=await supabase.auth.getSession();
      const token=session?.access_token;
      const r=await fetch(`${API}/api/dashboard/${uid}`, token?{headers:{Authorization:`Bearer ${token}`}}:undefined);
      if(r.ok) setData(await r.json());
      else if(r.status===401||r.status===403) setFetchErr("auth_error");
      else setFetchErr(r.status===404?"not_found":"server_error");
    }catch(e){console.error(e);setFetchErr("network_error");}
    setLoading(false);
  },[]);

  useEffect(()=>{if(user)fetchData(user.id);},[user,fetchData]);

  // Sincroniza arcSelected al cycleNum real una vez data esté disponible (para users en cycle 2+).
  useEffect(()=>{const cn=data?.cycle?.cycle_number||1;setArcSelected(cn);},[data?.cycle?.cycle_number]);

  // Auto-retry máximo 2 veces tras 6s si los pilares aún no están (lazy generation en backend).
  // Sin el cap, el dashboard recargaba cada 6s indefinidamente cuando los pilares fallaban.
  useEffect(()=>{
    if(!data||!user||retryCount>=2) return;
    const hasPillars=data.pillars_map&&Array.isArray(data.pillars_map.pillars)&&data.pillars_map.pillars.length>0;
    if(!hasPillars){
      const t=setTimeout(()=>{setRetryCount(c=>c+1);fetchData(user.id);},6000);
      return()=>clearTimeout(t);
    }
  },[data,user,fetchData,retryCount]);

  if(!authOk)return<Ldr/>;

  // Magic link inválido o caducado — antes de mostrar Login (que pide pass que el user no tiene), explicamos qué pasó
  if(!user&&linkErr){
    return<div style={{minHeight:"100vh",display:"flex",alignItems:"center",justifyContent:"center",padding:"48px 24px",background:T.bg,flexDirection:"column",textAlign:"center"}}>
      <p style={{color:T.oro,fontSize:11,letterSpacing:4,marginBottom:14,textTransform:"uppercase"}}>ANTIFRÁGIL</p>
      <h1 style={{fontFamily:T.serif,fontSize:"1.6rem",color:T.crema,marginBottom:14,maxWidth:420}}>El enlace ha caducado</h1>
      <p style={{color:T.grisL,fontSize:14,maxWidth:380,lineHeight:1.6,marginBottom:20}}>Los enlaces de acceso son de un solo uso y duran una hora. Vuelve a tu chat con el bot y escribe <code style={{color:T.oro}}>/mi_dashboard</code> para que te genere uno nuevo. Click inmediato.</p>
      <p style={{color:T.gris,fontSize:11}}>{linkErr==="otp_expired"?"otp_expired":"access_denied"}</p>
    </div>;
  }

  if(!user)return<Login onLogin={setUser}/>;

  if(loading)return<Ldr text="Cargando tu programa..."/>;
  // Sesión válida pero el API no devolvió datos: o el profile aún no existe (onboarding no terminado) o hay un mismatch entre auth_id y profiles
  if(!data){
    return<div style={{minHeight:"100vh",display:"flex",alignItems:"center",justifyContent:"center",padding:"48px 24px",background:T.bg,flexDirection:"column",textAlign:"center"}}>
      <p style={{color:T.oro,fontSize:11,letterSpacing:4,marginBottom:14,textTransform:"uppercase"}}>ANTIFRÁGIL</p>
      <h1 style={{fontFamily:T.serif,fontSize:"1.4rem",color:T.crema,marginBottom:14,maxWidth:420}}>Aún no encuentro tu programa</h1>
      <p style={{color:T.grisL,fontSize:14,maxWidth:380,lineHeight:1.6,marginBottom:14}}>Sesión válida pero no veo tu perfil en la base de datos. Si ya hiciste el onboarding y el bot te ha hablado, puede ser un mismatch de cuenta — escribe <code style={{color:T.oro}}>/mi_dashboard</code> al bot otra vez.</p>
      <p style={{color:T.gris,fontSize:11}}>error: {fetchErr||"desconocido"}</p>
    </div>;
  }

  const{profile,cycle,snapshot,micros,checkins,events,calendar,weekly,pillars_map,cimientos_message,down_days}=data;
  const name=profile?.name||"";
  // "T00:00:00" fuerza interpretación en hora LOCAL (una fecha date-only se parsea como
  // UTC y getDay() cae un día antes al oeste de Madrid → weekly_dow en día equivocado).
  const sd=cycle?.start_date?new Date(cycle.start_date+"T00:00:00"):new Date();
  // cdReal = día honesto (puede ser ≤0 si el ciclo aún no ha empezado, o >28 si ya cerró).
  // cd = clamped a [1,28] para cálculos internos (tabla maestra, calendario, micros).
  // isPreCycle / isPostCycle = flags para que el Hero muestre mensaje específico en lugar
  // de fingir "Día 1" cuando el user eligió empezar mañana.
  const cdReal=Math.floor((Date.now()-sd.getTime())/86400000)+1;
  // Parte 2 (equidad): los días caídos del bot no cuentan como día vivido → día EFECTIVO. El ciclo
  // dura hasta 28 efectivos; si el bot se cayó, cdReal va por delante (días de recuperación). El
  // "Día X/28" y el post-ciclo van por el efectivo, así un user en recuperación ve "Día 28/28", no
  // "Día 30/28". El bot cierra en rawCd = 29 + caídos, coherente con esto.
  const _downCount=(down_days||[]).filter(d=>d<=cdReal).length;
  const effCd=cdReal-_downCount;
  const isPreCycle=cdReal<1;
  const isPostCycle=effCd>28;
  // CÓMPUTO: post-ciclo usa cd=29 → el día 28 cuenta como PASADO (no "hoy pendiente") y la semana 4
  // del weekly_count se juzga, igual que el bot (que cierra en día 29 con lived=28). Sin esto el
  // dashboard mostraba MÁS % que Telegram al cierre (ocultaba fallos del día 28 + tiraba la semana 4).
  // DISPLAY: cdDisplay sigue clampado a 28 para no mostrar "día 29/28". Auditoría 12-ago.
  const cd=isPostCycle?29:Math.min(28,Math.max(1,cdReal));
  const cdDisplay=Math.min(28,Math.max(1,effCd));
  const wk=Math.min(Math.ceil(cdDisplay/7),4);
  // Parseo defensivo: Supabase puede devolver JSONB como string si la columna se
  // pobló con `json.dumps(...)` desde el bot (vs como dict directo). Sin esto, vs={}
  // string daría undefined al hacer vs[d.id] → radar vacío y "Cómo vives" + brecha
  // sin línea de vital. Mismo bug afecta a ocean_scores.
  const _parseJSONB=(v)=>{if(!v)return null;if(typeof v==="object")return v;try{return JSON.parse(v);}catch(e){return null;}};
  const osRaw=_parseJSONB(snapshot?.ocean_scores);
  const os=osRaw||{O:Math.round((snapshot?.ocean_openness||0.5)*100),C:Math.round((snapshot?.ocean_conscientiousness||0.5)*100),E:Math.round((snapshot?.ocean_extraversion||0.5)*100),A:Math.round((snapshot?.ocean_agreeableness||0.5)*100),N:Math.round((snapshot?.ocean_neuroticism||0.5)*100)};
  const vs=_parseJSONB(snapshot?.vital_scores)||{};
  const obj=snapshot?.four_week_goal||"";
  // Patrón canónico (perfil clickado en onboarding tipo "complacer"/"sobrepensar"/...).
  // peros_mirror guarda el perfil; peros_pattern arrastra un bug histórico (es el primer
  // PERO literal). Priorizamos mirror y solo caemos a pattern si el primero no existe.
  const pat=snapshot?.peros_mirror||snapshot?.peros_pattern||"";
  const board=(()=>{let b=snapshot?.manifesting_board||snapshot?.board||[];if(typeof b==="string")try{b=JSON.parse(b)}catch(e){b=[]};return Array.isArray(b)?b:[]})();
  const streak=cycle?.current_streak||0;

  // G38: deduplicación de checkins por (micro_change_id, cycle_day). El bot puede generar
  // varios rows el mismo día (reintento, doble-tap). Nos quedamos con el más reciente
  // — la API ya viene ordenada por checked_at desc, así que el primer hit por (mid,cd) gana.
  // También filtramos cycle_day > cd actual (eventos del futuro por desync de TZ).
  // 31-may: total = OPORTUNIDADES REALES según pattern (no nº de respuestas dadas).
  // Antes total=mc.length → 1 sola respuesta ✅ en todo el ciclo daba 100% cumplimiento.
  const _dowOf=(day)=>((((sd.getDay()+6)%7)+(day-1))%7)+1; // 1=lun..7=dom (getDay Dom=0 -> Lun=0 como el bot)
  const _dtByDay={};const _downByDay=new Set();(calendar||[]).forEach(d=>{if(d.cycle_day!=null){_dtByDay[d.cycle_day]=d.day_type;if(d.bot_down)_downByDay.add(d.cycle_day);}});
  // Vanessa (27-jun-26): dos magnitudes distintas.
  //   _opportunitiesInRange(meta, end): opps de día 1 a `end` segun pattern.
  //     - Si end=28 -> opps del CICLO ENTERO -> usado como TOTAL visible (X/Y).
  //     - Si end=cd -> opps HASTA HOY -> usado para CLASIFICAR (Integrado/Mantenimiento/Friccion)
  //       por ratio done/opps_hasta_hoy. Asi un user que llevaba 4/4 en dia 4 sale
  //       Integrado (100% relativo) aunque la cifra visible sea 4/28.
  // Criterio: la cifra grande mide proyeccion del ciclo (coherencia); el color mide
  // constancia hasta hoy (motivacion).
  const CYCLE_LEN=28;
  const _opportunitiesInRange=(meta,end)=>{
    const pattern=meta.pattern||null;
    const dows=Array.isArray(meta.dows)?meta.dows:null;
    const interval_days=meta.interval_days||null;
    const weekly_target=meta.weekly_target||null;
    // Arranca en el día en que nació el micro (P0 justicia): un micro del día 14 no acumula
    // oportunidades de los días 1-13 en que no existía.
    const scd=parseInt(meta.start_cycle_day,10)||1;
    if(scd>end) return 0;
    if(pattern==="weekly_count"&&weekly_target>0) return weekly_target*Math.ceil((end-scd+1)/7);
    let count=0;
    for(let day=scd;day<=end;day++){
      if(day===13) continue;
      if(_downByDay.has(day)) continue;  // día caído del bot → no cuenta como oportunidad (equidad)
      const dt=_dtByDay[day]||"workday";
      if(dt==="special") continue;
      const effDt=dt==="vacation"?"dayoff":dt;
      if(pattern==="daily"){
        count++;
      } else if(pattern==="weekly_dow"){
        if(dows&&dows.includes(_dowOf(day))) count++;
      } else if(pattern==="interval"){
        if(interval_days>0&&(day-1)%interval_days===0) count++;
      } else if(pattern==="monthly"){
        if(day===1||day===28) count++;
      } else if(!pattern){
        const sch=(meta.schedules||{})[effDt]||(meta.schedules||{})[dt];
        if(sch&&sch.active) count++;
      }
    }
    return count;
  };
  const parsed=micros.map(m=>{
    const meta=_pjb(m.metadata)||{};
    const mcAll=checkins.filter(c=>c.micro_change_id===m.id&&(c.cycle_day==null||c.cycle_day<=cd));
    const seenDay=new Set();
    const mc=[];
    for(const c of mcAll){const k=c.cycle_day??`_${c.checked_at}`;if(!seenDay.has(k)){seenDay.add(k);mc.push(c);}}
    let done=mc.filter(c=>c.completed).length;
    let hechos=null;  // "X hechos" a mostrar (weekly_count: todas las semanas; resto: = done)
    const isSituational=(meta.pattern==="situational")||(meta.frequency==="cuando_surja");
    const isWeeklyCount=meta.pattern==="weekly_count";
    // Dos magnitudes (Vanessa 27jun26):
    //  total = opps del CICLO ENTERO (28d) -> cifra visible X/Y. Coherencia.
    //  oppsSoFar = opps hasta hoy -> denominador del pct (clasificacion). Motivacion:
    //  un user que llevaba 4/4 sale Integrado (100% relativo) aunque cifra sea 4/28.
    let oppsCycle=isSituational?mc.length:_opportunitiesInRange(meta,CYCLE_LEN);
    // MODELO "no check-in = X, hoy pendiente" (Vanessa 11-ago): las oportunidades hasta hoy son los
    // días PASADOS que aplicaban (scd..cd-1, sin día 13 ni special) + HOY solo si ya lo respondiste.
    // Un día pasado sin marcar = NO HECHO (cuenta en el denominador, no en done). Hoy sin cerrar =
    // pendiente (fuera del denominador). Si oppsSoFar=0 → aún no hay nada que juzgar (neutro).
    let oppsSoFar;
    if(isSituational){oppsSoFar=mc.length;}
    else{
      const _pastOpps=_opportunitiesInRange(meta,Math.max(0,cd-1));
      const _todayApplies=(_opportunitiesInRange(meta,cd)-_pastOpps)>0;
      const _todayAnswered=mcAll.some(c=>c.cycle_day===cd);
      oppsSoFar=_pastOpps+((_todayApplies&&_todayAnswered)?1:0);
    }
    // weekly_count "cuando surja · mínimo X": done capado por semana + opps = Σ target_w (escalado
    // por ancla). Coincide con el cierre (_wc_done_opps) y las barras de pilar. Bug/modelo 9-ago.
    if(isWeeklyCount){
      const _wcC=_wcDoneOpps(meta,m.id,checkins,calendar,1,CYCLE_LEN);          // meta del ciclo (todas)
      const _wcAll=_wcDoneOpps(meta,m.id,checkins,calendar,1,cd);               // done total ("X hechos")
      const _wcClosed=_wcDoneOpps(meta,m.id,checkins,calendar,1,cd,cd);         // solo semanas CERRADAS (#3)
      // #3: la clasificación (color/pilar) usa solo semanas cerradas → en la semana en curso queda
      // PENDIENTE (neutro), no rojo. done Y oppsSoFar deben ser de la MISMA base (cerradas) para que
      // done/oppsSoFar ≤ 1 (antes done=todas / opps=cerradas → >100% capado, descuadraba). El total
      // "X hechos" del user usa `hechos` (todas), aparte. Fix auditoría 12-ago.
      done=_wcClosed.done; hechos=_wcAll.done; oppsCycle=_wcC.opps; oppsSoFar=_wcClosed.opps;
    }
    // PILAR (Cimientos) = % del CICLO construido (4 semanas / 28 días), NO % de lo que ya ha pasado.
    // Un pilar solo llega a 100% cuando TODO su objetivo del ciclo está hecho (Vanessa 14-ago: "son 4
    // semanas, 75% sería haber hecho el 100% de las 3 primeras"). Al día 7 todo sale bajo — es lo
    // correcto, el fundamento se construye a lo largo del ciclo. done = repeticiones reales (hechos
    // para weekly_count); denominador = objetivo del ciclo (total). pillarOpps se asigna abajo (=total).
    const pillarDone=(hechos!=null?hechos:done);
    // Fallback legacy: si el cálculo da 0 pero hay respuestas, usar mc.length.
    const total=oppsCycle||mc.length||0;
    // DENOMINADOR del % = oportunidades hasta hoy (pasadas + hoy-si-respondido). done/oppsSoFar.
    const denomForPct=oppsSoFar||0;
    const cat=getCat(m);
    // is_commitment: MISMA heurística que el bot (bot.py::is_commitment) para que micros% y
    // compromisos% cuadren en ambos lados. Antes el dashboard solo miraba 2 verbos por 'includes'
    // y el bot 6 por 'startsWith' → un "Contactar a un mentor" sin flag salía compromiso en el bot
    // y micro en el dashboard, descuadrando AMBOS porcentajes. Unificado (auditoría 8-ago, FALLO 3).
    const _t=(m.title||"").toLowerCase();
    const _cat=(m.category||m.tag||"").toLowerCase();
    const _cverbs=["documentar","documentaré","agendar","agendaré","contactar","contactaré","enviar","enviaré","presentar","presentaré","publicar","publicaré"];
    const isCom=meta.is_commitment===true||_cat.includes("compromiso")||_cat.includes("skin")||_cverbs.some(v=>_t.startsWith(v));
    const dl=meta.deadline?Math.ceil((new Date(meta.deadline)-Date.now())/86400000):null;
    // Modelo nuevo (pattern + campos específicos). Fallback a schedules legacy.
    const pattern=meta.pattern||null;
    const day_types=Array.isArray(meta.day_types)?meta.day_types:null;
    const dows=Array.isArray(meta.dows)?meta.dows:null;
    const weekly_target=meta.weekly_target||null;
    const interval_days=meta.interval_days||null;
    const schedules=meta.schedules||null;  // legacy fallback para DTg
    // Times: prioridad al modelo nuevo (meta.times), luego sumar todas las horas activas de schedules
    let allTimes=Array.isArray(meta.times)?[...meta.times]:[];
    if(!allTimes.length&&schedules&&typeof schedules==="object"){
      const seen=new Set();
      Object.values(schedules).forEach(s=>{
        if(s&&s.active&&Array.isArray(s.times)){
          s.times.forEach(t=>{if(!seen.has(t)){seen.add(t);allTimes.push(t);}});
        }
      });
    }
    const times_by_type=(meta.times_by_type&&typeof meta.times_by_type==="object"&&!Array.isArray(meta.times_by_type))?meta.times_by_type:null;
    const momento=typeof meta.momento==="string"?meta.momento:null;
    // "Dos modos" (docs/VACACIONES-Y-LIBRES.md): acción alternativa del MISMO micro para
    // vacaciones/libre. Se muestra como línea "🏖 En vacaciones: <acción>" en la card.
    const variants=(meta.variants&&typeof meta.variants==="object"&&!Array.isArray(meta.variants))?meta.variants:null;
    // Compromiso "cada semana" (weekly_dow): el total visible = ocurrencias de su día en el ciclo,
    // EXCLUYENDO días especiales (día tuyo sin avisos → esa semana se descuenta). El día 13 (ruptura)
    // SÍ cuenta pero como FREEBIE (no penaliza — igual que los micros diarios en día 13). Así el
    // sábado (que caía en día 13) sale 4/4 posible, no 0/3. Coherencia con lo que ve el user.
    let totalVis=total;
    if(isCom&&pattern==="weekly_dow"&&Array.isArray(dows)&&dows.length>=1){
      const _scd=parseInt(meta.start_cycle_day,10)||1;
      let _cnt=0;
      for(let day=_scd;day<=CYCLE_LEN;day++){
        if(!dows.includes(_dowOf(day))) continue;
        if(day===13) continue;           // día 13 = ruptura → NO cuenta (igual que el bot)
        if(_downByDay.has(day)) continue;                     // día caído del bot → se descuenta
        if((_dtByDay[day]||"workday")==="special") continue;  // especial → se descuenta
        _cnt++;
      }
      // total = ocurrencias del día del compromiso, excluyendo día 13 y special. Coincide con el bot
      // (_opps_for_micro_range también excluye día 13). Sin freebie: evita los 3 números distintos
      // (67/75/100%) que veía el auditor. Un sábado cuyo día 13 caía en sábado sale /3, no /4.
      totalVis=Math.max(1,_cnt);
    }
    return{...m,meta,done,hechos:hechos??done,total:totalVis,answered:mc.length,oppsSoFar:denomForPct,pillarDone,pillarOpps:totalVis,pastOpps:denomForPct,pct:denomForPct?Math.min(100,Math.round(done/denomForPct*100)):0,cat,isCom,dl,isSituational,times:allTimes,times_by_type,momento,schedules,pattern,day_types,dows,weekly_target,interval_days,variants,desc:m.description||meta.desc||""};
  });
  const comps=parsed.filter(m=>m.isCom);
  const mcs=parsed.filter(m=>!m.isCom);
  // Para mostrar la hora del turno correcto en micros con momento (turnos rotativos). Vanessa 10-ago.
  const _daySched=_pjb(snapshot?.day_schedules)||null;
  const _hasShifts=(calendar||[]).some(d=>String(d.day_type||"").startsWith("work_"));
  // Horarios por TURNO (mañana/tarde/noche) cuando el user rota — check-in y despertar cambian según
  // el turno del día. Si solo hay 1 turno con hora, la hora fija basta (devuelve null → fallback).
  const _turnoTimes=(kind)=>{
    if(!_hasShifts||!_daySched) return null;
    const lbl={am:"mañana",pm:"tarde",nt:"noche"};
    const parts=[];
    for(const p of ["am","pm","nt"]){
      const v=_daySched[`${p}_${kind}`];
      if(v&&String(v).includes(":")) parts.push(`${lbl[p]} ${String(v).slice(0,5)}`);
    }
    return parts.length>=2?parts.join(" · "):null;
  };

  // Sumamos sobre el parsed (ya deduplicado y filtrado por cycle_day<=cd). Cap a 100 por
  // seguridad — si el denominador inferido descuadra con el real, no queremos 106%.
  // Excluir situational del % resumen: son opt-in (done==total siempre) e inflarían el
  // porcentaje. La tabla ya los excluye (_aggregateInRange); aquí también, para que cuadren.
  const mcsReal=mcs.filter(m=>!m.isSituational);
  // Denominador = oportunidades hasta hoy (m.oppsSoFar = días pasados + hoy-si-respondido).
  const microsDone=mcsReal.reduce((s,m)=>s+m.done,0),microsTotal=mcsReal.reduce((s,m)=>s+(m.oppsSoFar||0),0);
  const microsPct=microsTotal?Math.min(100,Math.round(microsDone/microsTotal*100)):0;
  const compsDone=comps.reduce((s,m)=>s+m.done,0),compsTotal=comps.reduce((s,m)=>s+m.total,0);
  const compsPct=compsTotal?Math.min(100,Math.round(compsDone/compsTotal*100)):0;
  const totalDone=microsDone+compsDone,totalAll=(microsTotal+compsTotal)||1;
  const pctG=Math.min(100,Math.round(totalDone/totalAll*100));
  const cEvents=events.filter(e=>e.event_name==="checkin_complete");
  const ciDays=new Set(cEvents.map(e=>(e.event_data||{}).cycle_day).filter(Boolean)).size;

  // D4: el bot graba `micro_index` (numérico). Antes leíamos solo `micro_idx` (typo)
  // y caíamos al fallback de `micro_title` siempre. Ahora aceptamos ambos nombres y
  // poblamos doble índice (numérico + título) para que el lookup downstream encuentre
  // sea por sort_order o por title.
  const benByIdx={};
  events.filter(e=>e.event_name==="micro_benefit").forEach(e=>{
    const d=e.event_data||{};
    const idx=d.micro_index!=null?d.micro_index:(d.micro_idx!=null?d.micro_idx:null);
    const title=d.micro_title||"";
    const b=d.benefit||d.label||"";
    if(!b)return;
    const keys=[];
    if(idx!=null)keys.push(String(idx));
    if(title)keys.push(title);
    keys.forEach(k=>{
      if(!benByIdx[k])benByIdx[k]={};
      benByIdx[k][b]=(benByIdx[k][b]||0)+1;
    });
  });

  // Migración 7-jun-2026: cycle_calendar.day_type guarda "dayoff" directamente
  // (sin underscore). Antes existía un parche de normalización aquí que sobraba
  // tras el UPDATE SQL + cambio en db.py de cómo se persisten los nuevos rows.
  const calDays=[...calendar].sort((a,b)=>a.cycle_day-b.cycle_day);
  const ciByDay={};cEvents.forEach(e=>{const d=(e.event_data||{}).cycle_day;if(d)ciByDay[d]=true;});
  // Mood por día del ciclo — para el calendario coloreado por energía
  const moodByDay={};cEvents.forEach(e=>{const d=(e.event_data||{}).cycle_day;const m=(e.event_data||{}).mood;if(d&&m)moodByDay[d]=m;});
  const delivered=events.filter(e=>e.event_name==="resource_delivered");

  const logout=async()=>{await supabase.auth.signOut();setUser(null);setData(null);};

  const cycleNum=cycle?.cycle_number||1;
  const phase=phaseFor(cycleNum);
  const nameClean=(name||"").replace(/\s+/g,"");
  // CycleArc selection: si seleccionas un ciclo distinto al activo, las secciones
  // de abajo muestran teasers vacíos en lugar del contenido del activo.
  const viewingActive=(arcSelected||cycleNum)===cycleNum;
  const viewingPhase=CYCLE_PHASES[((arcSelected||cycleNum)-1)%4]||CYCLE_PHASES[0];

  // Resúmenes para los headers cuando una sección está cerrada.
  const objSummary=obj?`"${obj.length>50?obj.slice(0,49)+"…":obj}"`:"";
  const microsSummary=`${mcs.length} micros · ${microsPct}% cumplimiento`;
  const compsSummary=comps.length>0?`${comps.length} compromiso${comps.length>1?"s":""} · ${compsPct}% cumplimiento`:"";
  const cimSummary=pillars_map?.pillars?.length?`${pillars_map.pillars.length} pilares`:"";
  const progSummary=`${pctG}% · racha ${streak} · ${ciDays}/${cd} check-ins`;
  const semSummary=`Semana ${wk} de 4`;

  return(<SecCtx.Provider value={{forceCounter:secForce.counter,forceMode:secForce.mode}}><div style={{background:T.bg,minHeight:"100vh",color:T.crema,fontFamily:T.font}}>
    <div style={{padding:"14px 20px",borderBottom:`1px solid ${T.gb}`,display:"flex",justifyContent:"space-between",alignItems:"center",position:"sticky",top:0,background:T.bg,zIndex:10}}>
      <div style={{display:"flex",alignItems:"center",gap:9}}>
        <img src="/antifragil-symbol.svg" alt="Antifrágil Society" style={{height:26,width:"auto",display:"block"}}/>
        <span style={{fontSize:13,letterSpacing:2.5,color:T.oro,fontWeight:400}}>ANTIFRÁGIL <span style={{opacity:.7,letterSpacing:3}}>SOCIETY</span></span>
      </div>
      <div style={{display:"flex",alignItems:"center",gap:10}}>
        <span style={{fontSize:13,color:T.grisL}}>{name}</span>
        <button onClick={logout} style={{background:"none",border:`1px solid ${T.gb}`,borderRadius:6,color:T.grisL,fontSize:10,padding:"3px 10px",cursor:"pointer",fontFamily:T.font}}>Salir</button>
      </div>
    </div>

    <div style={{maxWidth:460,margin:"0 auto",padding:"28px 16px"}}>

      {/* 0. PORTADA — nombre + hashtag */}
      <div style={{textAlign:"center",marginBottom:24,paddingTop:8}}>
        <h1 style={{fontFamily:T.serif,fontSize:"clamp(2.4rem,7vw,3rem)",color:T.crema,fontWeight:400,letterSpacing:1,marginBottom:6,lineHeight:1}}>
          {name}
        </h1>
        <p style={{fontSize:11,color:T.oro,letterSpacing:2,fontWeight:500}}>#{nameClean}Antifragil</p>
      </div>

      {/* 1. TU ARCO — vista zoom-out de 4 ciclos × 28 días. Pulsar pill cambia lo que se ve abajo. */}
      <CycleArc cycleNum={cycleNum} selected={arcSelected} onSelect={setArcSelected}/>

      {/* HERO PANEL — solo se muestra cuando estás viendo el ciclo activo. Para ciclos
          no activos (selección en CycleArc), el resto del dashboard incluido el hero
          se oculta y se muestra el CycleTeaser. */}
      {viewingActive&&<HeroPanel
        name={name}
        obj={obj}
        pillars={pillars_map?.pillars||[]}
        countdown={pillars_map?.countdown}
        micros={mcs}
        comps={comps}
        cd={cd}
        wk={wk}
        cdReal={cdReal}
        isPreCycle={isPreCycle}
        isPostCycle={isPostCycle}
        startDate={cycle?.start_date}
        events={events}
        weekly={weekly}
        calDays={calDays}
        checkins={checkins}
        sd={sd}
      />}

      {/* HACIA EL CICLO 2 — solo cuando el ciclo está cerrado. Surface hints
          basadas en los datos reales del Ciclo 1: lo que se integró se amplifica,
          lo que se resistió se enfrenta, lo del pilar fuerte se materializa.
          Es la transición visible Ciclo 1 (Resistir) → Ciclo 2 (Integrar). */}
      {viewingActive&&isPostCycle&&<HaciaCiclo2 micros={mcs} comps={comps} pillarsMap={pillars_map} events={events}/>}

      {/* Botón global para desplegar/replegar todo el dashboard de una vez */}
      <div style={{display:"flex",justifyContent:"flex-end",marginBottom:14}}>
        <button onClick={toggleAllSections} style={{background:"none",border:`1px solid ${T.gb}`,borderRadius:8,color:T.grisL,fontSize:10,padding:"6px 14px",cursor:"pointer",fontFamily:T.font,letterSpacing:1.5,textTransform:"uppercase"}}>
          {secForce.allOpen?"Replegar todo":"Desplegar todo"}
        </button>
      </div>

      <Div/>

      {!viewingActive ? (
        <CycleTeaser num={arcSelected||cycleNum} phase={viewingPhase} isPast={(arcSelected||cycleNum)<cycleNum}/>
      ) : (<>

      {/* ==================== RETO · CON TUS PROPIAS PALABRAS ==================== */}
      <BlockHeader title="Reto" subtitle="Con tus propias palabras" />

      {/* MI OBJETIVO */}
      <Sec title="Mi objetivo" collapsible defaultOpen={false} summary={objSummary}>
        <Card gold>
          <p style={{fontSize:15,fontFamily:T.serif,fontStyle:"italic",lineHeight:1.6,color:T.crema}}>"{obj}"</p>
        </Card>
      </Sec>

      {/* MI VISIÓN — el board del onboarding como sección propia. Siempre visible:
          si el board está vacío (snapshot incompleto o sin board), muestra placeholder
          en lugar de ocultarse — el user no debe perder la sección por un dato faltante. */}
      <Sec title="Mi visión" collapsible defaultOpen={false} summary={board.length>0?`${board.length} pasos al objetivo`:"sin datos"}>
        {board.length>0?<Card>
          {board.map((b,i)=><div key={i} style={{display:"flex",gap:14,padding:"8px 0",borderBottom:i<board.length-1?`1px solid ${T.gb}`:"none"}}>
            <span style={{color:T.oro,fontFamily:T.serif,fontSize:18,lineHeight:"24px",minWidth:24}}>{String(i+1).padStart(2,"0")}</span>
            <p style={{fontSize:13,fontWeight:400,color:T.crema,lineHeight:1.5}}>{typeof b==="string"?b:b.title||b.text||""}</p>
          </div>)}
        </Card>:<Card><p style={{fontSize:11,color:T.grisL,fontStyle:"italic",lineHeight:1.5}}>No se generó tu visión en el onboarding. Cuando completes uno nuevo, aquí verás los pasos a tu objetivo.</p></Card>}
      </Sec>

      {/* QUIÉN SOY — radares + resumen narrativo + patrón */}
      <Sec title="Quién soy" collapsible defaultOpen={false} summary="Personalidad · vital · patrón">
        <div style={{display:"flex",gap:8}}>
          <div style={{flex:1,textAlign:"center"}}><p style={{fontSize:10,color:T.grisL,letterSpacing:2,textTransform:"uppercase",marginBottom:2}}>Cómo eres</p><Radar scores={os} dims={P_DIMS} size={140}/></div>
          <div style={{flex:1,textAlign:"center"}}><p style={{fontSize:10,color:T.grisL,letterSpacing:2,textTransform:"uppercase",marginBottom:2}}>Cómo vives</p><Radar scores={vs} dims={V_DIMS} size={140} color={T.lima}/></div>
        </div>
        {/* Resumen narrativo derivado del OCEAN + Vital + patrón */}
        <Card style={{marginTop:14}}>
          <IdentityNarrative os={os} vs={vs} pat={pat}/>
        </Card>
        {/* Sprint v2: LO QUE ESCRIBÍ AL EMPEZAR — datos crudos del user al inicio del onboarding.
            vital_moment (chip + frase libre), memoria_patron (textarea 250), imagen_futuro
            (textarea 250). Material crudo en sus propias palabras. La Opinión Antifrágil al
            final del dashboard cita estos textos LITERAL en su narrative — aquí los muestra
            como referencia identitaria fija (no evolucionan durante el ciclo). */}
        <OnboardingTextosCard events={events}/>
        {/* Las narrativas del LLM (early_reading + final_reading + opinion RAG) viven juntas
            en "Opinión Antifrágil" del bloque RESULTADO — son 3 lecturas en momentos
            distintos del ciclo y se confrontan. Aquí en "Quién soy" solo lo estructurado. */}
      </Sec>

      {/* MI CALENDARIO — el calendario configurado en el onboarding (28 días, día actual destacado).
          Permite al user revisar cómo se distribuyen sus días tipo en el ciclo. */}
      <Sec title="Mi calendario" collapsible defaultOpen={false} summary={(()=>{
        const types=new Set(calDays.map(d=>d.day_type));
        const counts={};calDays.forEach(d=>{counts[d.day_type]=(counts[d.day_type]||0)+1;});
        const top=Object.entries(counts).sort((a,b)=>b[1]-a[1]).slice(0,2);
        return top.length?top.map(([t,c])=>`${c} ${({workday:"laboral",dayoff:"libre",vacation:"vacaciones",special:"especial",work_am:"mañana",work_pm:"tarde",work_night:"noche"})[t]||t}`).join(" · "):`${calDays.length} días`;
      })()}>
        <UserCalendarView calDays={calDays} cd={cd} daySchedules={snapshot?.day_schedules}/>
      </Sec>

      {/* ==================== PROCESO · ERES LO QUE HACES, NO LO QUE DICES ==================== */}
      <BlockHeader title="Proceso" subtitle="Eres lo que haces, no lo que dices" />

      {/* COMPROMISOS */}
      {comps.length>0&&<Sec title="Compromisos" collapsible defaultOpen={false} summary={compsSummary}>
        {comps.map(m=><MC key={m.id} m={m} bens={benByIdx} dl daySched={_daySched} calDays={calendar} cd={cd} cycleStart={cycle?.start_date} hasShifts={_hasShifts}/>)}
        <CalendarExport comps={comps} mcs={mcs} cycleStart={cycle?.start_date}/>
      </Sec>}

      {/* MICRO-CAMBIOS */}
      <Sec title="Mis micro-cambios" collapsible defaultOpen={false} summary={microsSummary}>
        {mcs.map(m=><MC key={m.id} m={m} bens={benByIdx} daySched={_daySched} calDays={calendar} cd={cd} cycleStart={cycle?.start_date} hasShifts={_hasShifts}/>)}
      </Sec>

      {/* MI ESPACIO — diario abierto + recursos. Summary dinámico con counts cuando hay.
          id="mi-espacio" para que /diario del bot (magic link con #mi-espacio) abra
          esta seccion automaticamente y haga scroll al aterrizar. */}
      <Sec title="Mi espacio" id="mi-espacio" collapsible defaultOpen={false} summary={(()=>{
        const dEv=(events||[]).find(e=>e.event_name==="user_note"&&(e.event_data||{}).cycle_id===cycle?.id);
        const ded=dEv?.event_data||{};
        // Semanas con contenido (diario por semanas) + fallback al blob legacy.
        const wks=ded.weeks||{};
        const semanas=Object.values(wks).filter(t=>(t||"").trim()).length;
        const legacy=((ded.text||"").trim()?1:0);
        const apuntes=semanas||legacy;
        const chat=(events||[]).filter(e=>e.event_name==="diary_entry"&&(e.event_data||{}).cycle_id===cycle?.id).length;
        const recs=delivered.length;
        const parts=[];
        if(semanas)parts.push(`${semanas} semana${semanas>1?"s":""} escrita${semanas>1?"s":""}`);
        else if(legacy)parts.push("1 apunte");
        if(chat)parts.push(`${chat} nota${chat>1?"s":""} por chat`);
        if(recs)parts.push(`${recs} recurso${recs>1?"s":""}`);
        return parts.length?parts.join(" · "):"Diario · recursos";
      })()}>
        <CycleDiary userId={profile?.id} cycleId={cycle?.id} wk={wk} initialEvent={(events||[]).find(e=>e.event_name==="user_note"&&(e.event_data||{}).cycle_id===cycle?.id)} chatEntries={(events||[]).filter(e=>e.event_name==="diary_entry"&&(e.event_data||{}).cycle_id===cycle?.id)}/>
        <p style={{fontSize:11,color:T.grisL,letterSpacing:2,textTransform:"uppercase",margin:"18px 0 10px"}}>Recursos del ciclo</p>
        <Card>
          {[{i:"🎵",n:"Canción",d:3,t:"music"},{i:"🎬",n:"Vídeo",d:7,t:"video"},{i:"📖",n:"Libro",d:15,t:"book"},{i:"🏆",n:"Tu tarjeta",d:28,t:"card"}].filter(r=>r.d<=cd).map((r,idx,arr)=>{
            const ev=delivered.find(e=>(e.event_data||{}).type===r.t);
            const got=Boolean(ev);
            const url=(ev?.event_data||{}).url||(ev?.event_data||{}).link||null;
            const inner=(<>
              <span style={{fontSize:18,width:28,textAlign:"center"}}>{r.i}</span>
              <div style={{flex:1}}>
                <p style={{fontSize:12,color:T.crema}}>{r.n} — Día {r.d}</p>
                {got&&url&&<p style={{fontSize:10,color:T.oro,marginTop:2,letterSpacing:0.5}}>Abrir →</p>}
              </div>
              <span style={{fontSize:10,color:got?T.lima:T.grisL,fontWeight:500,letterSpacing:1}}>{got?"RECIBIDO":`DÍA ${r.d}`}</span>
            </>);
            const rowStyle={display:"flex",alignItems:"center",gap:10,padding:"9px 0",borderBottom:idx<arr.length-1?`1px solid ${T.gb}`:"none"};
            if(url)return<a key={idx} href={url} target="_blank" rel="noopener noreferrer" style={{...rowStyle,textDecoration:"none",color:"inherit"}}>{inner}</a>;
            return<div key={idx} style={rowStyle}>{inner}</div>;
          })}
        </Card>
      </Sec>

      {/* ==================== RESULTADO · CONSTRUYENDO ANTIFRAGILIDAD ==================== */}
      <BlockHeader title="Resultado" subtitle="Construyendo antifragilidad" />

      {/* MIS CIMIENTOS — pilares del board agregados sobre TODO el ciclo (no por semana) */}
      <Sec title="Mis cimientos" collapsible defaultOpen={false} summary={cimSummary}>
        <Cimientos
          pillars={pillars_map?.pillars||[]}
          countdown={pillars_map?.countdown}
          objetivo={obj}
          micros={mcs}
          comps={comps}
          message={cimientos_message}
          cd={cd}
          events={events}
        />
      </Sec>

      {/* SEMANAS — zoom-in. Solo se renderizan semanas vividas (w <= wk): la actual + cerradas.
          Las futuras NO aparecen — se "abren" cuando llega su turno. */}
      <Sec title="Mis semanas" sub={`Ciclo ${cycleNum} · ${phase?.n||"Arrancar"}`} collapsible defaultOpen={false} summary={semSummary}>
        <WeeksBlock cycleNum={cycleNum} cd={cd} wk={wk} weekly={weekly} events={events} phase={phase} cycleStart={cycle?.start_date} cycleId={cycle?.id} mcs={mcs} calDays={calDays} checkins={checkins} sd={sd}/>
      </Sec>

      {/* PROGRESO — síntesis cuantitativa del ciclo. Tabla maestra (S1-S4 + Acumulada + Ciclo)
          + calendario coloreado + patrón de energía + peros categorizados. Recurso para Ciclo 2. */}
      <Sec title={`Mi progreso · día ${cdDisplay}/28`} collapsible defaultOpen={false} summary={progSummary}>
        {/* Tabla maestra del ciclo */}
        <ProgressTable wk={wk} cd={cd} weekly={weekly} events={events} mcs={mcs} comps={comps} calDays={calDays} checkins={checkins} sd={sd}/>
        {/* Calendario con emoji de energía por día (de checkin_complete events) */}
        <Card style={{marginTop:14}}><Cal calDays={calDays} cd={cd} ciByDay={ciByDay} moodByDay={moodByDay}/></Card>
        {/* Evolución de los micros — sustituye al antiguo "Patrón de energía" */}
        <Card style={{marginTop:12}}>
          <p style={{fontSize:10,color:T.oro,letterSpacing:2,textTransform:"uppercase",marginBottom:6}}>Evolución de los micros</p>
          <p style={{fontSize:11,color:T.grisL,marginBottom:12,lineHeight:1.45}}>% de micros que cumpliste cada día del ciclo.</p>
          <MicrosEvolution checkins={checkins} mcs={mcs} cd={cd} cycleStart={cycle?.start_date} calDays={calDays} sd={sd}/>
        </Card>
        {/* Beneficios agregados del ciclo */}
        <CycleBenefits events={events}/>
        {/* Energía: lo que te dio + lo que te quitó */}
        <CycleEnergyPlus events={events}/>
        <CycleEnergyMinus events={events}/>
      </Sec>

      {/* ==================== TU LECTURA · CIERRE DEL DASHBOARD ====================
          Va al final, después de los 3 bloques (RETO/PROCESO/RESULTADO) para no manchar
          la columna del producto. Accesible también desde el banner del Hero (scroll suave
          hasta aquí). Agrupa las 3 lecturas LLM del ciclo: early_reading (pre-paywall) +
          final_reading (baseline del ciclo) + antifragil_opinion (RAG cierre semanal/ciclo).
          User-facing renombrado a "Tu lectura" (13-may-2026) — el nombre interno del evento
          sigue siendo `antifragil_opinion` (no rompe nada). "Opinión Antifrágil" queda como
          naming interno para storytelling externo (pitch/whitepaper/OPERATIVA.md). */}
      <div id="antifragil-opinion" style={{scrollMarginTop:80}}>
        <Sec title="Tu lectura" defaultOpen={true} summary={(()=>{
          const fr=(events||[]).find(e=>e.event_name==="final_reading");
          // Solo la lectura de CIERRE (week>=4) cuenta aquí — las semanales viven en Mis semanas.
          const rag=(events||[]).find(e=>e.event_name==="antifragil_opinion"&&((e.event_data||{}).week_number||0)>=4);
          if(rag) return "Actualizada con tus datos · cierre";
          if(fr) return "Baseline del ciclo · sin cierre aún";
          return "Aún sin lectura";
        })()}>
          <AntifragilOpinion events={events} cycleId={cycle?.id}/>
        </Sec>
      </div>

      {/* ==================== CÓMO FUNCIONA · MANUAL DE USO ====================
          Card al final con las reglas del juego del ciclo. Mismo contenido que el comando
          /instrucciones del bot. No menciona día 13 (sorpresa) ni "Opinión Antifrágil"
          como naming (es "Tu lectura" user-facing). */}
      <ComoFuncionaCard/>

      </>)}

      <Div/>

      {/* 10. CUENTA — colapsable, cerrada por default (rara vez se abre) */}
      <Sec title="Mi cuenta" collapsible defaultOpen={false} summary={user?.email||""}>
        <Card>
          <AR l="Check-in" v={_turnoTimes("checkin")||snapshot?.daily_checkin_time?.slice(0,5)||snapshot?.time_slot_evening?.slice(0,5)||"22:00"}/>
          <AR l="Morning" v={_turnoTimes("wake")||snapshot?.time_slot_morning?.slice(0,5)||"07:00"}/>
          <AR l="Email" v={user?.email||""} m/>
          <AR l="Bot" v="t.me/Antifragil_society_bot" lk last/>
        </Card>
      </Sec>
      <div style={{height:40}}/>
    </div>
  </div></SecCtx.Provider>);
}

function MC({m,bens,dl,daySched,calDays,cd,cycleStart,hasShifts}){
  const[open,setOpen]=useState(false);
  // Compromisos (cuando dl=true): el color depende del deadline + cumplimiento.
  //   - dl pendiente (m.dl > 0): neutro/oro, "Pendiente · Xd".
  //   - dl hoy o vencido (m.dl <= 0): verde si done > 0, rojo si done = 0.
  // Micros normales: por % done como antes.
  let col,st;
  if(dl){
    if(m.dl===null||m.dl===undefined){col=T.gb;st="Sin fecha";}
    else if(m.dl>0){col=m.dl<=3?T.coral:T.oro;st=`Pendiente · ${m.dl}d`;}
    else{col=m.done>0?T.verde:T.rojo;st=m.done>0?"Cumplido":"Vencido";}
  }else if(m.isSituational){
    // Situational / weekly_count ("cuando surja"): sin target de hora. Si hay ejecuciones,
    // oro suave; si no, gris "Cuando surja" (antes "Disponible", confuso). Nunca fricción.
    col=m.done>0?T.oro:T.gb;
    st=m.done>0?"Activo":"Cuando surja";
  }else if(!m.oppsSoFar){
    // oppsSoFar=0 → aún no hay ningún día PASADO que juzgar (día 1 sin cerrar, o el micro aún no
    // ha tocado). Neutro, no fricción. En cuanto pasa un día que aplicaba → cuenta (marcado o no).
    col=T.gb; st="Aún sin datos";
  }else{
    col=m.pct>=70?T.verde:m.pct>=40?T.oro:T.rojo;
    st=m.pct>=70?"Integrado":m.pct>=40?"En proceso":"Fricción";
  }
  const days=m.day_type||m.meta?.days||"all";
  const bl=Object.entries(bens[m.title]||bens[String(m.sort_order||0)]||{}).sort((a,b)=>b[1]-a[1]);
  // Borde lateral coloreado: para compromisos refleja el estado de deadline,
  // para micros refleja el ratio. Si total=0 y no es compromiso, gris (no dramatizar).
  const borderColor=dl?col:(m.total>0||m.isSituational?col:T.gb);
  return<Card style={{marginBottom:10,borderLeft:`3px solid ${borderColor}`,paddingLeft:13}}>
    <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
      <div style={{flex:1}}>
        <p style={{fontSize:13,fontWeight:500,lineHeight:1.3}}>{m.icon||""} {m.title}</p>
        <div style={{display:"flex",gap:4,alignItems:"center",flexWrap:"wrap",marginTop:5}}>
          <Tg label={m.cat.l} color={m.cat.c}/><DTg pattern={m.pattern} day_types={m.day_types} dows={m.dows} weekly_target={m.weekly_target} interval_days={m.interval_days} days={days} schedules={m.schedules} times={m.times} radarHour={m.pattern==="situational"&&daySched?_radarHour(daySched,_microApplyDayType(m,cd,calDays,cycleStart)):null}/>
          {/* Hora visible solo para patterns con hora fija (no situational/weekly_count/monthly) */}
          {(()=>{const _skip=m.pattern==="situational"||m.pattern==="weekly_count"||m.pattern==="monthly";if(_skip)return null;
            // Si el micro tiene MOMENTO y hay day_schedules, mostrar la hora REAL del turno de hoy
            // (calculada como el bot), no la fija. Para turnos rotativos. Vanessa 10-ago.
            const _mh=m.momento&&daySched?_momentoHour(m.momento,daySched,_microApplyDayType(m,cd,calDays,cycleStart)):null;
            if(_mh) return <span style={{fontSize:10,color:T.grisL}}>{_mh}{hasShifts?<span style={{color:T.gris}}> · se ajusta a tu turno</span>:null}</span>;
            return m.times.length>0?<span style={{fontSize:10,color:T.grisL}}>{m.times.join(" · ")}</span>:null;
          })()}
        </div>
        {m.variants&&(m.variants.vacation||m.variants.dayoff)?(()=>{const vv=m.variants.vacation||m.variants.dayoff;return <p style={{fontSize:10,color:T.grisL,marginTop:4,fontStyle:"italic"}}>🏖 En vacaciones: {vv.titulo||vv.title}</p>;})():null}
      </div>
      <div style={{textAlign:"right",minWidth:50}}>
        {/* Situational: "X hechos". Resto: done / META DEL CICLO (proyección, ej. 0/27 micros,
            0/4 compromisos) — el número muestra la meta; el COLOR refleja el progreso real hasta
            hoy (done/oportunidades-pasadas). Decisión Vanessa 11-ago.
            _numCol: en estado neutro el borde es gris muy oscuro (T.gb) e ilegible como texto →
            usamos un gris CLARO (T.grisL). Con estado real (verde/oro/rojo) se mantiene el color. */}
        <p style={{fontSize:16,fontWeight:500,color:col===T.gb?T.grisL:col}}>{m.isSituational?`${m.hechos??m.done} hechos`:`${m.done}/${m.total}`}</p>
        <p style={{fontSize:9,color:col===T.gb?T.grisL:col}}>{st}</p>
      </div>
    </div>
    {dl&&m.dl!==null&&<div style={{marginTop:8,padding:"6px 10px",background:"rgba(192,57,43,0.08)",borderRadius:6,display:"flex",justifyContent:"space-between"}}>
      <span style={{fontSize:11,color:T.rojo}}>Fecha límite</span>
      <span style={{fontSize:13,fontWeight:500,color:T.rojo}}>Faltan {Math.max(0,m.dl)} días</span>
    </div>}
    <button onClick={()=>setOpen(!open)} style={{background:"none",border:"none",color:T.oro,fontSize:10,cursor:"pointer",padding:"4px 0",marginTop:6,fontFamily:T.font}}>{open?"cerrar":"ver más"}</button>
    {open&&<>
      {m.desc&&<p style={{fontSize:11,color:T.grisL,lineHeight:1.6,marginTop:6,padding:"10px 12px",background:"rgba(255,255,255,0.02)",borderRadius:8}}>{m.desc}</p>}
      {/* Bloque "cuándo aplica" — una línea por pattern (no tabla por tipo de día). */}
      <div style={{marginTop:8,padding:"10px 12px",background:"rgba(255,255,255,0.02)",borderRadius:8}}>
        <p style={{fontSize:9,letterSpacing:1,textTransform:"uppercase",color:T.grisL,marginBottom:6}}>Cuándo aplica</p>
        {(() => {
          const p=m.pattern;
          const t=m.times||[];
          const DLBL={1:"lunes",2:"martes",3:"miércoles",4:"jueves",5:"viernes",6:"sábado",7:"domingo"};
          // Momento (horas relativas al ritmo): el bot calcula la hora real cada día según tu horario.
          if(m.momento){
            const ML={al_despertar:"al despertar",antes_trabajo:"antes de trabajar",en_trabajo:"durante el trabajo",salir_trabajo:"al salir del trabajo",antes_dormir:"antes de dormir",libre:"en tu tiempo libre"};
            const dws=Array.isArray(m.dows)?m.dows:null;
            const diaPre=p==="weekly_dow"&&dws?dws.map(d=>DLBL[d]||"?").join(" y ")+" · ":"";
            return <p style={{fontSize:12,color:T.crema,lineHeight:1.5}}>🕐 {diaPre}{ML[m.momento]||m.momento} — el sistema pone la hora según tu horario de cada día (turno, libre…).</p>;
          }
          // Horas por turno (usuarios con turnos): una línea por tipo de día con su hora real.
          if(m.times_by_type&&Object.keys(m.times_by_type).length&&(p==="daily"||p==="weekly_dow"||p==="interval")){
            const SLBL={workday:"🏢 Laboral",work_am:"🌅 Turno mañana",work_pm:"☀️ Turno tarde",work_night:"🌙 Turno noche",dayoff:"🛋️ No laborable",vacation:"🏖️ Vacaciones"};
            const dws=Array.isArray(m.dows)?m.dows:null;
            const diaPre=p==="weekly_dow"&&dws?dws.map(d=>DLBL[d]||"?").join(" y "):"";
            return <div>
              {diaPre&&<p style={{fontSize:12,color:T.crema,lineHeight:1.5,marginBottom:6}}>📅 {diaPre[0].toUpperCase()+diaPre.slice(1)}</p>}
              <p style={{fontSize:9,letterSpacing:1,textTransform:"uppercase",color:T.grisL,marginBottom:4}}>Hora por turno</p>
              {Object.entries(m.times_by_type).map(([k,arr])=>(
                <div key={k} style={{display:"flex",justifyContent:"space-between",fontSize:11,padding:"3px 0"}}>
                  <span style={{color:T.grisL}}>{SLBL[k]||k}</span>
                  <span style={{color:T.crema}}>{arr&&arr.length?arr.join(" · ")+"h":"—"}</span>
                </div>
              ))}
            </div>;
          }
          if(p==="situational") return <p style={{fontSize:12,color:T.crema,lineHeight:1.5}}>💭 Sin hora fija. El bot te pregunta cada noche si tuviste oportunidad.</p>;
          if(p==="weekly_count") return <p style={{fontSize:12,color:T.crema,lineHeight:1.5}}>🎯 {m.weekly_target||2} veces/semana — sin día fijo. El bot te pregunta el domingo cuántas veces lo has hecho.</p>;
          if(p==="monthly") return <p style={{fontSize:12,color:T.crema,lineHeight:1.5}}>📆 1 vez al mes (día 1 y 28 del ciclo).</p>;
          if(p==="interval"){
            const tl=t.length?` a las ${t[0]}h`:"";
            return <p style={{fontSize:12,color:T.crema,lineHeight:1.5}}>🔁 Cada {m.interval_days||3} días{tl}.</p>;
          }
          if(p==="weekly_dow"){
            const dws=Array.isArray(m.dows)?m.dows:[5];
            const dia=dws.length===1?DLBL[dws[0]]||"viernes":dws.map(d=>DLBL[d]||"?").join(" y ");
            const tl=t.length?` a las ${t[0]}h`:"";
            return <p style={{fontSize:12,color:T.crema,lineHeight:1.5}}>📅 {dia[0].toUpperCase()+dia.slice(1)}{tl}.</p>;
          }
          if(p==="daily"){
            const dt=m.day_types||[];
            const hasWk=dt.some(x=>x.startsWith("work")||x==="workday");
            const hasOff=dt.includes("dayoff");
            let cuando="todos los días";
            if(hasWk&&!hasOff) cuando="lunes a viernes";
            else if(!hasWk&&hasOff) cuando="fines de semana";
            else if(dt.length>0) cuando=dt.join(", ");
            const tl=t.length>1?t.map(x=>`${x}h`).join(" · "):(t.length?`${t[0]}h`:"sin hora");
            return <p style={{fontSize:12,color:T.crema,lineHeight:1.5}}>🕐 {cuando} · {tl}.</p>;
          }
          // Legacy fallback (sin pattern): pinta la tabla vieja
          if(m.schedules) return [["workday","🏢 Laboral"],["work_am","🌅 Turno mañana"],["work_pm","☀️ Turno tarde"],["work_night","🌙 Turno noche"],["dayoff","🛋️ No laborable"],["vacation","🏖️ Vacaciones"],["special","⭐ Libre"]].map(([k,l])=>{
            const s=m.schedules[k];if(!s) return null;
            return <div key={k} style={{display:"flex",justifyContent:"space-between",fontSize:11,padding:"3px 0",opacity:s.active?1:0.4}}>
              <span>{l}</span>
              <span style={{color:s.active?T.crema:T.grisL}}>{s.active?(s.times&&s.times.length?s.times.join(" · "):"sin hora"):"desactivado"}</span>
            </div>;
          });
          return <p style={{fontSize:12,color:T.grisL}}>—</p>;
        })()}
      </div>
    </>}
    {bl.length>0&&<div style={{marginTop:8,padding:"8px 10px",background:"rgba(201,168,76,0.04)",borderRadius:8}}>
      <p style={{fontSize:9,color:T.oro,letterSpacing:1,textTransform:"uppercase",marginBottom:4}}>Beneficio líquido</p>
      {bl.map(([b,c])=><div key={b} style={{display:"flex",justifyContent:"space-between",fontSize:11,padding:"2px 0",color:T.grisL}}>
        <span>{b}</span><span style={{color:T.oro,fontWeight:500}}>{c}x</span>
      </div>)}
    </div>}
  </Card>;
}

// Helpers compartidos entre WeeksBlock (zoom-in narrativo) y ProgressTable (síntesis cuantitativa).
// Media de mood = UN valor por NOCHE (cycle_day): el último no-nulo del día. Antes promediaba
// TODOS los checkin_complete (hay varios por noche en guardados parciales/reintentos), así que un
// día con low+normal contaba las dos → sesgaba a 1.7 cuando la noche fue normal/normal (2.0). Dedup
// por cycle_day quedándose el mood más reciente del día. (Vanessa 14-ago, mismo criterio que 2/7)
// Emoji del nivel de ánimo medio (redondeado): 1 😶 · 2 😐 · 3 💪 · 4 🔥. Para que "2.0" se lea claro.
const _moodEmoji=avg=>{const r=Math.round(avg||0);return r>=4?"🔥":r===3?"💪":r===2?"😐":r===1?"😶":"";};
const _moodAvg=arr=>{
  const byDay=new Map();
  (arr||[]).forEach(e=>{
    const cd=(e.event_data||{}).cycle_day;
    const sc=MOOD_SCORE[(e.event_data||{}).mood]||0;
    if(cd==null||!sc) return;
    const prev=byDay.get(cd);
    if(!prev||(e.created_at||"")>=prev.ca) byDay.set(cd,{sc,ca:e.created_at||""});
  });
  const ms=[...byDay.values()].map(v=>v.sc);
  return ms.length?+(ms.reduce((s,n)=>s+n,0)/ms.length).toFixed(1):null;
};
const _checkinsForWeek=(events,w)=>(events||[]).filter(e=>{
  if(e.event_name!=="checkin_complete") return false;
  const ecd=(e.event_data||{}).cycle_day;
  return ecd>=((w-1)*7+1)&&ecd<=(w*7);
});
// Noches de check-in CERRADO en un rango cycle_day. Fuente = night_checkin_done (el check-in
// llegó a completarse), NO checkin_complete: este último se escribe también en guardados
// PARCIALES (fricción/mood/energía sueltas) e interacciones abandonadas → inflaba el conteo
// (4 eventos en 2 noches reales → "4/7" cuando fueron 2). Dedup por cycle_day. Usa
// event_data.cycle_day si está; si no lo deriva del created_at contra el inicio del ciclo
// (backfill de eventos viejos). Día 13 excluido aquí — su +1 va aparte vía dia_si. (Vanessa 14-ago)
const _nightsInRange=(events,sd,start,end)=>{
  if(!(sd instanceof Date)) return 0;
  const days=new Set();
  (events||[]).forEach(e=>{
    if(e.event_name!=="night_checkin_done") return;
    let cd=(e.event_data||{}).cycle_day;
    if(cd==null&&e.created_at) cd=Math.floor((new Date(e.created_at)-sd)/86400000)+1;
    if(cd!=null&&cd!==13&&cd>=start&&cd<=end) days.add(cd);
  });
  return days.size;
};
const _daysLivedInWeek=(w,wk,cd)=>{if(w<wk) return 7;if(w===wk) return Math.min(Math.max(1,cd-(w-1)*7),7);return 0;};
// Días "off" en un rango cycle_day [start..end] — días special del calendario y el día
// 13 (ruptura intencional Taleb). El bot no envía micros esos días, así que el dashboard
// los excluye del denominador para no penalizar al user. Equivale a contarlos 100%.
const _offDaysInRange=(calDays,start,end)=>{
  if(!Array.isArray(calDays)) return 0;
  let off=0;
  calDays.forEach(d=>{
    const cd=d.cycle_day;
    if(cd==null||cd<start||cd>end) return;
    // special (día tuyo) · día 13 (ruptura) · bot_down (día caído del bot, marcado por la API):
    // el bot no envió micros → no es culpa del user → fuera del denominador. (equidad, universal)
    if(d.day_type==="special"||cd===13||d.bot_down) off++;
  });
  return off;
};
// Solo días `special` (que el user marcó como "día tuyo, sin sistema"): el bot no envía
// check-in esos días, así que no deben contar como check-in fallido en el denominador.
// (El día 13 se maneja aparte con la lógica "Option II" — dia_si cuenta como su check-in.)
// Clasificación Integrado/Mantenimiento/Fricción — FUENTE ÚNICA (igual que el pie del cierre _cls).
// Micros con agenda (opps>0): por ratio (≥70 int / 40-69 man / <40 fri). Situacionales (opps=0):
// por CUENTA de hechos (≥4 int / ≥1 man / 0 excluido, nunca fricción). Decisión Vanessa A (7-ago).
const _clsMicros=(per)=>{
  // Denominador = oportunidades hasta hoy (días pasados que aplicaban + hoy-si-respondido; el
  // aggregate ya aplica "hoy pendiente"). Un día pasado sin marcar cuenta como no hecho. opps=0 →
  // aún no hay nada que juzgar (neutro, excluido). El ratio = done/opps.
  const valid=(per||[]).filter(x=>x.opps>0);
  const sit=(per||[]).filter(x=>x.opps===0&&x.done>0);
  if(!valid.length&&!sit.length) return {integrados:null,mantenimiento:null,fricciones:null};
  const ratios=valid.map(x=>x.done/x.opps);
  return {
    integrados: ratios.filter(r=>r>=0.7).length + sit.filter(x=>x.done>=4).length,
    mantenimiento: ratios.filter(r=>r>=0.4&&r<0.7).length + sit.filter(x=>x.done>=1&&x.done<4).length,
    fricciones: ratios.filter(r=>r<0.4).length,
  };
};

// Igual que _clsMicros pero devuelve los TÍTULOS por clase. Lo usan los tags de "Mis semanas",
// que DEBEN ser un calco de la tabla de "Mi progreso" (misma clasificación en vivo por ratio).
// Antes esos tags salían de summary_data del bot (wd.integrados/friccion), que mezcla compromisos
// con micros y usa otro método → contradecían la tabla. Bug 8-ago.
const _clsMicrosTitles=(per)=>{
  const out={integrados:[],mantenimiento:[],fricciones:[]};
  (per||[]).forEach(x=>{
    const t=x.m?.title||"";
    if(!t) return;
    if(x.opps>0){
      const r=x.done/x.opps;
      if(r>=0.7) out.integrados.push(t);
      else if(r>=0.4) out.mantenimiento.push(t);
      else out.fricciones.push(t);
    } else if(x.opps===0&&x.done>=4){ out.integrados.push(t); }
    else if(x.opps===0&&x.done>=1){ out.mantenimiento.push(t); }
    // Sin evidencia (answered==0) o (opps==0 && done==0) → excluido: neutro, no fricción.
  });
  return out;
};

const _specialDaysInRange=(calDays,start,end)=>{
  if(!Array.isArray(calDays)) return 0;
  let n=0;
  calDays.forEach(d=>{
    const cd=d.cycle_day;
    if(cd==null||cd<start||cd>end) return;
    if(d.day_type==="special") n++;
  });
  return n;
};
// Done count de daily micros en un rango cycle_day [start..end]. Dedup por (mid, day).
// Necesario para que computeWeekStats(en curso) y computeCycleStats no doble-cuenten:
// `mcs[m].done` suma TODO el ciclo, así que filtrar por rango requiere ir a los checkins crudos.
const _doneInRange=(mcs,checkins,start,end)=>{
  const dailyMids=new Set((mcs||[]).filter(m=>(m.meta?.frequency||"")!=="semanal").map(m=>m.id));
  const seen=new Set();
  let done=0;
  for(const c of (checkins||[])){
    if(!dailyMids.has(c.micro_change_id)) continue;
    if(c.cycle_day==null||c.cycle_day<start||c.cycle_day>end) continue;
    const k=`${c.micro_change_id}|${c.cycle_day}`;
    if(seen.has(k)) continue;
    seen.add(k);
    if(c.completed) done++;
  }
  return{done,dailyCount:dailyMids.size};
};
// Oportunidades de UN micro en [start..end] según su pattern. Excluye día 13 y day_type=special.
// Igual lógica que _opportunitiesUntilCd pero parametrizable por rango → para tabla por-semana.
const _oppsForMicroInRange=(meta,sd,calendar,start,end)=>{
  const pattern=meta.pattern||null;
  const day_types=Array.isArray(meta.day_types)?meta.day_types:null;
  const dows=Array.isArray(meta.dows)?meta.dows:null;
  const interval_days=meta.interval_days||null;
  const weekly_target=meta.weekly_target||null;
  // El micro no tuvo oportunidades antes de nacer (P0 justicia, igual que el bot): un micro
  // introducido el día 14 arranca a contar en su start_cycle_day, no en el día 1.
  const scd=parseInt(meta.start_cycle_day,10)||1;
  start=Math.max(start,scd);
  if(start>end) return 0;
  if(pattern==="weekly_count"&&weekly_target>0){
    const weeksInRange=Math.max(0,Math.ceil((end-start+1)/7));
    return weekly_target*weeksInRange;
  }
  const dtByDay={};(calendar||[]).forEach(d=>{if(d.cycle_day!=null)dtByDay[d.cycle_day]=d.day_type;});
  const _dow=(day)=>((((sd.getDay()+6)%7)+(day-1))%7)+1; // getDay Dom=0 -> Lun=0 como el bot
  let count=0;
  for(let day=start;day<=end;day++){
    if(day===13) continue;
    const dt=dtByDay[day]||"workday";
    if(dt==="special") continue;
    const effDt=dt==="vacation"?"dayoff":dt;
    if(pattern==="daily"){
      // Vanessa (7-jun): daily = todos los días salvo special. day_types informativo
      // pero no filtra. El day===13 y special ya están descartados arriba.
      count++;
    } else if(pattern==="weekly_dow"){
      if(dows&&dows.includes(_dow(day))) count++;
    } else if(pattern==="interval"){
      if(interval_days>0&&(day-1)%interval_days===0) count++;
    } else if(pattern==="monthly"){
      if(day===1||day===28) count++;
    } else if(!pattern){
      const sch=(meta.schedules||{})[effDt]||(meta.schedules||{})[dt];
      if(sch&&sch.active) count++;
    }
  }
  return count;
};
// Done de UN micro en [start..end] (con dedup por día).
const _doneForMicroInRange=(mid,checkins,start,end)=>{
  const seen=new Set();
  let d=0;
  for(const c of (checkins||[])){
    if(c.micro_change_id!==mid) continue;
    if(c.cycle_day==null||c.cycle_day<start||c.cycle_day>end) continue;
    if(seen.has(c.cycle_day)) continue;
    seen.add(c.cycle_day);
    if(c.completed) d++;
  }
  return d;
};
// Nº de check-ins RESPONDIDOS (✅ o ❌) del micro en el rango — dedup por día. Distingue "sin datos"
// (nunca respondió → neutro) de "fricción" (respondió pero cumplió poco). Sin esto, un micro recién
// arrancado (día 1-2, cero check-ins) salía como Fricción roja. El dashboard refleja, no dramatiza.
const _answeredForMicroInRange=(mid,checkins,start,end)=>{
  const seen=new Set();
  for(const c of (checkins||[])){
    if(c.micro_change_id!==mid) continue;
    if(c.cycle_day==null||c.cycle_day<start||c.cycle_day>end) continue;
    seen.add(c.cycle_day);
  }
  return seen.size;
};
// weekly_count "cuando surja · mínimo X": tope por semana (D1-A) + escalar ancla (D2). Espejo del
// _wc_done_opps del bot. Devuelve {done, opps} = Σ min(done_w, target) / Σ target_w (target 0 en
// semanas sin días del ancla). Así cuadra con el cierre.
const _wcDoneOpps=(meta,mid,checkins,calDays,start,end,cdNow)=>{
  const target=parseInt(meta.weekly_target,10)||0;
  if(target<=0) return {done:0,opps:0};
  const anchor=new Set(meta.day_types||["workday","dayoff"]);
  const dtByDay={};(calDays||[]).forEach(dd=>{if(dd.cycle_day!=null)dtByDay[dd.cycle_day]=dd.day_type;});
  const anchorOk=(cd)=>{if(cd===13)return false;const dt=dtByDay[cd]||"workday";if(dt==="special")return false;if(anchor.has(dt))return true;if(dt==="vacation"&&anchor.has("dayoff"))return true;if(String(dt).startsWith("work_")&&anchor.has("workday"))return true;if(dt==="workday"&&[...anchor].some(a=>String(a).startsWith("work_")))return true;return false;};
  const doneDay=new Map();
  for(const c of (checkins||[])){if(c.micro_change_id!==mid)continue;const cd=c.cycle_day;if(cd==null||cd===13||cd<start||cd>end)continue;if(doneDay.has(cd))continue;doneDay.set(cd,!!c.completed);}
  let td=0,to=0,w=Math.floor((start-1)/7)+1;
  while((w-1)*7+1<=end){
    const ws=(w-1)*7+1,we=w*7,rs=Math.max(ws,start),re=Math.min(we,end);
    // #3 (Vanessa 11-ago): weekly_count se juzga SOLO cuando la semana ha CERRADO. Si se pasa cdNow
    // y el último día de la semana (we) aún no ha pasado (we>=cdNow), esa semana queda PENDIENTE
    // (no cuenta como fricción todavía). Sin cdNow → cuenta todas (para la meta del ciclo).
    if(cdNow!=null&&we>=cdNow){w++;continue;}
    if(rs<=re){
      let has=false;for(let cd=rs;cd<=re;cd++){if(anchorOk(cd)){has=true;break;}}
      const tw=has?target:0;
      let dw=0;doneDay.forEach((v,cd)=>{if(v&&cd>=rs&&cd<=re)dw++;});
      td+=Math.min(dw,tw);to+=tw;
    }
    w++;
  }
  return {done:td,opps:to};
};
// Agregado: done + opps de una lista de items (mcs o comps) en [start..end].
const _aggregateInRange=(items,sd,calendar,checkins,start,end,cd)=>{
  let done=0,opps=0;const per=[];
  for(const m of (items||[])){
    const meta=m.meta||{};
    let d,o;
    if(meta.pattern==="weekly_count"){const wc=_wcDoneOpps(meta,m.id,checkins,calendar,start,end,cd);d=wc.done;o=wc.opps;}
    else{
      d=_doneForMicroInRange(m.id,checkins,start,end);
      o=_oppsForMicroInRange(meta,sd,calendar,start,end);
      // "Hoy pendiente" (Vanessa 11-ago): si el rango llega a HOY y hoy no se ha respondido este
      // micro, hoy NO cuenta (día sin cerrar). Los días PASADOS sin marcar SÍ cuentan (no hecho).
      if(cd!=null&&end>=cd&&start<=cd){
        const todayApplies=_oppsForMicroInRange(meta,sd,calendar,cd,cd)>0;
        const todayAns=(checkins||[]).some(c=>c.micro_change_id===m.id&&c.cycle_day===cd);
        if(todayApplies&&!todayAns) o=Math.max(0,o-1);
      }
    }
    // Los situational (y micros fuera de rango esta semana) tienen opps=0: no cuentan
    // al ratio de cumplimiento (no tienen agenda), pero sí van en `per` para mostrarse.
    if(o>0){done+=d;opps+=o;}
    per.push({m,done:d,opps:o});
  }
  return{done,opps,per};
};
function computeWeekStats(w,{wk,cd,weekly,events,mcs,comps,calDays,checkins,sd}){
  const daysLived=_daysLivedInWeek(w,wk,cd);
  // Semanas futuras (w>wk): todo null para que la columna salga "—" (prevista, no vivida aún).
  if(daysLived===0){
    return{microsPct:null,compsPct:null,dailyDays:0,daysLived:0,weeklyDone:false,mood:null,integrados:null,mantenimiento:null,fricciones:null,totalPct:null,wkEv:[],wd:null};
  }
  const wkEv=_checkinsForWeek(events,w);
  const ws=(weekly||[]).find(s=>s.week_number===w);
  const wd=ws?_pjb(ws.summary_data??ws.data):null;
  const wkStart=(w-1)*7+1;
  const wkEnd=Math.min(w*7,cd);
  // Día 13 (regla Vanessa): su "¿a qué dijiste SÍ?" ES su check-in. Cualquier respuesta
  // —texto O declinar con "-"— crea un evento dia_si → check-in COMPLETO (+1). Si pasa al
  // día siguiente sin responder (ghost, sin dia_si) → INCOMPLETO (en el denominador, no
  // suma). El día 13 siempre está en el denominador. Solo los `special` se excluyen.
  const _hasDiaSi=(events||[]).some(e=>e.event_name==="dia_si");
  const _d13InRange=13>=wkStart&&13<=wkEnd;
  const effDays=Math.max(0,daysLived-_offDaysInRange(calDays,wkStart,wkEnd));
  const mAgg=_aggregateInRange(mcs,sd,calDays,checkins,wkStart,wkEnd,cd);
  const cAgg=_aggregateInRange(comps,sd,calDays,checkins,wkStart,wkEnd,cd);
  // Denominador = oportunidades hasta hoy (días pasados + hoy-si-respondido, ya aplicado en el
  // aggregate). Sin ninguna oportunidad cerrada → "—" (null), no 0%.
  const microsPct=mAgg.opps?Math.min(100,Math.round(mAgg.done/mAgg.opps*100)):(mAgg.done>0?100:null);
  const compsPct=cAgg.opps?Math.min(100,Math.round(cAgg.done/cAgg.opps*100)):(cAgg.done>0?100:null);
  let dailyDays=_nightsInRange(events,sd,wkStart,wkEnd);
  if(_d13InRange&&_hasDiaSi) dailyDays+=1;
  const weeklyDone=Boolean(ws);
  const mood=_moodAvg(wkEv);
  // Integrados/Mantenimiento/Fricción: SIEMPRE por ratio EN LA SEMANA (una sola fuente de verdad).
  // Antes, si la semana tenía summary_data, usaba wd.integrados/friccion → esos arrays MEZCLAN
  // compromisos con micros (Speech/Casa contaban como 'fricción' de micros) e incoherían con la
  // columna Ciclo. Ahora clasifica en vivo por ratio, con compromisos ya fuera de mAgg. Bug 7-ago.
  let integrados=null,mantenimiento=null,fricciones=null;
  {
    const _c=_clsMicros(mAgg.per);integrados=_c.integrados;mantenimiento=_c.mantenimiento;fricciones=_c.fricciones;
  }
  // Constancia: ratio ponderado por oportunidades reales (micros + check-ins diarios).
  // Antes era promedio simple de [microsPct, compsPct, checkinPct] / 3 — esto distorsionaba:
  // los compromisos (1-2 en el ciclo) pesaban 1/3, igual que los 70+ opps de micros.
  // Fallar 1 compromiso semanal tiraba el total como si fueran 30 fallos de micros.
  // Fix (Vanessa, opcion D): los compromisos van APARTE como cifra cualitativa (X/Y cerrados),
  // la constancia mezcla solo lo que es repetitivo (micros + check-ins) por opps reales.
  const constDone=mAgg.done+dailyDays;
  const constOpps=mAgg.opps+effDays;
  const totalPct=constOpps?Math.min(100,Math.round(constDone/constOpps*100)):null;
  return{microsPct,compsPct,compsDone:cAgg.done,compsOpps:cAgg.opps,dailyDays,daysLived:effDays,weeklyDone,mood,integrados,mantenimiento,fricciones,totalPct,wkEv,wd};
}
// Acumulada = solo semanas YA cerradas (no cuenta la actual). Ciclo = todos los días vividos hasta hoy.
function computeAccumulatedStats({wk,weekly,events,mcs,comps,calDays,checkins,sd}){
  // Solo semanas cerradas: w < wk
  const closedWeeks=[1,2,3,4].filter(w=>w<wk);
  if(!closedWeeks.length) return null;
  const days=closedWeeks.length*7;  // raw days (para check-ins denominator)
  // Día 13: cualquier respuesta (texto o "-") crea dia_si → completo (+1). Ghost → incompleto.
  // Siempre en el denominador. Solo los `special` se excluyen.
  const _hasDiaSi=(events||[]).some(e=>e.event_name==="dia_si");
  const _d13InRange=13>=1&&13<=days;
  const effDays=Math.max(0,days-_offDaysInRange(calDays,1,days));
  const mAgg=_aggregateInRange(mcs,sd,calDays,checkins,1,days);
  const cAgg=_aggregateInRange(comps,sd,calDays,checkins,1,days);
  // Denominador = oportunidades hasta hoy (días pasados + hoy-si-respondido, ya aplicado en el
  // aggregate). Sin ninguna oportunidad cerrada → "—" (null), no 0%.
  const microsPct=mAgg.opps?Math.min(100,Math.round(mAgg.done/mAgg.opps*100)):(mAgg.done>0?100:null);
  const compsPct=cAgg.opps?Math.min(100,Math.round(cAgg.done/cAgg.opps*100)):(cAgg.done>0?100:null);
  const allEv=(events||[]).filter(e=>{if(e.event_name!=="checkin_complete")return false;const ecd=(e.event_data||{}).cycle_day;return ecd>=1&&ecd<=days;});
  let dailyDays=_nightsInRange(events,sd,1,days);
  if(_d13InRange&&_hasDiaSi) dailyDays+=1;
  const weeklyDoneCount=closedWeeks.filter(w=>(weekly||[]).some(r=>r.week_number===w)).length;
  const mood=_moodAvg(allEv);
  // Integrados/Mantenimiento/Fricción: SIEMPRE por ratio agregado (una sola fuente de verdad,
  // igual que computeCycleStats). Antes, si todas las semanas cerradas tenían summary_data, sumaba
  // los arrays integrados/friccion guardados por semana → DOBLA-CUENTA el mismo micro entre semanas
  // y MEZCLA compromisos → 'Fricción 10 / Integrados 4' incoherente con el Ciclo (0/2). Bug 7-ago.
  let integrados=null,mantenimiento=null,fricciones=null;
  {
    const _c=_clsMicros(mAgg.per);integrados=_c.integrados;mantenimiento=_c.mantenimiento;fricciones=_c.fricciones;
  }
  // Constancia ponderada por opps (ver computeWeekStats para detalle del fix).
  const constDone=mAgg.done+dailyDays;
  const constOpps=mAgg.opps+effDays;
  const totalPct=constOpps?Math.min(100,Math.round(constDone/constOpps*100)):null;
  return{microsPct,compsPct,compsDone:cAgg.done,compsOpps:cAgg.opps,dailyDays,daysLived:effDays,weeklyDone:`${weeklyDoneCount}/${closedWeeks.length}`,mood,integrados,mantenimiento,fricciones,totalPct};
}
// Ciclo = todos los días vividos del ciclo (incluida la semana actual hasta hoy).
function computeCycleStats({wk,cd,weekly,events,mcs,comps,calDays,checkins,sd}){
  const totalDays=Math.min(cd,28);  // raw days
  // Día 13: cualquier respuesta (texto o "-") crea dia_si → completo (+1). Ghost → incompleto.
  // Siempre en el denominador. Solo los `special` se excluyen.
  const _hasDiaSi=(events||[]).some(e=>e.event_name==="dia_si");
  const _d13InRange=13<=totalDays;
  const effDays=Math.max(0,totalDays-_offDaysInRange(calDays,1,totalDays));
  const mAgg=_aggregateInRange(mcs,sd,calDays,checkins,1,totalDays,cd);
  const cAgg=_aggregateInRange(comps,sd,calDays,checkins,1,totalDays,cd);
  // Denominador = oportunidades hasta hoy (días pasados + hoy-si-respondido, ya aplicado en el
  // aggregate). Sin ninguna oportunidad cerrada → "—" (null), no 0%.
  const microsPct=mAgg.opps?Math.min(100,Math.round(mAgg.done/mAgg.opps*100)):(mAgg.done>0?100:null);
  const compsPct=cAgg.opps?Math.min(100,Math.round(cAgg.done/cAgg.opps*100)):(cAgg.done>0?100:null);
  const allEv=(events||[]).filter(e=>{if(e.event_name!=="checkin_complete")return false;const ecd=(e.event_data||{}).cycle_day;return ecd>=1&&ecd<=totalDays;});
  let dailyDaysAll=_nightsInRange(events,sd,1,totalDays);
  if(_d13InRange&&_hasDiaSi) dailyDaysAll+=1;
  const weeklyDoneAll=(weekly||[]).length;
  const mood=_moodAvg(allEv);
  let integrados=null,mantenimiento=null,fricciones=null;
  {const _c=_clsMicros(mAgg.per);integrados=_c.integrados;mantenimiento=_c.mantenimiento;fricciones=_c.fricciones;}
  // Constancia ponderada por opps (ver computeWeekStats para detalle del fix).
  const constDone=mAgg.done+dailyDaysAll;
  const constOpps=mAgg.opps+effDays;
  const totalPct=constOpps?Math.min(100,Math.round(constDone/constOpps*100)):null;
  return{microsPct,compsPct,compsDone:cAgg.done,compsOpps:cAgg.opps,dailyDays:dailyDaysAll,daysLived:effDays,weeklyDone:`${new Set((weekly||[]).map(r=>r.week_number)).size}/4`,mood,integrados,mantenimiento,fricciones,totalPct};
}

// ProgressTable — tabla maestra del progreso del ciclo. Columnas: Sem 1-4 + Acumulada + Ciclo.
// Filas: Compromisos · Micros · Integrados · Mantenimiento · Fricción · Check-ins diarios ·
// Weekly review · Mood · TOTAL CUMPLIMIENTO. La síntesis cuantitativa del ciclo entero.
function ProgressTable({wk,cd,weekly,events,mcs,comps,calDays,checkins,sd}){
  const wkStats=[1,2,3,4].map(w=>computeWeekStats(w,{wk,cd,weekly,events,mcs,comps,calDays,checkins,sd}));
  const accStats=computeAccumulatedStats({wk,weekly,events,mcs,comps,calDays,checkins,sd});
  const cycStats=computeCycleStats({wk,cd,weekly,events,mcs,comps,calDays,checkins,sd});
  // Helpers de render
  const cell=(v,suffix="")=>v===null||v===undefined?<span style={{color:T.grisL}}>—</span>:<span style={{color:T.crema,fontFamily:T.serif}}>{v}{suffix}</span>;
  const cellNum=(v)=>v===null||v===undefined?<span style={{color:T.grisL}}>—</span>:<span style={{color:T.crema,fontFamily:T.serif,fontSize:13}}>{v}</span>;
  // Filtrar columnas visibles ANTES de armar el grid — meter "0" no funciona en CSS Grid,
  // descuadra las celdas. Las columnas vivas se construyen como pares {label, stats}.
  // Las 4 semanas siempre visibles: las futuras se renderizan con celdas "—" (previstas).
  // Acumulada solo aparece cuando hay 1+ semanas cerradas (no aporta nada en semana 1).
  const allCols=[
    {label:"Sem 1",stats:wkStats[0],visible:true,isFuture:1>wk},
    {label:"Sem 2",stats:wkStats[1],visible:true,isFuture:2>wk},
    {label:"Sem 3",stats:wkStats[2],visible:true,isFuture:3>wk},
    {label:"Sem 4",stats:wkStats[3],visible:true,isFuture:4>wk},
    {label:"Acum.",stats:accStats,visible:Boolean(accStats),isAcc:true},
    {label:"Ciclo",stats:cycStats,visible:true,isCyc:true},
  ];
  const cols=allCols.filter(c=>c.visible);
  const gridCols=`1.4fr ${cols.map(()=>"minmax(48px,1fr)").join(" ")}`;
  const numCell=(v,suffix="",color)=>v===null||v===undefined?<span style={{color:T.grisL}}>—</span>:<span style={{color:color||T.crema,fontFamily:T.serif}}>{v}{suffix}</span>;
  const subRow=(label,key,color)=>(<>
    <div style={{padding:"4px 14px 4px 28px",color:T.grisL,fontSize:10}}>· {label}</div>
    {cols.map((col,i)=>{const v=col.stats?.[key];return(<div key={i} style={{padding:"4px 8px",textAlign:"right"}}>{v===null||v===undefined?<span style={{color:T.grisL}}>—</span>:<span style={{color:color,fontFamily:T.serif,fontSize:13}}>{v}</span>}</div>);})}
  </>);
  const row=(label,key,suffix="")=>(<>
    <div style={{padding:"8px 14px",color:T.crema,fontSize:11}}>{label}</div>
    {cols.map((col,i)=>(<div key={i} style={{padding:"8px 8px",textAlign:"right",fontSize:11}}>{numCell(col.stats?.[key],suffix)}</div>))}
  </>);
  return(<Card style={{padding:0,marginTop:14}}>
    <div style={{padding:"14px 18px 8px",borderBottom:`1px solid ${T.gb}`}}>
      <p style={{fontSize:10,letterSpacing:2,color:T.oro,textTransform:"uppercase",fontWeight:500}}>Tabla del ciclo</p>
    </div>
    <div style={{overflowX:"auto",width:"100%",WebkitOverflowScrolling:"touch",position:"relative"}}>
      {/* Hint visual: gradiente al borde derecho que indica que hay más contenido scrollable.
          Sin esto, en mobile la columna Ciclo queda fuera de pantalla y el user no se entera. */}
      {cols.length>=5&&<div style={{position:"absolute",top:0,right:0,bottom:0,width:24,pointerEvents:"none",background:`linear-gradient(to right, transparent, ${T.bgCard||"rgba(20,20,20,0.95)"})`,zIndex:2}}/>}
      <div style={{display:"grid",gridTemplateColumns:gridCols,gap:0,minWidth:cols.length*52+110}}>
        {/* Header row */}
        <div style={{padding:"10px 14px",borderBottom:`1px solid ${T.gb}`}}></div>
        {cols.map((col,i)=>(<div key={i} style={{padding:"10px 8px",borderBottom:`1px solid ${T.gb}`,textAlign:"right",color:col.isCyc?T.oro:T.grisL,letterSpacing:1.2,textTransform:"uppercase",fontSize:9,fontWeight:col.isCyc?600:500}}>{col.label}</div>))}

        {row("Micros","microsPct","%")}
        {subRow("Integrados","integrados",T.lima)}
        {subRow("Mantenimiento","mantenimiento",T.oro)}
        {subRow("Fricción","fricciones",T.coral)}

        {/* Check-in nocturno (antes "Te presentaste"). Número honesto SEPARADO de "Micros" — no se
            mezclan. borderTop para cortar visualmente del bloque de sub-filas Integrados/Manten/Fricción
            (Vanessa 8-ago: se cruzaban al leer). */}
        <div style={{padding:"8px 14px",color:T.crema,fontSize:11,borderTop:`1px solid ${T.gb}`}}>Check-in</div>
        {cols.map((col,i)=>(<div key={i} style={{padding:"8px 8px",textAlign:"right",fontSize:11,borderTop:`1px solid ${T.gb}`}}>{col.stats?.daysLived?<span style={{color:T.crema,fontFamily:T.serif}}>{col.stats.dailyDays}/{col.stats.daysLived}</span>:<span style={{color:T.grisL}}>—</span>}</div>))}

        {/* Weekly review — checkmark para semanas, X/N para acumulada/ciclo */}
        <div style={{padding:"8px 14px",color:T.crema,fontSize:11}}>Weekly review</div>
        {cols.map((col,i)=>(<div key={i} style={{padding:"8px 8px",textAlign:"right",fontSize:11}}>{col.isAcc||col.isCyc?(col.stats?.weeklyDone?<span style={{color:T.crema,fontFamily:T.serif}}>{col.stats.weeklyDone}</span>:<span style={{color:T.grisL}}>—</span>):(col.stats?.weeklyDone?<span style={{color:T.lima,fontFamily:T.serif}}>✓</span>:<span style={{color:T.grisL}}>—</span>)}</div>))}

        {/* Mood */}
        <div style={{padding:"8px 14px",color:T.crema,fontSize:11}}>Energía</div>
        {cols.map((col,i)=>(<div key={i} style={{padding:"8px 8px",textAlign:"right",fontSize:11}}>{col.stats?.mood?<span style={{color:T.crema,fontFamily:T.serif}}>{_moodEmoji(col.stats.mood)} {col.stats.mood}</span>:<span style={{color:T.grisL}}>—</span>}</div>))}

        {/* La fila "Constancia" mezclada (micros + check-ins ponderados) se QUITÓ (Vanessa 7-ago):
            confundía — alguien con micros perfectos pero pocas noches salía al 50%. Ahora los dos
            números viven separados arriba (Micros % · Te presentaste N/N), cada uno honesto. */}

        {/* COMPROMISOS — cifra cualitativa aparte: cerrados / totales (no promediado). */}
        <div style={{padding:"10px 14px 12px",color:T.crema,fontWeight:500,fontSize:11}}>Compromisos cerrados</div>
        {cols.map((col,i)=>{const d=col.stats?.compsDone;const o=col.stats?.compsOpps;return(<div key={i} style={{padding:"10px 8px 12px",textAlign:"right",fontSize:11}}>{o?<span style={{color:d===o?T.lima:(d>0?T.oro:T.coral),fontFamily:T.serif,fontWeight:500}}>{d}/{o}</span>:<span style={{color:T.grisL}}>—</span>}</div>);})}
      </div>
    </div>
    {/* Leyenda — qué significa cada fila, en español llano. Evita que el user tenga que adivinar
        "Energía" o "Compromisos cerrados" (Vanessa 8-ago). */}
    <div style={{padding:"12px 18px 16px",borderTop:`1px solid ${T.gb}`,display:"flex",flexDirection:"column",gap:5}}>
      {[
        ["Micros %","de los micros que tocaban, cuántos cumpliste"],
        ["Integrados / Mantenimiento / Fricción","cómo va cada micro: bien (≥70%) / a medias (40-69%) / cuesta (<40%)"],
        ["Check-in","noches que te presentaste a mirarte, de las noches del periodo"],
        ["Weekly review","revisiones de fin de semana completadas"],
        ["Energía","tu ánimo MEDIO del periodo (no un recuento): 😶 floja(1) · 😐 normal(2) · 💪 con energía(3) · 🔥 mucha(4). Ej: 😐 2.0 = de media estuviste en 'normal'"],
        ["Compromisos cerrados","promesas del ciclo cumplidas, del total"],
      ].map(([k,v],i)=>(<p key={i} style={{fontSize:10,color:T.grisL,lineHeight:1.4,margin:0}}>
        <span style={{color:T.crema,fontWeight:500}}>{k}:</span> {v}
      </p>))}
    </div>
  </Card>);
}

// WeeksBlock — zoom-in narrativo de cada semana: gráfico mood + detalle diario + chips benefits + tus palabras + cierre.
// La tabla de stats vive en Mi progreso ahora (ProgressTable).
function WeeksBlock({cycleNum,cd,wk,weekly,events,phase,cycleStart,cycleId,mcs,calDays,checkins,sd}){
  // Diario por semanas (jul-26): un solo evento user_note con event_data.weeks {"1":...,"2":...}.
  // Cada card muestra su semana de solo lectura → permite comparar semana a semana.
  const diaryEv=(events||[]).find(e=>e.event_name==="user_note"&&(!cycleId||(e.event_data||{}).cycle_id===cycleId));
  const diaryWeeks=(diaryEv?.event_data||{}).weeks||{};
  // Rango de fechas por semana del ciclo (UTC, igual que las queries del backend).
  const cs=cycleStart?new Date((""+cycleStart).slice(0,10)+"T00:00:00"):null;
  const weekRange=(w)=>{
    if(!cs) return null;
    const start=new Date(cs);start.setDate(start.getDate()+(w-1)*7);
    const end=new Date(cs);end.setDate(end.getDate()+w*7);
    return{start,end};
  };
  return(<>{[1,2,3,4].map(w=>{
    const act=w===wk;
    const fut=w>wk;
    const desc=(WEEK_DESCRIPTIONS[phase?.n||"Arrancar"]||[])[w-1]||"";
    const wkEv=_checkinsForWeek(events,w);
    const ws=(weekly||[]).find(s=>s.week_number===w);
    const wd=ws?_pjb(ws.summary_data??ws.data):null;
    // Clasificación EN VIVO por ratio de esta semana — misma fuente que la tabla de Mi progreso
    // (computeWeekStats → _clsMicros). Los tags de "Tu lectura de la semana" salen de aquí, NO de
    // wd.integrados (summary_data del bot, que mezcla compromisos) → calco exacto con la tabla.
    const _wS=(w-1)*7+1,_wE=Math.min(w*7,cd);
    const _clsT=fut?{integrados:[],mantenimiento:[],fricciones:[]}:_clsMicrosTitles(_aggregateInRange(mcs,sd,calDays,checkins,_wS,_wE,cd).per);
    const _hasCls=_clsT.integrados.length||_clsT.mantenimiento.length||_clsT.fricciones.length;
    // La lectura RAG de ESTA semana es la síntesis narrativa (Vanessa: la síntesis debe
    // tener sentido, no ser el 'X/Y' mecánico ni el mensaje de chat con hashtags).
    const ragEv=(events||[]).find(e=>e.event_name==="antifragil_opinion"&&(e.event_data||{}).week_number===w);
    const ragText=ragEv?(((ragEv.event_data||{}).text)||"").trim():"";
    // BENEFICIO LÍQUIDO de la semana w: acotar por created_at en rango [start, end) o por
    // event_data.cycle_day si existe. Antes mostraba todos los benefits del ciclo en cada
    // semana — bug que hacía que las 4 semanas se vieran iguales.
    const range=weekRange(w);
    const wBenefits=(events||[]).filter(e=>{
      if(e.event_name!=="micro_benefit") return false;
      const ecd=(e.event_data||{}).cycle_day;
      if(typeof ecd==="number") return ecd>=(w-1)*7+1&&ecd<=w*7;
      if(range&&e.created_at){const t=new Date(e.created_at);return t>=range.start&&t<range.end;}
      return false;
    });
    const benefitsByLabel={};
    wBenefits.forEach(e=>{const b=(e.event_data||{}).benefit;if(!b)return;benefitsByLabel[b]=(benefitsByLabel[b]||0)+1;});
    const benefitsList=Object.entries(benefitsByLabel).sort((a,b)=>b[1]-a[1]);
    // Avance notes de la semana w
    const wNotesEv=(events||[]).filter(e=>e.event_name==="weekly_avance_notes"&&((e.event_data||{}).week_number===w));
    const wNotes={};
    wNotesEv.forEach(e=>{const n=(e.event_data||{}).notes||{};Object.entries(n).forEach(([k,v])=>{wNotes[k]=v;});});
    return(<Card key={w} style={{marginBottom:14,opacity:fut?0.45:1}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"baseline",marginBottom:6}}>
        <div>
          <span style={{fontFamily:T.serif,fontSize:17,color:T.crema}}>Semana {w}</span>
          {desc&&<span style={{fontSize:10,color:T.grisL,marginLeft:10,letterSpacing:1}}>· {desc}</span>}
        </div>
        {act&&<span style={{fontSize:10,color:T.oro,letterSpacing:1.5,textTransform:"uppercase",fontWeight:500}}>En curso</span>}
        {!act&&!fut&&<span style={{fontSize:10,color:T.grisL,letterSpacing:1.5,textTransform:"uppercase"}}>Cerrada</span>}
        {fut&&<span style={{fontSize:10,color:T.gris,letterSpacing:1.5,textTransform:"uppercase"}}>Próxima</span>}
      </div>
      {fut&&<p style={{fontSize:11,color:T.gris,fontStyle:"italic",marginTop:6}}>Aquí verás los datos de esta semana cuando llegue.</p>}

      {/* RESUMEN narrativo arriba — síntesis breve de lo que el user verá debajo.
          D7: contar DÍAS únicos con check-in, no eventos. El bot graba 2-3 events checkin_complete
          por día (mood / energy / friction como rows separados); usar wkEv.length inflaba
          el contador a "7 check-ins" en una semana con sólo 3 días vividos. */}
      {(()=>{let ciDaysWk=new Set(wkEv.map(e=>(e.event_data||{}).cycle_day).filter(Boolean)).size;
        // Día 13 cuenta como check-in (su "¿a qué dijiste SÍ?" ES el check-in) — IGUAL que la tabla
        // de Mi progreso (computeWeekStats). Sin esto, la narrativa de la Semana 2 decía N y la tabla
        // N+1. Ahora ambas son un calco.
        {const _wkStart=(w-1)*7+1,_wkEnd=w*7;if(13>=_wkStart&&13<=_wkEnd&&(events||[]).some(e=>e.event_name==="dia_si")) ciDaysWk+=1;}
        // Check-in cuenta 1 aunque sea "en seco" (presentarse ES el ritual — Vanessa 8-ago). Pero
        // reconocemos en TEXTO cuántos llevaron nota (mood/energía/fricción). Si algunos fueron
        // rápidos (solo micros), se ve el matiz sin castigar la presencia ni usar fracciones.
        const _noteDays=new Set();
        wkEv.forEach(e=>{const d=e.event_data||{};const cd=d.cycle_day;if(cd==null)return;if(d.mood||d.energy_plus||d.energy_minus||(d.friction_reasons&&Object.keys(d.friction_reasons).length))_noteDays.add(cd);});
        const notesCount=_noteDays.size;
        const partial=notesCount>0&&notesCount<ciDaysWk;
        return !fut&&<p style={{fontSize:12,color:T.grisL,lineHeight:1.5,marginTop:8,marginBottom:14,fontStyle:"italic"}}>
        {ciDaysWk===0?"Aún sin check-ins. Cuando los hagas verás aquí tu mood, qué te dio energía, qué costó y los beneficios que te están aportando los micros.":
          `${ciDaysWk} check-in${ciDaysWk>1?"s":""} esta semana${partial?` · ${notesCount} con nota`:""}${benefitsList.length?` · ${benefitsList.length} beneficio${benefitsList.length>1?"s":""} reportado${benefitsList.length>1?"s":""}`:""}${Object.keys(wNotes).length?` · ${Object.keys(wNotes).length} nota${Object.keys(wNotes).length>1?"s":""} tuya${Object.keys(wNotes).length>1?"s":""}`:""}${wd?" · cierre semanal cerrado":""}.`}
      </p>;})()}

      {/* ENERGÍA — gráfico semanal con título (antes "Mood", renombrado para coherencia con el bot) */}
      {!fut&&<>
        <p style={{fontSize:9,letterSpacing:2,color:T.oro,textTransform:"uppercase",marginBottom:4,marginTop:6}}>Energía</p>
        <WeekMoodChart events={wkEv} cycleStart={cycleStart} weekNum={w}/>
      </>}

      {/* CHECK-INS DIARIOS — detalle día a día con título */}
      {!fut&&wkEv.length>0&&<>
        <p style={{fontSize:9,letterSpacing:2,color:T.oro,textTransform:"uppercase",marginBottom:4,marginTop:14}}>Check-ins diarios</p>
        <WeekDetail events={wkEv} cycleStart={cycleStart} weekNum={w} cd={cd}/>
      </>}
      {!fut&&wkEv.length===0&&act&&<p style={{fontSize:11,color:T.gris,fontStyle:"italic",marginTop:4}}>Aún sin check-ins esta semana.</p>}

      {/* BENEFICIO LÍQUIDO — chips con peso visual. Color crema (no oro) para no confundir con el título. */}
      {!fut&&benefitsList.length>0&&<div style={{marginTop:14}}>
        <p style={{fontSize:9,letterSpacing:2,color:T.oro,textTransform:"uppercase",marginBottom:4}}>Beneficio líquido</p>
        <p style={{fontSize:11,color:T.grisL,marginBottom:10,lineHeight:1.45}}>Lo que te ha aportado cada micro según tus check-ins. Cuanto más repites un beneficio, más grande se ve.</p>
        <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
          {benefitsList.map(([b,c],i)=>{const sz=c>=3?13:c>=2?12:11;const op=c>=3?1:c>=2?0.85:0.7;return(
            <span key={i} style={{fontSize:sz,padding:c>=3?"6px 12px":"4px 10px",borderRadius:8,background:T.glass,color:T.crema,border:`1px solid ${T.gb}`,opacity:op,fontWeight:c>=3?500:400,letterSpacing:0.2}}>
              {b}{c>1&&<span style={{marginLeft:6,color:T.oro,fontSize:9,fontWeight:500}}>×{c}</span>}
            </span>
          );})}
        </div>
      </div>}

      {/* TUS PALABRAS — avance_notes literales del weekly review */}
      {!fut&&Object.keys(wNotes).length>0&&<div style={{marginTop:14}}>
        <p style={{fontSize:9,letterSpacing:2,color:T.oro,textTransform:"uppercase",marginBottom:8}}>Tus palabras</p>
        {Object.entries(wNotes).map(([titulo,nota],i)=>(
          <div key={i} style={{padding:"6px 0",borderBottom:i<Object.keys(wNotes).length-1?`1px solid ${T.gb}`:"none"}}>
            <p style={{fontSize:10,color:T.grisL,letterSpacing:0.5,marginBottom:2}}>{titulo}</p>
            <p style={{fontSize:12,color:T.crema,fontStyle:"italic",fontFamily:T.serif,lineHeight:1.45}}>"{nota}"</p>
          </div>
        ))}
      </div>}

      {/* TU DIARIO · SEMANA N — la entrada del diario de esta semana (solo lectura). Permite
          comparar lo que escribiste semana a semana. Se edita desde "Mi espacio". */}
      {(()=>{const dt=(diaryWeeks[w]||diaryWeeks[String(w)]||"").trim();return !fut&&dt&&<div style={{marginTop:14}}>
        <p style={{fontSize:9,letterSpacing:2,color:T.oro,textTransform:"uppercase",marginBottom:6}}>Tu diario · Semana {w}</p>
        <p style={{fontSize:12,color:T.crema,lineHeight:1.55,whiteSpace:"pre-wrap"}}>{dt}</p>
      </div>;})()}

      {/* TU LECTURA DE LA SEMANA — la lectura RAG narrativa (la síntesis de verdad). Fallback
          al summary_text viejo si aún no hay lectura. Los tags integrado/mantenimiento/fricción
          se mantienen debajo como resumen visual. */}
      {(wd||ragText||_hasCls)&&<div style={{marginTop:14,paddingTop:14,borderTop:`1px solid ${T.gb}`}}>
        <p style={{fontSize:9,letterSpacing:2,color:T.oro,textTransform:"uppercase",marginBottom:6}}>Tu lectura de la semana</p>
        {ragText
          ? <p style={{fontSize:12,color:T.crema,lineHeight:1.6,whiteSpace:"pre-wrap"}}>{ragText}</p>
          : (wd&&(wd.summary||wd.analysis))?<p style={{fontSize:12,color:T.crema,lineHeight:1.55}}>{wd.summary||wd.analysis}</p>:null}
        {/* Tags = clasificación EN VIVO (calco de la tabla de Mi progreso), NO wd.integrados del bot. */}
        {_hasCls?<div style={{display:"flex",gap:6,flexWrap:"wrap",marginTop:10}}>
          {_clsT.integrados.map((t,i)=><Tg key={`i${i}`} label={`✓ ${t}`} color={T.lima}/>)}
          {_clsT.mantenimiento.map((t,i)=><Tg key={`p${i}`} label={`⏳ ${t}`} color={T.oro}/>)}
          {_clsT.fricciones.map((t,i)=><Tg key={`f${i}`} label={`⚠ ${t}`} color={T.coral}/>)}
        </div>:null}
        {wd&&wd.frase&&<p style={{fontSize:13,color:T.crema,marginTop:12,fontStyle:"italic",fontFamily:T.serif,lineHeight:1.5}}>"{wd.frase}"</p>}
      </div>}
      {act&&!wd&&wkEv.length>0&&<p style={{fontSize:11,color:T.gris,marginTop:10,fontStyle:"italic"}}>La síntesis de la semana la verás aquí cuando termine.</p>}
    </Card>);
  })}</>);
}

// Sprint v2 (mayo 2026) — LO QUE ESCRIBÍ AL EMPEZAR. Sub-card dentro de "Quién soy"
// con el material crudo que el user escribió al inicio del onboarding:
//   · vital_moment: chip (arquetipo) + frase libre 200 chars
//   · memoria_patron: textarea 250 chars vinculada al patrón clickado
//   · imagen_futuro: textarea 250 chars positivizada vinculada al objetivo
// Identidad fija — no evoluciona durante el ciclo. La Opinión Antifrágil al final del
// dashboard cita estos textos LITERAL en su narrative. Aquí se muestran como referencia.
// Textos sin truncate (whiteSpace pre-wrap, sin ellipsis) — son palabras del user.
function OnboardingTextosCard({events}){
  const vm = (events||[]).find(e=>e.event_name==="vital_moment")?.event_data;
  const mp = (events||[]).find(e=>e.event_name==="memoria_patron")?.event_data;
  const ifut = (events||[]).find(e=>e.event_name==="imagen_futuro")?.event_data;
  const memoria = (typeof mp === "object" && mp?.text) || "";
  const futuro = (typeof ifut === "object" && ifut?.text) || "";
  const tieneAlgo = (vm && (vm.chip_label || vm.frase)) || memoria || futuro;
  if(!tieneAlgo) return null;
  return(<Card style={{marginTop:14}}>
    <p style={{fontSize:10,letterSpacing:2,color:T.oro,textTransform:"uppercase",fontWeight:500,marginBottom:12}}>◆ Lo que escribí al empezar</p>
    <div style={{display:"flex",flexDirection:"column",gap:14}}>
      {vm && (vm.chip_label || vm.frase) && <div>
        <p style={{fontSize:10,color:T.grisL,letterSpacing:1.5,textTransform:"uppercase",marginBottom:6}}>Llegué aquí porque</p>
        {/* Si el chip es "otro" (el user no encajó en los 4 buckets canónicos), el chip_label
            ("Otra cosa") no aporta — el contenido real está en la frase libre. Omitir etiqueta
            en ese caso. Para los 4 canónicos sí aporta: clasifica el momento. */}
        {vm.chip_label && vm.chip_key !== "otro" && <p style={{fontSize:13,color:T.crema,lineHeight:1.45,marginBottom:vm.frase?4:0}}>{vm.chip_label}</p>}
        {vm.frase && <p style={{fontSize:12,color:T.crema,fontFamily:T.serif,fontStyle:"italic",lineHeight:1.5,whiteSpace:"pre-wrap"}}>"{vm.frase}"</p>}
      </div>}
      {memoria && <div>
        <p style={{fontSize:10,color:T.grisL,letterSpacing:1.5,textTransform:"uppercase",marginBottom:6}}>Memoria del patrón</p>
        <p style={{fontSize:12,color:T.crema,fontFamily:T.serif,fontStyle:"italic",lineHeight:1.55,whiteSpace:"pre-wrap"}}>"{memoria}"</p>
      </div>}
      {futuro && <div>
        <p style={{fontSize:10,color:T.grisL,letterSpacing:1.5,textTransform:"uppercase",marginBottom:6}}>Mi horizonte</p>
        <p style={{fontSize:12,color:T.crema,fontFamily:T.serif,fontStyle:"italic",lineHeight:1.55,whiteSpace:"pre-wrap"}}>"{futuro}"</p>
      </div>}
    </div>
  </Card>);
}

// Sprint v2 (mayo 2026) — CÓMO FUNCIONA ANTIFRÁGIL. Card al final del dashboard con
// las reglas del juego del ciclo. Mismo contenido que /instrucciones del bot. No menciona
// día 13 (sorpresa intencional). Renombra "Opinión Antifrágil" a "tu lectura del ciclo"
// (user-facing — el evento interno sigue siendo antifragil_opinion).
function ComoFuncionaCard(){
  const items = [
    {n:"01", t:"Cada mañana", d:"Recibes tus micro-cambios y compromisos personalizados a las horas que configuraste."},
    {n:"02", t:"Día a día", d:"Si no marcas alguno durante el día, no pasa nada. El check-in nocturno los repasa todos a la hora que elegiste."},
    {n:"03", t:"Sin penalizar", d:"Si no haces el check-in de noche, no se queda colgado. Se autocancela y mañana sigues."},
    {n:"04", t:"Días 7, 14 y 21", d:"Revisión semanal. 4-5 preguntas + síntesis de la semana."},
    {n:"05", t:"Día 28", d:"Cierre de ciclo basado en evidencia y documentación. Lo que proyectaste. Lo que hiciste. Lo que avanzaste. Lo que evitaste. Dónde estás ahora. Y decides si entras al Ciclo 2."},
    {n:"06", t:"Tu diario", d:"En esta pestaña → \"Mi espacio\". Unas líneas aportan evidencias. La memoria maquilla. El diario no."},
  ];
  return(<Card style={{marginTop:24,marginBottom:8,padding:"20px 22px"}}>
    <p style={{fontSize:10,letterSpacing:2,color:T.oro,textTransform:"uppercase",fontWeight:500,marginBottom:6}}>◐ Cómo funciona Antifrágil</p>
    <p style={{fontSize:13,color:T.grisL,fontStyle:"italic",fontFamily:T.serif,lineHeight:1.5,marginBottom:18}}>28 días contigo. Las reglas del juego del ciclo.</p>
    <div style={{display:"flex",flexDirection:"column",gap:16}}>
      {items.map((it,i)=>(
        <div key={i} style={{display:"flex",gap:14,alignItems:"flex-start"}}>
          <span style={{color:T.oro,fontFamily:T.serif,fontSize:13,fontWeight:600,minWidth:24,marginTop:1}}>{it.n}</span>
          <div style={{flex:1}}>
            <p style={{fontSize:13,color:T.crema,fontWeight:500,marginBottom:3,lineHeight:1.4}}>{it.t}</p>
            <p style={{fontSize:12,color:T.grisL,lineHeight:1.55}}>{it.d}</p>
          </div>
        </div>
      ))}
    </div>
    <div style={{marginTop:18,paddingTop:14,borderTop:`1px solid ${T.gb}`}}>
      <p style={{fontSize:10,color:T.grisL,letterSpacing:1.5,textTransform:"uppercase",marginBottom:6}}>Comandos en Telegram</p>
      <p style={{fontSize:12,color:T.grisL,lineHeight:1.6}}>
        <span style={{color:T.oro,fontFamily:T.mono||T.font}}>/mi_dashboard</span> — vuelve aquí en un toque<br/>
        <span style={{color:T.oro,fontFamily:T.mono||T.font}}>/instrucciones</span> — esto mismo en el chat
      </p>
    </div>
  </Card>);
}

// Resumen narrativo de "Quién soy" — derivado de OCEAN + Vital + patrón clickado.
// Identifica las 1-2 fortalezas (scores altos) y los 1-2 retos (scores bajos), y los
// presenta como frase corta. No es texto guardado en BD, se genera al vuelo cada
// vez que cargas el dashboard a partir de los scores actuales.
// (EarlyReadingCard movida a AntifragilOpinion como capa 1 — todas las narrativas LLM
// viven juntas en RESULTADO, "Quién soy" solo lleva lo estructurado.)

function IdentityNarrative({os,vs,pat}){
  const oceanLabels={O:"creatividad",C:"disciplina",E:"energía social",A:"empatía",N:"sensibilidad"};
  const vitalLabels={REG:"regulación",EMO:"emoción",VIN:"vínculo",CUI:"cuidado",PRO:"propósito",EXP:"exploración",IDE:"identidad",DIS:"disfrute"};
  const oSorted=Object.entries(os||{}).sort((a,b)=>b[1]-a[1]);
  const vSorted=Object.entries(vs||{}).filter(([,v])=>typeof v==="number").sort((a,b)=>b[1]-a[1]);
  // Top-2 / bottom-2 SIEMPRE, sin umbrales — para que perfiles balanceados también
  // vean los 4 vértices del cruce. Mismo principio que en La Brecha del onboarding.
  // Top/bottom con empates: si N+1 tiene mismo score que N, se incluye (cap 4) — antes
  // con slice(0,2) los empates de score se cortaban silenciosamente.
  const topWithTies=(arr,n=2,cap=4)=>{
    if(arr.length<=n) return arr;
    const cutoff=arr[n-1][1];
    const out=[];
    for(const d of arr){if(out.length>=cap) break; if(out.length<n||d[1]===cutoff) out.push(d);}
    return out;
  };
  const bottomWithTies=(arr,n=2,cap=4)=>{
    if(arr.length<=n) return [...arr].reverse();
    const cutoff=arr[arr.length-n][1];
    const out=[];
    for(let i=arr.length-1;i>=0;i--){const d=arr[i]; if(out.length>=cap) break; if(out.length<n||d[1]===cutoff) out.push(d);}
    return out;
  };
  const oHigh=topWithTies(oSorted);
  const oLow=bottomWithTies(oSorted).filter(([k])=>!oHigh.find(h=>h[0]===k));
  const vHigh=topWithTies(vSorted);
  const vLow=bottomWithTies(vSorted).filter(([k])=>!vHigh.find(h=>h[0]===k));
  const fortalezas=[...oHigh.map(([k])=>oceanLabels[k]),...vHigh.map(([k])=>vitalLabels[k])];
  const retos=[...oLow.map(([k])=>oceanLabels[k]),...vLow.map(([k])=>vitalLabels[k])];
  return(<div>
    {fortalezas.length>0&&<p style={{fontSize:13,color:T.crema,lineHeight:1.55,marginBottom:8}}>
      Tienes <span style={{color:T.lima}}>{fortalezas.slice(0,2).join(" y ")}</span> a tu favor.
    </p>}
    {retos.length>0&&<p style={{fontSize:13,color:T.crema,lineHeight:1.55,marginBottom:pat?12:0}}>
      Tu reto: <span style={{color:T.coral}}>{retos.slice(0,2).join(" y ")}</span>.
    </p>}
    {pat&&<div style={{paddingTop:12,borderTop:`1px solid ${T.gb}`}}>
      <p style={{fontSize:10,letterSpacing:2,color:T.oro,textTransform:"uppercase",marginBottom:4}}>Patrón</p>
      <p style={{fontSize:13,color:T.grisL,fontStyle:"italic",lineHeight:1.5}}>"{pat}"</p>
    </div>}
  </div>);
}

// PEROS por categoría en Mi progreso — counts del onboarding × % real de cumplimiento de
// micros de esa misma categoría en el ciclo. Es el contraste "lo que dijiste / lo que haces":
// cada PERO se enfrenta a sus datos. Si tu PERO es de regulación y haces poco REGulación,
// la categoría se ve coral (datos confirman el PERO). Si la haces, lima (datos contradicen).
const PEROS_CAT_LABELS={REG:"Regulación",EMO:"Emoción",VIN:"Vínculo",CUI:"Cuidado",PRO:"Propósito",EXP:"Exploración",IDE:"Identidad",DIS:"Disfrute"};
const CAT_TO_TAG={REG:"regulacion",EMO:"emocion",VIN:"vinculo",CUI:"cuidado",PRO:"proposito",EXP:"exploracion",IDE:"identidad",DIS:"disfrute"};
function PerosCategoriesPreview({events,mcs}){
  const ev=(events||[]).filter(e=>e.event_name==="peros_categorized").pop();
  if(!ev) return null;
  const peros=(ev.event_data||{}).peros||[];
  if(!peros.length) return null;
  // Contar PEROS por categoría
  const peroCounts={};
  peros.forEach(p=>{const c=p.category||p.cat||p.tag;if(!c)return;peroCounts[c]=(peroCounts[c]||0)+1;});
  // % real de cumplimiento por categoría (de los micros del usuario)
  const perCatStats=Object.entries(peroCounts).map(([cat,nPeros])=>{
    const tag=CAT_TO_TAG[cat]||"";
    const microsCat=(mcs||[]).filter(m=>{
      const c=(m.category||m.tag||"").toLowerCase();
      return c.includes(tag);
    });
    const done=microsCat.reduce((s,m)=>s+m.done,0);
    const total=microsCat.reduce((s,m)=>s+m.total,0);
    const pct=total?Math.round(done/total*100):null;
    const status=pct===null?"sin-micros":(pct>=60?"contradice":pct>=30?"medio":"confirma");
    return{cat,nPeros,nMicros:microsCat.length,pct,status};
  }).sort((a,b)=>b.nPeros-a.nPeros);
  const colorFor=(s)=>s==="contradice"?T.lima:s==="confirma"?T.coral:s==="medio"?T.oro:T.grisL;
  const labelFor=(s)=>s==="contradice"?"datos contradicen":s==="confirma"?"datos confirman":s==="medio"?"a medias":"sin micros";
  return(<Card style={{marginTop:12}}>
    <p style={{fontSize:10,color:T.oro,letterSpacing:2,textTransform:"uppercase",marginBottom:6}}>Tus PEROS vs los datos</p>
    <p style={{fontSize:11,color:T.grisL,marginBottom:12,lineHeight:1.45}}>Cada categoría que clickaste como PERO en el onboarding, contrastada con cuánto haces sus micros en el ciclo.</p>
    <div style={{display:"flex",flexDirection:"column",gap:8}}>
      {perCatStats.map(({cat,nPeros,nMicros,pct,status},i)=>{const col=colorFor(status);return(
        <div key={i} style={{display:"flex",alignItems:"center",gap:10,padding:"8px 10px",background:T.glass,borderRadius:8,border:`1px solid ${T.gb}`}}>
          <span style={{fontSize:12,color:T.crema,flex:1}}>{PEROS_CAT_LABELS[cat]||cat} <span style={{color:T.grisL,fontSize:10}}>· {nPeros} PERO{nPeros>1?"s":""}</span></span>
          {pct!==null&&<div style={{width:48,height:4,background:"rgba(255,255,255,0.05)",borderRadius:2,overflow:"hidden"}}>
            <div style={{width:`${pct}%`,height:"100%",background:col}}/>
          </div>}
          <span style={{fontFamily:T.serif,fontSize:14,color:col,minWidth:42,textAlign:"right"}}>{pct!==null?`${pct}%`:"—"}</span>
          <span style={{fontSize:9,color:col,letterSpacing:0.8,textTransform:"uppercase",minWidth:96,textAlign:"right"}}>{nMicros>0?labelFor(status):"sin micros"}</span>
        </div>
      );})}
    </div>
  </Card>);
}

// HeroPanel: la fachada del ciclo activo. Estructura:
//   1. Nombre del user grande + cumplimiento global %.
// HaciaCiclo2 — solo se monta cuando el ciclo está cerrado (isPostCycle). Surface
// pistas concretas de qué viene en el Ciclo 2 (Integrar), basadas en datos reales
// del Ciclo 1: top integrado se amplifica, top fricción se enfrenta, pillar top
// se materializa, energy+/− apuntan dirección. Card prominente para que el user
// vea el puente — Resistir era hacer aparecer, Integrar es hacer convivir.
function HaciaCiclo2({micros,comps,pillarsMap,events}){
  // Top integrado: micros con done/total >= 0.7, ordenados por ratio desc.
  const withRatio=(micros||[]).filter(m=>m.total>0).map(m=>({m,r:m.done/m.total}));
  const integrados=withRatio.filter(x=>x.r>=0.7).sort((a,b)=>b.r-a.r);
  const friccion=withRatio.filter(x=>x.r<0.4).sort((a,b)=>a.r-b.r);
  const topInt=integrados[0];
  const topFric=friccion[0];
  // Top pillar: max pct sobre pillarsMap.
  let topPillar=null;
  if(pillarsMap&&pillarsMap.pillars){
    let best=null,bestPct=-1;
    pillarsMap.pillars.forEach(p=>{
      let done=0,total=0;
      (p.micro_idxs||[]).forEach(i=>{const m=(micros||[])[i];if(m){done+=m.done;total+=(m.oppsSoFar||0);}});
      (p.commitment_idxs||[]).forEach(i=>{const c=(comps||[])[i];if(c){done+=c.done;total+=(c.oppsSoFar||0);}});
      const pct=total?done/total:0;
      if(pct>bestPct){bestPct=pct;best=p;}
    });
    topPillar=best;
  }
  // Energy top: agregamos checkin_complete events y nos quedamos con el más frecuente.
  const ciEvs=(events||[]).filter(e=>e.event_name==="checkin_complete");
  const epCount={},emCount={};
  ciEvs.forEach(e=>{
    const ep=(e.event_data||{}).energy_plus;
    const em=(e.event_data||{}).energy_minus;
    if(ep)epCount[ep]=(epCount[ep]||0)+1;
    if(em)emCount[em]=(emCount[em]||0)+1;
  });
  const sortEntries=(o)=>Object.entries(o).sort((a,b)=>b[1]-a[1]);
  const topEp=sortEntries(epCount)[0];
  const topEm=sortEntries(emCount)[0];

  if(!topInt&&!topFric&&!topPillar&&!topEp&&!topEm) return null;
  return(<div style={{background:T.bgCard,border:`1px solid ${T.oro}`,borderRadius:18,padding:"22px 20px",marginBottom:20,position:"relative",overflow:"hidden"}}>
    <span style={{position:"absolute",right:-20,top:-30,fontSize:160,color:T.oro,opacity:0.05,fontFamily:T.serif,lineHeight:1,pointerEvents:"none",userSelect:"none"}}>◇</span>
    <p style={{fontSize:10,letterSpacing:2.5,color:T.oro,textTransform:"uppercase",fontWeight:600,marginBottom:6}}>Hacia el Ciclo 2</p>
    <h3 style={{fontFamily:T.serif,fontSize:22,color:T.crema,fontWeight:400,marginBottom:14,lineHeight:1.1}}>Integrar</h3>
    <p style={{fontSize:12,fontFamily:T.serif,fontStyle:"italic",color:T.grisL,marginBottom:18,lineHeight:1.5}}>
      Ciclo 1 fue Resistir — hacer aparecer lo que no estaba.<br/>
      Ciclo 2 es Integrar — hacer convivir lo que ya está contigo.
    </p>
    <div style={{display:"flex",flexDirection:"column",gap:14}}>
      {topInt&&<div>
        <p style={{fontSize:10,letterSpacing:1.8,color:T.grisL,textTransform:"uppercase",marginBottom:3}}>📌 Lo que ya haces sin pensar</p>
        <p style={{fontSize:13,color:T.crema,fontFamily:T.serif,marginBottom:2}}>{topInt.m.title}</p>
        <p style={{fontSize:11,color:T.grisL,fontStyle:"italic"}}>→ en el Ciclo 2 se amplifica</p>
      </div>}
      {topFric&&<div>
        <p style={{fontSize:10,letterSpacing:1.8,color:T.grisL,textTransform:"uppercase",marginBottom:3}}>🔴 Lo que aún se resiste</p>
        <p style={{fontSize:13,color:T.crema,fontFamily:T.serif,marginBottom:2}}>{topFric.m.title}</p>
        <p style={{fontSize:11,color:T.grisL,fontStyle:"italic"}}>→ en el Ciclo 2 se enfrenta · escenografía nueva</p>
      </div>}
      {topPillar&&<div>
        <p style={{fontSize:10,letterSpacing:1.8,color:T.grisL,textTransform:"uppercase",marginBottom:3}}>💚 Donde más vives</p>
        <p style={{fontSize:13,color:T.crema,fontFamily:T.serif,marginBottom:2}}>{topPillar.title}</p>
        <p style={{fontSize:11,color:T.grisL,fontStyle:"italic"}}>→ en el Ciclo 2 se materializa · de práctica a estructura</p>
      </div>}
      {(topEp||topEm)&&<div style={{marginTop:6,paddingTop:14,borderTop:`1px solid ${T.gb}`}}>
        <p style={{fontSize:10,letterSpacing:1.8,color:T.grisL,textTransform:"uppercase",marginBottom:8}}>⚡ Tu lectura de energía</p>
        {topEp&&<p style={{fontSize:12,color:T.crema,marginBottom:4}}>Te dio energía: <span style={{color:T.oro}}>{topEp[0]}</span> {topEp[1]>1?`×${topEp[1]}`:""}</p>}
        {topEm&&<p style={{fontSize:12,color:T.crema}}>Te quitó energía: <span style={{color:T.coral||T.grisL}}>{topEm[0]}</span> {topEm[1]>1?`×${topEm[1]}`:""}</p>}
        <p style={{fontSize:11,color:T.grisL,fontStyle:"italic",marginTop:6}}>→ por dónde tirar · qué retirar</p>
      </div>}
    </div>
    <p style={{fontSize:11,color:T.grisL,marginTop:18,paddingTop:14,borderTop:`1px solid ${T.gb}`,lineHeight:1.5}}>
      No más motivación. Más precisión.
    </p>
  </div>);
}

// HeroPanel: la fachada del ciclo activo. Estructura:
//   2. Día/Semana en oro discreto.
//   3. Frase del objetivo (italic, serif).
//   4. Chips de stats: micros diarios · semanales · compromisos · check-ins X/posibles.
//   5. Pilares (cimientos) con barra y %.
function HeroPanel({name,obj,pillars,countdown,micros,comps,cd,wk,cdReal,isPreCycle,isPostCycle,startDate,events,weekly,calDays,checkins,sd}){
  // Cuando el ciclo está cerrado, computamos el cumplimiento agregado para mostrar
  // la cifra grande junto a la decisión del user (sigue/descansa/para). Reutiliza la
  // misma lógica que ProgressTable (computeCycleStats) → mismo número en todos lados.
  const cycleStats=isPostCycle?computeCycleStats({wk:5,cd:29,weekly,events,mcs:micros,comps,calDays,checkins,sd}):null;
  const decisionEv=isPostCycle?(events||[]).find(e=>e.event_name==="cycle_decision"):null;
  const decision=decisionEv?(decisionEv.event_data||{}).decision:null;
  const decisionMap={
    continue:{icon:"🌀",label:"Sigues",color:T.lima||T.oro},
    pause:{icon:"✂️",label:"Descansas",color:T.oro},
    stop:{icon:"🛑",label:"Paras",color:T.coral||T.grisL},
  };
  const dec=decision&&decisionMap[decision];
  // Countdown del LLM (Cimientos). Validamos en render: máx 28, sino null.
  const cdValid=countdown&&typeof countdown.days_from_today==="number"&&countdown.days_from_today>0&&countdown.days_from_today<=28?countdown:null;
  const daysToGoal=cdValid?Math.max(0,cdValid.days_from_today-(cd-1)):null;
  const daysToCycleEnd=Math.max(0,28-cd+1);
  // Pre/post-ciclo: en lugar de fingir "Día 1/28" usamos labels honestos.
  const daysToStart=isPreCycle?(1-cdReal):0;
  const daysSinceClose=isPostCycle?(cdReal-28):0;
  const startDateLbl=startDate?new Date(startDate).toLocaleDateString("es-ES",{day:"numeric",month:"long"}):"";
  // Countdowns por compromiso con deadline. m.dl ya viene calculado en parsed (días desde hoy).
  const compsCountdowns=(comps||[]).map(c=>({title:c.title,icon:c.icon,days:c.dl})).filter(c=>typeof c.days==="number"&&c.days>=0);
  // Pilares con progreso agregado de sus micros + compromisos.
  // (Antes había chips de stats Diarios/Semanales/Compromisos/Check-ins — quitados el 2-may
  // porque duplicaban info visible mejor en sus secciones; el hero queda más limpio.)
  const pillarsCalc=(pillars||[]).map(p=>{
    // Pilar = fundamento construido HASTA HOY: pillarDone/pillarOpps (opps hasta hoy incluido +
    // repeticiones reales del weekly_count) → un item a cero cuyo día es hoy arrastra el pilar,
    // no sale 100% ocultando lo no hecho. Mismo criterio que la sección Cimientos. (Vanessa 14-ago)
    let done=0,total=0;
    (p.micro_idxs||[]).forEach(i=>{const m=(micros||[])[i];if(m){done+=(m.pillarDone??m.done);total+=(m.pillarOpps??(m.oppsSoFar||0));}});
    (p.commitment_idxs||[]).forEach(i=>{const c=(comps||[])[i];if(c){done+=(c.pillarDone??c.done);total+=(c.pillarOpps??(c.oppsSoFar||0));}});
    const pct=total?Math.min(100,Math.round(done/total*100)):0;
    return{title:p.title,icon:p.icon||"",pct,total};
  });
  return(<div style={{background:T.bgCard,border:`1px solid ${T.gb}`,borderRadius:22,padding:"26px 22px 20px",marginBottom:20,position:"relative",overflow:"hidden"}}>
    {/* Glyph translúcido de fondo */}
    <span style={{position:"absolute",right:-26,top:-50,fontSize:220,color:T.oro,opacity:0.05,fontFamily:T.serif,lineHeight:1,pointerEvents:"none",userSelect:"none"}}>◇</span>

    {/* Header: nombre grande. El % de cumplimiento se calcula y se muestra por semana
        en "Mis semanas" — no aquí, para no mezclar definición (nombre/objetivo/cimientos)
        con evolución (% vivo). */}
    <h2 style={{fontFamily:T.serif,fontSize:"clamp(28px, 7vw, 42px)",fontWeight:400,color:T.crema,lineHeight:1.05,letterSpacing:-0.5,marginBottom:8,position:"relative"}}>{name}</h2>

    {/* Día/Semana + lista de countdowns: ciclo + LLM si aplica + uno por cada compromiso con deadline.
        Tres estados:
          - PRE-CICLO: el user eligió empezar mañana (o más tarde). Sin "Día N", solo cuenta atrás.
          - ACTIVO: día N/28, semana W, countdowns.
          - POST-CICLO: ciclo cerrado, días desde el cierre. */}
    <div style={{marginBottom:14,position:"relative"}}>
      {isPreCycle?(
        <p style={{fontSize:10,letterSpacing:2.5,color:T.oro,textTransform:"uppercase",fontWeight:500,marginBottom:8}}>El ciclo empieza pronto</p>
      ):isPostCycle?(
        <p style={{fontSize:10,letterSpacing:2.5,color:T.oro,textTransform:"uppercase",fontWeight:500,marginBottom:8}}>Ciclo cerrado</p>
      ):(
        <p style={{fontSize:10,letterSpacing:2.5,color:T.oro,textTransform:"uppercase",fontWeight:500,marginBottom:8}}>Día {Math.min(cd,28)}/28 · Semana {wk}</p>
      )}
      <div style={{display:"flex",flexDirection:"column",gap:4}}>
        {isPreCycle?(<>
          <p style={{fontSize:12,color:T.crema}}>
            <span style={{fontFamily:T.serif,fontSize:16,color:T.oro,marginRight:6}}>{daysToStart}</span>
            <span style={{color:T.grisL,fontSize:11}}>{daysToStart===1?"día para empezar":"días para empezar"}{startDateLbl?` · ${startDateLbl}`:""}</span>
          </p>
        </>):isPostCycle?(<>
          <p style={{fontSize:12,color:T.crema}}>
            <span style={{fontFamily:T.serif,fontSize:16,color:T.oro,marginRight:6}}>{daysSinceClose}</span>
            <span style={{color:T.grisL,fontSize:11}}>{daysSinceClose===1?"día desde el cierre":"días desde el cierre"}</span>
          </p>
          {/* Cifra grande del ciclo cerrado: cumplimiento total + decisión del user.
              Es la lectura definitiva — el header del dashboard cambia de "Día X/28"
              a "Cumplimiento X%" + el camino elegido. */}
          {cycleStats&&cycleStats.totalPct!==null&&<div style={{marginTop:12,paddingTop:14,borderTop:`1px solid ${T.gb}`}}>
            <p style={{fontSize:11,letterSpacing:2,color:T.grisL,textTransform:"uppercase",marginBottom:4}}>Constancia del ciclo</p>
            <p style={{fontFamily:T.serif,fontSize:42,color:T.oro,lineHeight:1,fontWeight:400}}>{cycleStats.totalPct}%</p>
            <p style={{fontSize:10,color:T.grisL,marginTop:6}}>
              Micros {cycleStats.microsPct??"—"}% · Check-ins {cycleStats.daysLived?Math.min(100,Math.round(cycleStats.dailyDays/cycleStats.daysLived*100)):"—"}%
            </p>
            {cycleStats.compsOpps>0&&<p style={{fontSize:11,color:T.crema,marginTop:8,fontWeight:500}}>
              Compromisos cerrados: <span style={{fontFamily:T.serif,color:cycleStats.compsDone===cycleStats.compsOpps?T.lima:(cycleStats.compsDone>0?T.oro:T.coral)}}>{cycleStats.compsDone}/{cycleStats.compsOpps}</span>
            </p>}
            {dec&&<p style={{fontSize:13,marginTop:12,color:T.crema}}>
              <span style={{fontFamily:T.serif,fontSize:18,marginRight:8}}>{dec.icon}</span>
              <span style={{color:dec.color,letterSpacing:1.5,textTransform:"uppercase",fontSize:11,fontWeight:600}}>{dec.label}</span>
              <span style={{color:T.grisL,fontSize:11,marginLeft:6}}>· lo que decidiste</span>
            </p>}
            <p style={{fontFamily:T.serif,fontStyle:"italic",fontSize:13,color:T.crema,marginTop:14,lineHeight:1.5,paddingTop:12,borderTop:`1px solid ${T.gb}`}}>
              Esto lo hiciste tú. El sistema solo te leyó.
            </p>
          </div>}
        </>):(<>
        <p style={{fontSize:12,color:T.crema}}>
          <span style={{fontFamily:T.serif,fontSize:16,color:T.oro,marginRight:6}}>{daysToCycleEnd}</span>
          <span style={{color:T.grisL,fontSize:11}}>días para cerrar el ciclo</span>
        </p>
        {daysToGoal!==null&&<p style={{fontSize:12,color:T.crema}}>
          <span style={{fontFamily:T.serif,fontSize:16,color:T.oro,marginRight:6}}>{daysToGoal}</span>
          <span style={{color:T.grisL,fontSize:11}}>días {cdValid.label||"para tu objetivo"}</span>
        </p>}
        {compsCountdowns.map((c,i)=>(<p key={i} style={{fontSize:12,color:T.crema}}>
          <span style={{fontFamily:T.serif,fontSize:16,color:c.days<=3?T.coral:T.oro,marginRight:6}}>{c.days}</span>
          <span style={{color:T.grisL,fontSize:11}}>días para {c.icon||""} {c.title}</span>
        </p>))}
        </>)}
      </div>
    </div>

    {/* Frase del objetivo */}
    {obj&&<p style={{fontSize:14,fontFamily:T.serif,fontStyle:"italic",lineHeight:1.5,color:T.crema,position:"relative",marginBottom:16,paddingBottom:16,borderBottom:`1px solid ${T.gb}`}}>"{obj}"</p>}

    {/* Teaser "Tu lectura" — banner compacto con título + momento + flecha al final del dashboard.
        Sin frase narrativa para que el hero quede limpio (la lectura completa vive
        en su sección al final del dashboard, scroll corto). Renombrado de "Opinión Antifrágil"
        a "Tu lectura" (13-may-2026) — refuerza que es trabajo del user, no opinión del sistema. */}
    {(()=>{
      const fr=(events||[]).find(e=>e.event_name==="final_reading");
      // Solo la lectura de CIERRE (week>=4). Las semanales viven en "Mis semanas", no aquí.
      const rag=(events||[]).filter(e=>e.event_name==="antifragil_opinion"&&((e.event_data||{}).week_number||0)>=4).sort((a,b)=>((b.event_data||{}).week_number||0)-((a.event_data||{}).week_number||0))[0];
      if(!fr&&!rag) return null;
      let momento="Baseline del ciclo";
      if(rag) momento="Cierre del ciclo · actualizada con tus datos";
      return(<a href="#antifragil-opinion" onClick={e=>{e.preventDefault();const el=document.getElementById("antifragil-opinion");if(el)el.scrollIntoView({behavior:"smooth",block:"start"});}} style={{display:"flex",alignItems:"center",gap:14,padding:"14px 16px",borderRadius:12,background:`linear-gradient(135deg, ${T.oroBg} 0%, rgba(201,168,76,0.04) 100%)`,border:`1px solid ${T.oroBorder}`,marginBottom:16,textDecoration:"none",cursor:"pointer",transition:"all 0.2s"}}>
        <span style={{fontSize:22,color:T.oro,fontFamily:T.serif,lineHeight:1,opacity:0.9}}>◇</span>
        <div style={{flex:1,minWidth:0}}>
          <p style={{fontSize:10,letterSpacing:2.2,color:T.oro,textTransform:"uppercase",fontWeight:600,marginBottom:2}}>Tu lectura</p>
          <p style={{fontSize:11,color:T.grisL,letterSpacing:0.3,whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{momento}</p>
        </div>
        <span style={{color:T.oro,fontSize:14,flexShrink:0,opacity:0.7}}>↓</span>
      </a>);
    })()}

    {/* Pilares (cimientos) — sin título: el contenido habla por sí mismo */}
    {pillarsCalc.length>0?<div style={{position:"relative"}}>
      <div style={{display:"flex",flexDirection:"column",gap:9}}>
        {pillarsCalc.map((p,i)=>{const col=p.pct>=70?T.lima:p.pct>=40?T.oro:p.total>0?T.coral:T.grisL;return(
          <div key={i} style={{display:"flex",alignItems:"center",gap:10}}>
            <span style={{fontSize:14,minWidth:18,textAlign:"center"}}>{p.icon}</span>
            <span style={{fontSize:12,color:T.crema,flex:1,fontWeight:400}}>{p.title}</span>
            <div style={{width:54,height:4,background:"rgba(255,255,255,0.05)",borderRadius:2,overflow:"hidden"}}>
              <div style={{width:`${p.pct}%`,height:"100%",background:col,transition:"width 0.4s"}}/>
            </div>
            <span style={{fontFamily:T.serif,fontSize:15,color:col,fontWeight:500,minWidth:38,textAlign:"right",lineHeight:1}}>{p.pct}<span style={{fontSize:10,color:T.grisL}}>%</span></span>
          </div>
        );})}
      </div>
    </div>:<p style={{fontSize:11,color:T.grisL,fontStyle:"italic",position:"relative"}}>Tus cimientos se están preparando…</p>}{/* Internamente "tus cimientos" — texto en plural personal */}
  </div>);
}

// CycleArc: las 4 fases del primer arco como pills horizontales + panel del seleccionado.
// El user empieza en ciclo 1 (Resistir) y va recorriendo los 4. Cycle_number 5+ vuelve
// a empezar el arco — por ahora MVP solo cubre cycles 1-4 (siguiente arco es feature later).
// P3=b: ciclos futuros muestran descripción narrativa pre-canned, sin promesa de fechas.
// Lifted state: el padre controla `selected` para que pueda propagarlo al resto del dashboard
// (al seleccionar un ciclo distinto al activo, las secciones de abajo muestran teasers vacíos).
function CycleArc({cycleNum,selected,onSelect}){
  const cn=cycleNum||1;
  const sel=selected||cn;
  const selPhase=CYCLE_PHASES[(sel-1)%4]||CYCLE_PHASES[0];
  const isActive=sel===cn;
  const isPast=sel<cn;
  // Definición colapsable — abierta por default, se puede contraer.
  const[defOpen,setDefOpen]=useState(true);
  return(<div style={{marginBottom:32}}>
    {/* PILLS */}
    <div style={{display:"flex",gap:6,marginBottom:14,justifyContent:"space-between"}}>
      {CYCLE_PHASES.map((p,i)=>{
        const num=i+1;
        const act=num===cn,past=num<cn,fut=num>cn,thisSel=num===sel;
        const bg=act?T.oroSoft||"rgba(212,175,55,0.15)":past?"rgba(255,255,255,0.05)":"transparent";
        const border=thisSel?`1px solid ${T.oro}`:`1px solid ${T.glassBorder||"rgba(255,255,255,0.08)"}`;
        const op=fut&&!thisSel?0.45:1;
        return<button key={num} onClick={()=>onSelect&&onSelect(num)} style={{flex:1,background:bg,border,borderRadius:8,padding:"8px 4px",cursor:"pointer",opacity:op,fontFamily:T.font,color:T.crema,transition:"opacity 0.2s, border 0.2s"}}>
          <div style={{fontSize:9,letterSpacing:1.5,color:act?T.oro:T.grisL,marginBottom:2,textTransform:"uppercase"}}>Ciclo {num}</div>
          <div style={{fontSize:11,fontWeight:act?500:400,color:T.crema}}>{p.n}</div>
          <div style={{fontSize:8,color:T.grisL,marginTop:2,letterSpacing:1}}>{act?"AHORA":past?"CERRADO":"PRÓXIMO"}</div>
        </button>;
      })}
    </div>
    {/* PANEL del seleccionado — definición del ciclo. Header clicable para contraer. */}
    <Card style={{borderColor:isActive?T.oro:undefined,borderWidth:isActive?1:undefined,borderStyle:isActive?"solid":undefined}}>
      <button onClick={()=>setDefOpen(!defOpen)} style={{width:"100%",background:"none",border:"none",padding:0,cursor:"pointer",fontFamily:T.font,textAlign:"left",display:"flex",justifyContent:"space-between",alignItems:"baseline"}}>
        <p style={{fontSize:10,letterSpacing:2,color:T.oro,textTransform:"uppercase",fontWeight:500}}>Ciclo {sel} · {selPhase.n}</p>
        <div style={{display:"flex",alignItems:"baseline",gap:10}}>
          {isPast&&<span style={{fontSize:10,color:T.grisL,letterSpacing:1.5,textTransform:"uppercase"}}>Cerrado</span>}
          {!isActive&&!isPast&&<span style={{fontSize:10,color:T.grisL,letterSpacing:1.5,textTransform:"uppercase"}}>Próximo</span>}
          <span style={{fontSize:14,color:T.oro,transform:defOpen?"rotate(90deg)":"rotate(0deg)",transition:"transform 0.2s",lineHeight:1}}>›</span>
        </div>
      </button>
      {defOpen&&<div style={{marginTop:10}}>
        {selPhase.headline&&<p style={{fontSize:14,color:T.crema,fontWeight:500,lineHeight:1.5,marginBottom:10,fontFamily:T.serif,fontStyle:"italic"}}>{selPhase.headline}</p>}
        {selPhase.desc?selPhase.desc.split("\n\n").map((para,i)=>(
          <p key={i} style={{fontSize:12,color:T.grisL,lineHeight:1.55,marginBottom:8}}>{para}</p>
        )):(!isActive&&<p style={{fontSize:11,color:T.gris,fontStyle:"italic"}}>Bloqueado.</p>)}
        {isPast&&!selPhase.desc&&<p style={{fontSize:11,color:T.grisL,marginTop:6}}>Datos del cierre disponibles cuando completes este flujo de prueba.</p>}
      </div>}
    </Card>
  </div>);
}

// Cuando el user selecciona un ciclo distinto al activo en el CycleArc, mostramos teasers
// vacíos en lugar del contenido del activo. La descripción del ciclo NO se repite aquí
// — ya la muestra el panel del CycleArc arriba. Aquí solo el aviso de bloqueo + lista
// de secciones que verá cuando llegue.
function CycleTeaser({num,phase,isPast}){
  const sections = [
    {title:"Tu objetivo", desc:"El objetivo de 28 días que escojas para este ciclo."},
    {title:"Quién soy", desc:"Tu mapa de personalidad y vital, actualizado al inicio del ciclo."},
    {title:"Compromisos", desc:"Las apuestas verificables del ciclo."},
    {title:"Mis micro-cambios", desc:"Las acciones que harás cada día."},
    {title:"Tus cimientos", desc:"Los pilares que conectan tu trabajo diario con el objetivo."},
    {title:"Mi progreso", desc:"Tu cumplimiento, racha y patrón de energía."},
    {title:"Mi espacio", desc:"Diario abierto del ciclo y recursos que recibirás."},
    {title:"Mis semanas", desc:"El cierre de cada una de las 4 semanas."},
  ];
  return(<>
    <Card style={{borderColor:T.gb}}>
      <p style={{fontSize:11,color:T.grisL,fontStyle:"italic",lineHeight:1.5}}>
        {isPast?"Cerrado. El detalle del cierre estará disponible cuando completes este flujo.":"🔒 Aún por desbloquear. Llegarás aquí cuando cierres el ciclo anterior."}
      </p>
    </Card>
    <Div/>
    {sections.map((s,i)=>(<div key={i} style={{marginBottom:18,opacity:0.4}}>
      <p style={{fontSize:11,letterSpacing:2,color:T.grisL,textTransform:"uppercase",marginBottom:6}}>{s.title}</p>
      <p style={{fontSize:11,color:T.gris,lineHeight:1.4}}>{s.desc}</p>
    </div>))}
  </>);
}

function Cimientos({pillars,countdown,objetivo,micros,comps,message,cd,events}){
  // Benefits que el user ha reportado por micro (events.micro_benefit) — agregados por título.
  // Estructura del evento: {micro_title, benefit, tag}.
  const benefitsByTitle={};
  (events||[]).filter(e=>e.event_name==="micro_benefit").forEach(e=>{
    const d=e.event_data||{};
    const t=d.micro_title||"";
    const b=d.benefit||"";
    if(!t||!b) return;
    if(!benefitsByTitle[t]) benefitsByTitle[t]={};
    benefitsByTitle[t][b]=(benefitsByTitle[t][b]||0)+1;
  });
  // Notas de avance del weekly review por título — quedamos con la más reciente.
  // Estructura del evento: {week_number, notes: {title: nota}}.
  const notesByTitle={};
  (events||[]).filter(e=>e.event_name==="weekly_avance_notes").sort((a,b)=>{
    return (a.created_at||"").localeCompare(b.created_at||"");
  }).forEach(e=>{
    const ns=(e.event_data||{}).notes||{};
    Object.entries(ns).forEach(([t,n])=>{notesByTitle[t]=n;});
  });
  // Si no hay pillars_map (todavía generándose o falló), fallback claro
  if(!pillars||!pillars.length){
    return<Card><p style={{fontSize:11,color:T.grisL,lineHeight:1.5}}>Estamos preparando tus cimientos. Vuelve en un minuto y refresca.</p></Card>;
  }

  // Dado un array de items {name, ratio, done, total, type}, decidir su estado
  const stateOf=(ratio)=>ratio>=0.7?{l:"Integrado",c:T.verde}:ratio>=0.4?{l:"En proceso",c:T.oro}:{l:"Fricción",c:T.rojo};

  // Para cada pillar, agregar items (micros + compromisos) y calcular ratio
  const pillarsCalc=pillars.map(p=>{
    const items=[];
    let totalDone=0,totalAll=0;
    (p.micro_idxs||[]).forEach(idx=>{
      const m=micros[idx];
      if(!m) return;
      // Pilar = fundamento construido HASTA HOY: pillarDone/pillarOpps (opps hasta hoy incluido +
      // repeticiones reales del weekly_count). Un item a cero cuyo día es hoy arrastra; el
      // weekly_count hecho ya NO sale "Aún sin datos". El 'total' visible sigue siendo el ciclo.
      const _pd=m.pillarDone??m.done, _po=m.pillarOpps??(m.oppsSoFar||0);
      items.push({
        title:m.title,
        icon:m.icon||"",
        done:_pd,
        total:m.total,
        oppsSoFar:_po,
        pastOpps:m.oppsSoFar||0,  // opps PASADAS (sin hoy) → distinguir "hoy pendiente" de "no cumplido"
        ratio:_po?_pd/_po:0,
        cat:m.cat?.l||"",
        type:"micro",
      });
      totalDone+=_pd;totalAll+=_po;
    });
    (p.commitment_idxs||[]).forEach(idx=>{
      const c=comps[idx];
      if(!c) return;
      const dlText=c.dl===null?"Sin fecha":c.dl<0?"Vencido":c.dl===0?"Hoy":`${c.dl}d`;
      const _cd2=c.pillarDone??c.done, _co=c.pillarOpps??(c.oppsSoFar||0);
      const isDone=_cd2>0;
      items.push({
        title:c.title,
        icon:c.icon||"",
        done:_cd2,
        total:c.total,
        oppsSoFar:_co,
        ratio:_co?_cd2/_co:(isDone?1:0),
        cat:"Compromiso",
        type:"commitment",
        dlText,
        pendingState:isDone?"Hecho":(c.dl!==null&&c.dl<=2?"Urgente":"Pendiente"),
      });
      totalDone+=_cd2;totalAll+=_co;
    });
    const ratio=totalAll?totalDone/totalAll:0;
    return{...p,items,ratio,totalDone,totalAll,pct:Math.min(100,Math.round(ratio*100))};
  });

  const barColor=(pct)=>pct>=70?T.verde:pct>=40?T.oro:T.rojo;

  return<>
    {/* Mensaje semanal en lenguaje natural — resumen de los cimientos al inicio.
        Es el contexto narrativo que da sentido a las barras de abajo. El objetivo no se
        repite aquí (vive en su propia sección "Mi objetivo" del bloque RETO). */}
    {message&&<Card gold style={{marginBottom:14,padding:"14px 16px"}}>
      <p style={{fontSize:11,color:T.crema,lineHeight:1.55,fontWeight:400}}>{message}</p>
    </Card>}

    {/* Base del %: sobre el ciclo entero (28 días), no sobre lo que llevas. Por eso al principio sale
        bajo — el fundamento se construye a lo largo del ciclo. Se aclara para que el número se entienda. */}
    {pillarsCalc.length>0&&<p style={{fontSize:10,color:T.gris,fontStyle:"italic",marginBottom:12}}>El % es sobre el ciclo de 28 días — sube según lo vas construyendo.</p>}

    {/* Pilares */}
    {pillarsCalc.map((p,i)=>{
      // Sin ningún check-in en el pilar → neutro (gris, "—"), no 0% rojo. No dramatizar el arranque.
      const hasData=p.totalAll>0;
      const col=hasData?barColor(p.pct):T.gb;
      // G9 — agregar feedback del user (benefits + última nota) de los micros del pilar.
      const titlesInPillar=p.items.map(it=>it.title);
      const benefitCounts={};
      titlesInPillar.forEach(t=>{
        const bs=benefitsByTitle[t]||{};
        Object.entries(bs).forEach(([b,c])=>{benefitCounts[b]=(benefitCounts[b]||0)+c;});
      });
      const topBenefits=Object.entries(benefitCounts).sort((a,b)=>b[1]-a[1]).slice(0,3).map(([b])=>b);
      const pillarNotes=titlesInPillar.map(t=>notesByTitle[t]).filter(Boolean).slice(-2);
      const hasFeedback=topBenefits.length>0||pillarNotes.length>0;
      return<Card key={i} style={{marginBottom:12}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"baseline",marginBottom:6}}>
          <span style={{fontSize:14,fontWeight:500,color:T.crema}}>{p.icon} {p.title}</span>
          <span style={{fontSize:18,fontWeight:500,color:hasData?col:T.grisL,fontFamily:T.serif}}>{hasData?`${p.pct}%`:"—"}</span>
        </div>
        <div style={{height:5,background:"rgba(255,255,255,0.05)",borderRadius:2,overflow:"hidden",marginBottom:p.description?6:10}}>
          <div style={{height:"100%",width:`${p.pct}%`,background:col,borderRadius:2,transition:"width .4s"}}/>
        </div>
        {p.description&&<p style={{fontSize:10,color:T.gris,lineHeight:1.4,marginBottom:10,fontStyle:"italic"}}>{p.description}</p>}
        {p.items.map((it,j)=>{
          // Micros con done==0 y oportunidades (total>0): destacar "Pendiente N días" en rojo
          // — más informativo que "Fricción · 0/N", deja claro que el micro no se ha tocado.
          // Etiqueta del item = progreso del CICLO (done/total). NO se colorea en rojo por ir bajo al
          // principio (2/8 al día 7 no es "fricción", es ir a ritmo). Solo rojo si hubo días pasados
          // que aplicaron y NO se hizo nada. Verde si ya está completo el objetivo del ciclo.
          let itemCol,itemLabel;
          if(it.type==="commitment"&&it.total>1){
            // Compromiso RECURRENTE (cada semana): progreso del ciclo como un micro. "Hecho" tras 1
            // de 4 sería contradictorio → mostramos X/Y.
            if(it.done>=it.total){itemCol=T.verde;itemLabel=`Completo · ${it.done}/${it.total}`;}
            else if(it.done>0){itemCol=T.crema;itemLabel=`${it.done}/${it.total}`;}
            else{itemCol=it.pendingState==="Urgente"?T.coral:T.oro;itemLabel=`Pendiente · 0/${it.total}`;}
          } else if(it.type==="commitment"){
            // Compromiso de un solo hito (con deadline): estado por fecha.
            itemCol=it.pendingState==="Hecho"?T.verde:it.pendingState==="Urgente"?T.coral:T.oro;
            itemLabel=it.pendingState==="Hecho"?"Hecho":`${it.pendingState} · ${it.dlText}`;
          } else if(!it.total){
            itemCol=T.grisL; itemLabel="Aún sin datos";
          } else if(it.done>=it.total){
            itemCol=T.verde; itemLabel=`Completo · ${it.done}/${it.total}`;
          } else if(it.done>0){
            // Progreso del ciclo, neutro (crema) — va construyéndose, ni verde ni rojo.
            itemCol=T.crema; itemLabel=`${it.done}/${it.total}`;
          } else if(it.pastOpps>0){
            // Días pasados que aplicaban sin hacer nada → no empezado, fricción real.
            itemCol=T.coral; itemLabel=`Sin empezar · 0/${it.total}`;
          } else {
            // Aún no ha tenido una oportunidad pasada (su día es hoy o aún no llega).
            itemCol=T.oro; itemLabel=`Aún sin empezar · 0/${it.total}`;
          }
          return<div key={j} style={{display:"flex",justifyContent:"space-between",alignItems:"center",fontSize:11,padding:"4px 0",borderBottom:j<p.items.length-1?`1px solid ${T.gb}`:"none"}}>
            <span style={{color:T.grisL,flex:1}}><span style={{marginRight:5}}>{it.icon}</span>{it.title.length>34?it.title.slice(0,33)+"…":it.title}</span>
            <span style={{color:itemCol,fontSize:10,fontWeight:500,marginLeft:8,whiteSpace:"nowrap"}}>{itemLabel}</span>
          </div>;
        })}
        {hasFeedback&&<div style={{marginTop:10,padding:"10px 12px",background:"rgba(201,168,76,0.04)",borderRadius:8}}>
          <p style={{fontSize:9,letterSpacing:1,color:T.oro,textTransform:"uppercase",marginBottom:6}}>Tu lectura</p>
          {topBenefits.length>0&&<p style={{fontSize:11,color:T.grisL,lineHeight:1.5}}><span style={{color:T.crema,fontWeight:500}}>Te ayuda:</span> {topBenefits.join(" · ")}</p>}
          {pillarNotes.map((n,k)=>(<p key={k} style={{fontSize:11,color:T.grisL,marginTop:4,fontStyle:"italic"}}>"{n}"</p>))}
          {p.pct<50&&topBenefits.length>0&&<p style={{fontSize:10,color:T.oro,fontStyle:"italic",marginTop:6}}>Lo dijiste, pero estás al {p.pct}%. Ahí hay datos para mirar.</p>}
        </div>}
      </Card>;
    })}
  </>;
}

function Cats({micros}){
  const agg={};
  micros.forEach(m=>{
    const k=m.cat?.l||"—";
    if(!agg[k]) agg[k]={label:k,color:m.cat?.c||T.grisL,done:0,total:0};
    agg[k].done+=m.done;agg[k].total+=m.total;
  });
  const cats=Object.values(agg).filter(c=>c.total>0).map(c=>({...c,ratio:c.done/c.total}));
  if(!cats.length) return <Card><p style={{fontSize:11,color:T.grisL}}>Aún no hay datos suficientes — vuelve después de unos check-ins.</p></Card>;
  cats.sort((a,b)=>b.ratio-a.ratio);
  const top=cats[0],bottom=cats[cats.length-1];
  return<Card>
    {cats.map(c=>{const pct=Math.round(c.ratio*100);return<div key={c.label} style={{marginBottom:10}}>
      <div style={{display:"flex",justifyContent:"space-between",fontSize:11,marginBottom:4}}>
        <span style={{color:c.color,fontWeight:500}}>{c.label}</span>
        <span style={{color:T.grisL}}>{c.done}/{c.total} · {pct}%</span>
      </div>
      <div style={{height:5,background:"rgba(255,255,255,0.04)",borderRadius:2,overflow:"hidden"}}>
        <div style={{height:"100%",width:`${pct}%`,background:c.color,borderRadius:2,transition:"width .4s"}}/>
      </div>
    </div>;})}
    {cats.length>=3&&<p style={{fontSize:11,color:T.grisL,marginTop:14,lineHeight:1.6}}>
      Lo que más mueves: <span style={{color:top.color,fontWeight:500}}>{top.label}</span>.<br/>
      Lo que aún se resiste: <span style={{color:bottom.color,fontWeight:500}}>{bottom.label}</span>.
    </p>}
  </Card>;
}

function Cim({board,micros}){
  if(!board.length){
    const pct=micros.length?Math.round(micros.reduce((s,m)=>s+m.pct,0)/micros.length):0;
    const col=pct>=70?T.verde:pct>=40?T.oro:T.rojo;
    return<Card><div style={{display:"flex",justifyContent:"space-between",marginBottom:8}}><span style={{fontSize:13,fontWeight:500}}>Tu programa</span><span style={{fontSize:18,fontWeight:500,color:col}}>{pct}%</span></div>
      <div style={{height:4,background:"rgba(255,255,255,0.05)",borderRadius:2,marginBottom:10}}><div style={{height:4,width:`${pct}%`,background:col,borderRadius:2}}/></div>
      {micros.map(m=><MR key={m.id} m={m}/>)}
    </Card>;
  }
  const chunk=Math.max(1,Math.ceil(micros.length/board.length));
  return<>{board.map((b,i)=>{
    const title=typeof b==="string"?b:b.title||b.text||`Pilar ${i+1}`;
    const pm=micros.slice(i*chunk,(i+1)*chunk);
    const done=pm.reduce((s,m)=>s+m.done,0);const total=pm.reduce((s,m)=>s+m.total,0)||1;
    const pct=Math.round(done/total*100);const col=pct>=70?T.verde:pct>=40?T.oro:T.rojo;
    return<Card key={i} style={{marginBottom:10}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
        <span style={{fontSize:13,fontWeight:500}}>{title}</span>
        <span style={{fontSize:18,fontWeight:500,color:col}}>{pct}%</span>
      </div>
      <div style={{height:4,background:"rgba(255,255,255,0.05)",borderRadius:2,marginBottom:10}}><div style={{height:4,width:`${pct}%`,background:col,borderRadius:2}}/></div>
      {pm.map(m=><MR key={m.id} m={m}/>)}
    </Card>;
  })}</>;
}
function MR({m}){const col=m.pct>=70?T.verde:m.pct>=40?T.oro:T.rojo;const lb=m.pct>=70?"Integrado":m.pct>=40?"Proceso":"Fricción";
  return<div style={{display:"flex",justifyContent:"space-between",fontSize:12,padding:"5px 0",borderBottom:`1px solid ${T.gb}`}}>
    <span style={{color:T.grisL}}>{m.icon} {(m.title||"").slice(0,30)}</span>
    <span style={{fontWeight:500,fontSize:11,color:col}}>{lb} · {m.done}/{m.total}</span>
  </div>;
}

// UserCalendarView — el calendario que el user configuró en el onboarding (sin interactividad).
// Replica visualmente el grid 28 días del CalendarStep (App.jsx): colores por day_type +
// leyenda de tipos presentes. Día actual destacado con borde oro.
function UserCalendarView({calDays,cd,daySchedules}){
  if(!calDays||!calDays.length){
    return<Card><p style={{fontSize:11,color:T.grisL,fontStyle:"italic"}}>Aún no tienes calendario cargado.</p></Card>;
  }
  // calDays ya viene normalizado (day_type "day_off"→"dayoff") desde el origen.
  // Parse defensivo de daySchedules: el snapshot puede llegar como string JSON o como objeto.
  const sch=(()=>{if(!daySchedules)return null;if(typeof daySchedules==="string"){try{return JSON.parse(daySchedules);}catch(e){return null;}}return daySchedules;})();
  const lb=["L","M","X","J","V","S","D"];
  const f=new Date(((calDays[0]||{}).calendar_date||"")+"T00:00:00");
  const sw=Number.isFinite(f.getTime())?(f.getDay()+6)%7:0;
  const MO=["Ene","Feb","Mar","Abr","May","Jun","Jul","Ago","Sep","Oct","Nov","Dic"];
  // Paleta exacta del onboarding (App.jsx:973): [bg, border, fg].
  const COLORS={
    workday:["rgba(201,168,76,0.15)","rgba(201,168,76,0.35)","#c9a84c"],
    dayoff:["rgba(255,255,255,0.06)","rgba(255,255,255,0.12)","#9e9790"],
    vacation:["rgba(39,174,96,0.18)","rgba(39,174,96,0.4)","#27ae60"],
    special:["rgba(52,152,219,0.18)","rgba(52,152,219,0.4)","#3498db"],
    work_am:["rgba(241,196,15,0.15)","rgba(241,196,15,0.35)","#f1c40f"],
    work_pm:["rgba(230,126,34,0.15)","rgba(230,126,34,0.35)","#e67e22"],
    work_night:["rgba(155,89,182,0.15)","rgba(155,89,182,0.35)","#9b59b6"],
  };
  const LBL={workday:"laboral",dayoff:"libre",vacation:"vacaciones",special:"especial",work_am:"mañana",work_pm:"tarde",work_night:"noche"};
  // Solo mostrar tipos que el user tiene en el ciclo
  const typesPresent=Array.from(new Set(calDays.map(d=>d.day_type))).filter(t=>COLORS[t]);
  return<Card>
    {/* Leyenda — solo tipos presentes */}
    <div style={{display:"flex",gap:10,flexWrap:"wrap",marginBottom:12}}>
      {typesPresent.map(t=>{const c=COLORS[t];return<span key={t} style={{display:"flex",alignItems:"center",gap:5,fontSize:10,color:T.crema}}>
        <span style={{width:10,height:10,borderRadius:3,background:c[2]}}/>{LBL[t]||t}
      </span>;})}
    </div>
    {/* Header L M X J V S D */}
    <div style={{display:"grid",gridTemplateColumns:"repeat(7,1fr)",gap:3,marginBottom:3}}>
      {lb.map(d=><span key={d} style={{textAlign:"center",fontSize:10,color:T.gris,padding:3}}>{d}</span>)}
    </div>
    {/* Grid 28 días */}
    <div style={{display:"grid",gridTemplateColumns:"repeat(7,1fr)",gap:3}}>
      {Array(sw).fill(null).map((_,i)=><div key={`p${i}`} style={{height:50}}/>)}
      {calDays.map(d=>{
        const c=COLORS[d.day_type]||COLORS.workday;
        const today=d.cycle_day===cd;
        const dt=new Date(d.calendar_date);
        const down=d.bot_down;                 // día caído del bot (infra) — no cuenta
        const recov=d.cycle_day>28;            // día de recuperación (Parte 2) — replica un día caído
        return<div key={d.cycle_day} style={{height:50,borderRadius:6,border:today?`1.5px solid ${T.oro}`:down?`1px dashed ${T.coral}`:`1px solid ${c[1]}`,background:down?"rgba(255,107,74,.08)":c[0],color:down?T.coral:c[2],fontSize:10,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}}>
          <span style={{fontWeight:500,fontSize:12}}>{dt.getDate()}</span>
          <span style={{fontSize:8,opacity:0.7}}>{MO[dt.getMonth()]}</span>
          <span style={{fontSize:8}}>{down?"⚡ caído":recov?`↻ ${LBL[d.day_type]||d.day_type}`:(LBL[d.day_type]||d.day_type)}</span>
        </div>;
      })}
    </div>
    <p style={{fontSize:10,color:T.gris,marginTop:8,fontStyle:"italic"}}>El calendario que configuraste al empezar. El día actual destacado en oro.{calDays.some(d=>d.bot_down)?" ⚡ = el sistema se cayó ese día (no cuenta). ↻ = día de recuperación: te devolvemos el día perdido.":""}</p>
    {/* Horarios consensuados por tipo de día — mismo paso 3 del onboarding (CalendarStep). */}
    {sch&&(()=>{
      // typesPresent ya está definido arriba — sólo mostramos los tipos que el user tiene en el ciclo.
      const FIELDS={
        workday:{label:"🏢 Día laboral",f:[["wk_wake","Me levanto"],["wk_start","Empiezo trabajo"],["wk_end","Termino"],["wk_sleep","Me acuesto"]]},
        work_am:{label:"🌅 Turno mañana",f:[["am_wake","Me levanto"],["am_start","Empiezo"],["am_end","Termino"],["am_sleep","Me acuesto"]]},
        work_pm:{label:"☀️ Turno tarde",f:[["pm_wake","Me levanto"],["pm_start","Empiezo"],["pm_end","Termino"],["pm_sleep","Me acuesto"]]},
        work_night:{label:"🌙 Turno noche",f:[["nt_wake","Me levanto"],["nt_start","Empiezo"],["nt_end","Termino"],["nt_sleep","Me acuesto"]]},
        dayoff:{label:"🛋️ Día libre",f:[["do_wake","Me levanto"],["do_sleep","Me acuesto"]]},
        vacation:{label:"🏖️ Vacaciones",f:[["vc_wake","Me levanto"],["vc_sleep","Me acuesto"]]},
        special:{label:"⭐ Día especial",f:[["sp_wake","Me levanto"],["sp_sleep","Me acuesto"]]},
      };
      const counts={};calDays.forEach(d=>{counts[d.day_type]=(counts[d.day_type]||0)+1;});
      const blocks=typesPresent.filter(t=>FIELDS[t]).map(t=>({t,...FIELDS[t],cnt:counts[t]||0}));
      if(!blocks.length) return null;
      return<div style={{marginTop:18,paddingTop:14,borderTop:`1px solid ${T.gb}`}}>
        <p style={{fontSize:10,color:T.oro,letterSpacing:2,textTransform:"uppercase",marginBottom:10}}>Tus horarios consensuados</p>
        {blocks.map(b=>(<div key={b.t} style={{marginBottom:14}}>
          <p style={{fontSize:12,color:T.crema,fontWeight:500,marginBottom:6}}>{b.label} <span style={{color:T.grisL,fontSize:10,fontWeight:400}}>· {b.cnt} día{b.cnt!==1?"s":""}</span></p>
          {b.f.map(([k,l])=>{const v=sch[k]||"—";return<div key={k} style={{display:"flex",justifyContent:"space-between",fontSize:11,padding:"3px 0"}}>
            <span style={{color:T.grisL}}>{l}</span>
            <span style={{color:T.crema,fontFamily:T.serif}}>{v}</span>
          </div>;})}
        </div>))}
      </div>;
    })()}
  </Card>;
}

function Cal({calDays,cd,ciByDay,moodByDay}){
  const lb=["L","M","X","J","V","S","D"];
  const f=calDays[0]?new Date((calDays[0].calendar_date||"")+"T00:00:00"):new Date();
  const sw=Number.isFinite(f.getTime())?(f.getDay()+6)%7:0;
  return<><div style={{display:"grid",gridTemplateColumns:"repeat(7,1fr)",gap:3,marginBottom:3}}>
    {lb.map(d=><span key={d} style={{textAlign:"center",fontSize:9,color:T.grisL}}>{d}</span>)}
  </div>
  <div style={{display:"grid",gridTemplateColumns:"repeat(7,1fr)",gap:3}}>
    {Array(sw).fill(null).map((_,i)=><div key={`e${i}`}/>)}
    {calDays.map(d=>{
      const today=d.cycle_day===cd;const done=ciByDay[d.cycle_day];const work=d.day_type==="workday";const past=d.cycle_day<cd;
      const mood=(moodByDay||{})[d.cycle_day];
      const emoji=mood?MOOD_EMOJI[mood]:null;
      return<div key={d.cycle_day} style={{textAlign:"center",padding:"5px 2px",borderRadius:6,fontSize:10,minHeight:36,
        background:work?"rgba(201,168,76,0.06)":"rgba(255,255,255,0.02)",
        border:today?`1.5px solid ${T.oro}`:"1.5px solid transparent"}}>
        <div style={{fontWeight:500,color:done?T.crema:past?T.grisL:T.crema,fontSize:10}}>{new Date(d.calendar_date).getDate()}</div>
        {emoji&&<div style={{fontSize:14,lineHeight:1,marginTop:2}}>{emoji}</div>}
      </div>;
    })}
  </div>
  <div style={{display:"flex",gap:10,marginTop:10,fontSize:9,color:T.grisL,flexWrap:"wrap"}}>
    <span style={{display:"flex",alignItems:"center",gap:4}}><span style={{width:7,height:7,borderRadius:2,background:"rgba(201,168,76,0.06)",border:`1px solid ${T.gb}`}}/> Laboral</span>
    <span style={{display:"flex",alignItems:"center",gap:4}}><span style={{width:7,height:7,borderRadius:2,background:"rgba(255,255,255,0.02)",border:`1px solid ${T.gb}`}}/> Libre</span>
    <span style={{display:"flex",alignItems:"center",gap:4}}><span style={{width:7,height:7,borderRadius:2,border:`1.5px solid ${T.oro}`}}/> Hoy</span>
    <span style={{color:T.grisL}}>· 🔥 mucha · 💪 con energía · 😐 normal · 😶 floja</span>
  </div></>;
}

// MicrosEvolution — 28 mini-barras (1 por día del ciclo). Altura = % de micros cumplidos
// ese día (done/oportunidades reales). Color: lima ≥70 · oro 40-69 · coral <40 · gris si futuro/off.
// 5-jun: total = oportunidades del pattern (calendar + day_type) — antes solo contaba filas de
// checkin existentes, así que si el user respondía solo a 1 micro de 5 salía 100% verde siempre.
function MicrosEvolution({checkins,mcs,cd,cycleStart,calDays,sd}){
  const dailyMicros=(mcs||[]).filter(m=>{const meta=m.meta||{};const pat=meta.pattern||null;if(pat==="weekly_count")return false;if(meta.frequency==="semanal")return false;return true;});
  if(!dailyMicros.length) return <p style={{fontSize:11,color:T.gris,fontStyle:"italic"}}>Aún sin datos de micros.</p>;
  const dayOf=(c)=>{
    if(c.cycle_day) return c.cycle_day;
    if(!cycleStart||!c.checked_at) return null;
    const dt=new Date(c.checked_at);const sdLocal=new Date(cycleStart);
    return Math.floor((dt-sdLocal)/86400000)+1;
  };
  // Done por día (dedup por mid,day — API ordena por checked_at desc).
  const dailyMicroIds=new Set(dailyMicros.map(m=>m.id));
  const doneByDay={};
  const answeredByDay={};
  const seen=new Set();
  (checkins||[]).forEach(c=>{
    if(!dailyMicroIds.has(c.micro_change_id)) return;
    const day=dayOf(c);if(!day||day<1||day>cd||day>28) return;
    const key=`${c.micro_change_id}|${day}`;
    if(seen.has(key)) return;
    seen.add(key);
    answeredByDay[day]=(answeredByDay[day]||0)+1;
    if(c.completed) doneByDay[day]=(doneByDay[day]||0)+1;
  });
  // Total por día = nº de micros que APLICAN ese día según pattern + calendar.
  // Día 13 y day_type=special → 0 oportunidades (no penalizan).
  const dtByDay={};(calDays||[]).forEach(d=>{if(d.cycle_day!=null)dtByDay[d.cycle_day]=d.day_type;});
  const sdRef=sd||(cycleStart?new Date(cycleStart):new Date());
  const _dow=(day)=>((((sdRef.getDay()+6)%7)+(day-1))%7)+1; // getDay Dom=0 -> Lun=0 como el bot
  const microApplies=(m,day)=>{
    if(day===13) return false;
    const dt=dtByDay[day]||"workday";
    if(dt==="special") return false;
    const effDt=dt==="vacation"?"dayoff":dt;
    const meta=m.meta||{};
    const pat=meta.pattern||null;
    if(pat==="daily"){
      // Vanessa: daily = todos los días salvo special (ya descartado arriba).
      return true;
    }
    if(pat==="weekly_dow") return Array.isArray(meta.dows)&&meta.dows.includes(_dow(day));
    if(pat==="interval") return meta.interval_days>0&&(day-1)%meta.interval_days===0;
    if(pat==="monthly") return day===1||day===28;
    if(!pat){
      const sch=(meta.schedules||{})[effDt]||(meta.schedules||{})[dt];
      return Boolean(sch&&sch.active);
    }
    return false;
  };
  const stats={};
  const offDay={};
  for(let day=1;day<=cd&&day<=28;day++){
    const dt=dtByDay[day]||"workday";
    if(day===13||dt==="special"){offDay[day]=true;continue;}
    let total=0;
    for(const m of dailyMicros){if(microApplies(m,day))total++;}
    // Modelo "no check-in = X, hoy pendiente" (Vanessa 11-ago): un día PASADO que aplicaba se
    // colorea aunque no haya check-in (sin marcar = no hecho → rojo). HOY (day===cd) sin cerrar
    // NO se colorea (pendiente, gris) salvo que ya lo hayas respondido. Futuro: gris (isFuture).
    const _isPast=day<cd, _ansToday=(answeredByDay[day]||0)>0;
    if(total>0&&(_isPast||_ansToday))stats[day]={done:doneByDay[day]||0,total};
  }
  const colorFor=(p)=>p>=70?T.lima:p>=40?T.oro:T.coral;
  return(<div>
    <div style={{display:"flex",alignItems:"flex-end",gap:2,height:50,marginBottom:6}}>
      {Array.from({length:28},(_,i)=>{
        const day=i+1;
        const s=stats[day];
        const pct=s?Math.min(100,Math.round(s.done/s.total*100)):null;
        const isFuture=day>cd;
        const isToday=day===cd;
        const isOff=offDay[day];
        const h=isFuture?4:pct!==null?Math.max(8,pct):isOff?6:10;
        const bg=isFuture?"rgba(255,255,255,0.04)":pct!==null?colorFor(pct):isOff?"rgba(201,168,76,0.18)":"rgba(255,255,255,0.05)";
        const title=isFuture?" · futuro":isOff?(day===13?" · día 13 (ruptura)":" · día especial"):pct!==null?` · ${s.done}/${s.total} micros (${pct}%)`:" · sin micros";
        return(<div key={day} style={{flex:1,display:"flex",alignItems:"flex-end",height:"100%"}}>
          <div style={{width:"100%",height:`${h}%`,background:bg,borderRadius:"2px 2px 0 0",border:isToday?`1px solid ${T.oro}`:"none",opacity:isFuture?0.4:pct!==null?0.95:isOff?0.7:0.35,transition:"all 0.2s"}} title={`Día ${day}${title}`}/>
        </div>);
      })}
    </div>
    <div style={{display:"flex",justifyContent:"space-between",fontSize:9,color:T.grisL}}>
      <span>Día 1</span><span>Día 7</span><span>Día 14</span><span>Día 21</span><span>Día 28</span>
    </div>
    <div style={{display:"flex",gap:10,marginTop:8,fontSize:9,color:T.grisL,flexWrap:"wrap"}}>
      <span style={{display:"flex",alignItems:"center",gap:4}}><span style={{width:7,height:7,borderRadius:1,background:T.lima}}/> ≥70%</span>
      <span style={{display:"flex",alignItems:"center",gap:4}}><span style={{width:7,height:7,borderRadius:1,background:T.oro}}/> 40-69%</span>
      <span style={{display:"flex",alignItems:"center",gap:4}}><span style={{width:7,height:7,borderRadius:1,background:T.coral}}/> &lt;40%</span>
      <span style={{display:"flex",alignItems:"center",gap:4}}><span style={{width:7,height:7,borderRadius:1,background:"rgba(201,168,76,0.18)"}}/> Día libre</span>
      <span style={{display:"flex",alignItems:"center",gap:4}}><span style={{width:7,height:7,borderRadius:1,background:"rgba(255,255,255,0.04)"}}/> Sin datos</span>
    </div>
  </div>);
}

// EnergyChips — helper visual reusable: chips con peso visual según frecuencia.
// `kind`="plus" → lima, "minus" → coral.
function EnergyChips({items,kind}){
  if(!items.length) return null;
  const col=kind==="minus"?T.coral:T.lima;
  return(<div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
    {items.map(([t,c],i)=>{const sz=c>=3?13:c>=2?12:11;const op=c>=3?1:c>=2?0.85:0.7;return(
      <span key={i} style={{fontSize:sz,padding:c>=3?"6px 12px":"4px 10px",borderRadius:8,background:T.glass,color:col,border:`1px solid ${col}33`,opacity:op,fontWeight:c>=3?500:400,display:"inline-flex",alignItems:"center",gap:8}}>
        <span>{t}</span>
        {c>1&&<span style={{padding:"2px 8px",borderRadius:10,background:col,color:"#0a0a0a",fontSize:11,fontWeight:600,lineHeight:1}}>×{c}</span>}
      </span>
    );})}
  </div>);
}

// CycleEnergyPlus / Minus — agrega energy_plus / energy_minus del ciclo.
// El SÍ del día 13 (events.dia_si.text) entra como chip extra: lo que el user
// dijo al "introducir ruido" Taleb es por definición algo que le dio energía.
function CycleEnergyPlus({events}){
  const all=(events||[]).filter(e=>e.event_name==="checkin_complete").map(e=>(e.event_data||{}).energy_plus).filter(Boolean);
  const dia_si=(events||[]).filter(e=>e.event_name==="dia_si").map(e=>(e.event_data||{}).text).filter(Boolean);
  const merged=[...all,...dia_si];
  if(!merged.length) return null;
  const counts={};merged.forEach(p=>{counts[p]=(counts[p]||0)+1;});
  const sorted=Object.entries(counts).sort((a,b)=>b[1]-a[1]);
  return(<Card style={{marginTop:12}}>
    <p style={{fontSize:10,color:T.oro,letterSpacing:2,textTransform:"uppercase",marginBottom:6}}>Lo que te dio energía</p>
    <p style={{fontSize:11,color:T.grisL,marginBottom:10,lineHeight:1.45}}>Agregado de tus check-ins del ciclo {dia_si.length>0?"+ tu SÍ del día 13":""}.</p>
    <EnergyChips items={sorted} kind="plus"/>
  </Card>);
}
function CycleEnergyMinus({events}){
  const all=(events||[]).filter(e=>e.event_name==="checkin_complete").map(e=>(e.event_data||{}).energy_minus).filter(Boolean);
  if(!all.length) return null;
  const counts={};all.forEach(p=>{counts[p]=(counts[p]||0)+1;});
  const sorted=Object.entries(counts).sort((a,b)=>b[1]-a[1]);
  return(<Card style={{marginTop:12}}>
    <p style={{fontSize:10,color:T.oro,letterSpacing:2,textTransform:"uppercase",marginBottom:6}}>Lo que te quitó energía</p>
    <p style={{fontSize:11,color:T.grisL,marginBottom:10,lineHeight:1.45}}>Agregado de todos tus check-ins del ciclo.</p>
    <EnergyChips items={sorted} kind="minus"/>
  </Card>);
}

// AntifragilOpinion — 3 lecturas LLM en distintos momentos del ciclo, una sobre la otra.
// El user ve la evolución de cómo el sistema lo ha leído según iba teniendo más info:
//   1. PRE-PAYWALL  · early_reading: ~5 datos (perfil + OCEAN + vital + patrón).
//   2. POST-ONBOARDING · final_reading: ~25 datos (baseline declarada + focus_areas).
//   3. CIERRE        · antifragil_opinion: RAG sobre datos reales del ciclo (cumplimiento,
//      mood, beneficios, energía, diario). Confronta con las dos primeras al cierre.
// Las 3 capas se renderizan separadas por divisores. Si alguna falta, se omite.
function AntifragilOpinion({events,cycleId}){
  // Helper: fecha corta en es-ES a partir del created_at del evento. Para anclar al lector
  // que las dos primeras lecturas se escribieron ANTES de empezar (tiempo verbal en futuro
  // "vamos a..." se entiende como histórico, no como anacrónico post-cierre).
  const _fmtFecha=(iso)=>{if(!iso)return"";try{return new Date(iso).toLocaleDateString("es-ES",{day:"numeric",month:"short"});}catch{return"";}};

  // Capa 1: early_reading (1 por user, escrito al cerrar el onboarding).
  const erEv=(events||[]).find(e=>e.event_name==="early_reading");
  const er=erEv?((erEv.event_data||{}).reading||{}):null;
  const erText=er?(er.narrative||""):"";
  const erMatiz=erEv?((erEv.event_data||{}).matiz||""):"";
  const erFecha=_fmtFecha(erEv?.created_at);

  // Capa 2: final_reading (1 por user/onboarding).
  const frEv=(events||[]).find(e=>e.event_name==="final_reading");
  const fr=frEv?((frEv.event_data||{}).reading||{}):null;
  const frText=fr?(fr.narrative||""):"";
  const frFocus=Array.isArray(fr?.focus_areas)?fr.focus_areas.filter(Boolean):[];
  const frMatiz=frEv?((frEv.event_data||{}).matiz||""):"";
  const frFecha=_fmtFecha(frEv?.created_at);

  // Capa 3: antifragil_opinion RAG — SOLO la del CIERRE DEL CICLO (week_number >= 4).
  // Vanessa (jul-26): las lecturas RAG semanales viven en cada card de "Mis semanas". Aquí,
  // en "Tu lectura", solo aparece la lectura final del ciclo — que cruza TODO — cuando el
  // ciclo termina. Durante el ciclo esta capa se omite y se ven solo early + final.
  const opinions=(events||[]).filter(e=>e.event_name==="antifragil_opinion"&&(e.event_data||{}).cycle_id===cycleId&&((e.event_data||{}).week_number||0)>=4);
  const ev=opinions.sort((a,b)=>((b.event_data||{}).week_number||0)-((a.event_data||{}).week_number||0))[0];
  const ragText=ev?((ev.event_data||{}).text||""):"";
  const ragLabel="cierre del ciclo";

  if(!erText&&!frText&&!ragText){
    return(<Card style={{marginTop:12,opacity:0.75,padding:"16px 18px"}}>
      <p style={{fontSize:10,color:T.oro,letterSpacing:2,textTransform:"uppercase",marginBottom:8}}>Tu lectura</p>
      <p style={{fontSize:11,color:T.grisL,fontStyle:"italic",lineHeight:1.5}}>Aquí leerás cómo te he ido leyendo a lo largo del ciclo: la primera lectura tras el onboarding básico, la segunda tras todo lo que aportaste, y la lectura final cruzando tus datos reales (cumplimiento, mood, beneficios). Tres espejos a confrontar.</p>
    </Card>);
  }

  const sep={marginBottom:16,paddingBottom:14,borderBottom:`1px solid ${T.gb}`};
  return(<Card gold style={{marginTop:12,padding:"18px 20px"}}>
    <p style={{fontSize:10,color:T.oro,letterSpacing:2,textTransform:"uppercase",marginBottom:12}}>Tu lectura</p>

    {erText&&<div style={(frText||ragText)?sep:{}}>
      <p style={{fontSize:9,letterSpacing:1.5,color:T.grisL,textTransform:"uppercase",marginBottom:6}}>Cómo te leí al empezar{erFecha?` · escrito el ${erFecha}`:""}</p>
      <p style={{fontSize:13,color:T.crema,lineHeight:1.65,fontFamily:T.serif,fontStyle:"italic",whiteSpace:"pre-line"}}>{erText}</p>
      {erMatiz&&<p style={{marginTop:8,fontSize:11,color:T.grisL,fontStyle:"italic",lineHeight:1.5}}>Tu matiz: "{erMatiz}"</p>}
    </div>}

    {frText&&<div style={ragText?sep:{}}>
      <p style={{fontSize:9,letterSpacing:1.5,color:T.grisL,textTransform:"uppercase",marginBottom:6}}>Cómo te leí a fondo · baseline del ciclo{frFecha?` · escrito el ${frFecha}`:""}</p>
      <p style={{fontSize:13,color:T.crema,lineHeight:1.65,fontFamily:T.serif,fontStyle:"italic",whiteSpace:"pre-line"}}>{frText}</p>
      {frFocus.length>0&&<div style={{marginTop:10,display:"flex",flexWrap:"wrap",gap:6}}>
        {frFocus.map((f,i)=><span key={i} style={{fontSize:10,padding:"3px 9px",borderRadius:10,background:T.oroBg,color:T.oro,border:`1px solid ${T.oroBorder}`}}>{f}</span>)}
      </div>}
      {frMatiz&&<p style={{marginTop:10,fontSize:11,color:T.grisL,fontStyle:"italic",lineHeight:1.5}}>Tu matiz: "{frMatiz}"</p>}
    </div>}

    {ragText&&<div>
      <p style={{fontSize:9,letterSpacing:1.5,color:T.grisL,textTransform:"uppercase",marginBottom:6}}>Lo que dicen tus datos {ragLabel?`· ${ragLabel}`:""}</p>
      <p style={{fontSize:13,color:T.crema,lineHeight:1.65,fontFamily:T.serif,fontStyle:"italic",whiteSpace:"pre-line"}}>{ragText}</p>
    </div>}
  </Card>);
}

// CycleBenefits — agrega TODOS los micro_benefit del ciclo en chips con peso visual.
function CycleBenefits({events}){
  const benefits=(events||[]).filter(e=>e.event_name==="micro_benefit");
  if(!benefits.length) return null;
  const counts={};
  benefits.forEach(e=>{const b=(e.event_data||{}).benefit;if(b)counts[b]=(counts[b]||0)+1;});
  const sorted=Object.entries(counts).sort((a,b)=>b[1]-a[1]);
  if(!sorted.length) return null;
  return(<Card style={{marginTop:12}}>
    <p style={{fontSize:10,color:T.oro,letterSpacing:2,textTransform:"uppercase",marginBottom:6}}>Beneficios del ciclo</p>
    <p style={{fontSize:11,color:T.grisL,marginBottom:10,lineHeight:1.45}}>Lo que tus micros te han aportado en todo el ciclo. Cuanto más se repite, más grande.</p>
    <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
      {sorted.map(([b,c],i)=>{const sz=c>=4?14:c>=2?12:11;const op=c>=4?1:c>=2?0.85:0.7;return(
        <span key={i} style={{fontSize:sz,padding:c>=4?"6px 12px":"4px 10px",borderRadius:8,background:T.glass,color:T.crema,border:`1px solid ${T.gb}`,opacity:op,fontWeight:c>=4?500:400,letterSpacing:0.2}}>
          {b}{c>1&&<span style={{marginLeft:6,color:T.oro,fontSize:9,fontWeight:500}}>×{c}</span>}
        </span>
      );})}
    </div>
  </Card>);
}

// PeroVisionDiario — bloque narrativo que cruza PEROS literales del onboarding con el
// objetivo del ciclo y el cumplimiento real de los micros de cada categoría.
function PeroVisionDiario({events,mcs,obj}){
  const ev=(events||[]).filter(e=>e.event_name==="peros_categorized").pop();
  if(!ev) return null;
  const peros=(ev.event_data||{}).peros||[];
  if(!peros.length) return null;
  // Por categoría: % de cumplimiento real de los micros de esa cat
  const catPct=(cat)=>{
    const tag=CAT_TO_TAG[cat]||"";
    const microsCat=(mcs||[]).filter(m=>{const c=(m.category||m.tag||"").toLowerCase();return c.includes(tag);});
    const done=microsCat.reduce((s,m)=>s+m.done,0);
    const total=microsCat.reduce((s,m)=>s+m.total,0);
    return{pct:total?Math.round(done/total*100):null,nMicros:microsCat.length};
  };
  return(<Card style={{marginTop:12}}>
    <p style={{fontSize:10,color:T.oro,letterSpacing:2,textTransform:"uppercase",marginBottom:6}}>PERO · visión · datos</p>
    <p style={{fontSize:11,color:T.grisL,marginBottom:12,lineHeight:1.45}}>Lo que dijiste en el onboarding (PERO), lo que querías (tu objetivo) y lo que muestran tus datos del ciclo.</p>
    {obj&&<p style={{fontSize:13,color:T.crema,fontFamily:T.serif,fontStyle:"italic",lineHeight:1.5,marginBottom:14,paddingBottom:12,borderBottom:`1px solid ${T.gb}`}}>Tu objetivo: "{obj}"</p>}
    {peros.map((p,i)=>{
      const pero=p.text||p.literal||p.pero||p.original||"(PERO sin texto)";
      const cat=p.category||p.cat||p.tag||"";
      const {pct,nMicros}=catPct(cat);
      const status=pct===null?null:(pct>=60?{lbl:"Datos contradicen el PERO",col:T.lima}:pct>=30?{lbl:"A medias",col:T.oro}:{lbl:"Datos confirman el PERO",col:T.coral});
      return(<div key={i} style={{padding:"10px 0",borderBottom:i<peros.length-1?`1px solid ${T.gb}`:"none"}}>
        <p style={{fontSize:13,color:T.crema,fontStyle:"italic",fontFamily:T.serif,lineHeight:1.5,marginBottom:6}}>"{pero}"</p>
        <div style={{display:"flex",gap:10,alignItems:"center",flexWrap:"wrap",fontSize:11}}>
          {cat&&<span style={{color:T.grisL}}>Categoría: <span style={{color:T.crema}}>{PEROS_CAT_LABELS[cat]||cat}</span></span>}
          {nMicros>0&&pct!==null&&<>
            <span style={{color:T.grisL}}>· cumplimiento <span style={{color:status.col,fontFamily:T.serif,fontSize:13,fontWeight:500}}>{pct}%</span></span>
            <span style={{color:status.col,fontSize:10,letterSpacing:1,textTransform:"uppercase"}}>· {status.lbl}</span>
          </>}
          {nMicros===0&&<span style={{color:T.grisL,fontStyle:"italic"}}>· sin micros de esta categoría</span>}
        </div>
      </div>);
    })}
  </Card>);
}

function Logs({events}){
  const ci=events.filter(e=>e.event_name==="checkin_complete").sort((a,b)=>new Date(b.created_at)-new Date(a.created_at)).slice(0,5);
  if(!ci.length)return null;
  const me={"genial":"😄","bien":"🙂","normal":"😐","flojo":"😔","mal":"😞"};
  return<>{ci.map((e,i)=>{const d=e.event_data||{};
    return<Card key={i} style={{marginBottom:6}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
        <div><p style={{fontSize:10,color:T.grisL}}>Día {d.cycle_day||"?"} — {d.date||""}</p>
          <p style={{fontSize:12,marginTop:3}}>{me[d.mood?.toLowerCase()]||"📝"} {d.mood||"—"}</p></div>
        <div style={{textAlign:"right",fontSize:11,color:T.grisL}}>
          {d.energy_plus&&<p style={{color:T.verde}}>+{d.energy_plus}</p>}
          {d.energy_minus&&<p style={{color:T.rojo}}>-{d.energy_minus}</p>}
        </div>
      </div>
      {d.friction_reason&&<p style={{fontSize:11,color:T.grisL,marginTop:4,fontStyle:"italic"}}>Fricción: {d.friction_reason}</p>}
    </Card>;
  })}</>;
}

function AR({l,v,m,lk,last}){
  return<div style={{display:"flex",justifyContent:"space-between",gap:12,fontSize:13,padding:"7px 0",borderBottom:last?"none":`1px solid ${T.gb}`}}>
    <span style={{color:T.grisL,flexShrink:0}}>{l}</span>
    {lk?<a href={`https://${v}`} target="_blank" rel="noreferrer" style={{color:T.oro,textDecoration:"none",fontSize:12,textAlign:"right"}}>{v}</a>
    :<span style={{color:m?T.grisL:T.crema,textAlign:"right"}}>{v}</span>}
  </div>;
}

function Ldr({text}){return<div style={{minHeight:"100vh",display:"flex",alignItems:"center",justifyContent:"center",background:T.bg}}><p style={{color:T.grisL,fontSize:14}}>{text||""}</p></div>;}

// Mapeo del mood (4 niveles) a un score 1-4 y un emoji para los chips de detalle.
// low = 1 (rojo, altura mínima), normal = 2 (oro), energy = 3 (verde), high = 4 (verde más intenso).
// El bot graba mood SIN prefix ("low"/"normal"/"energy"/"high") en checkin_complete.event_data.mood.
// Mantenemos también las keys con prefix `mood_*` por compat hacia atrás (sufijo legacy).
const MOOD_SCORE = {low:1, normal:2, energy:3, high:4, mood_low:1, mood_normal:2, mood_energy:3, mood_high:4};
const MOOD_EMOJI = {low:"😶", normal:"😐", energy:"💪", high:"🔥", mood_low:"😶", mood_normal:"😐", mood_energy:"💪", mood_high:"🔥"};
const DOW_LABELS = ["L","M","X","J","V","S","D"];

// Gráfico semanal: 7 columnas = los 7 días de ESA semana del ciclo, EN ORDEN de ciclo
// (no L-D fijo — el ciclo puede empezar cualquier día). Cada columna se etiqueta con su
// día real de la semana y muestra el mood de ese cycle_day. Así el gráfico y el detalle
// (WeekDetail, también en orden de ciclo) se corresponden columna a fila.
function WeekMoodChart({events, cycleStart, weekNum}){
  // Mood por cycle_day (el bot graba mood y energía en checkin_complete separados; el
  // último con mood gana). Preferimos cycle_day; si falta, no se puede alinear al ciclo.
  const moodByCd = {};
  (events||[]).forEach(e=>{
    const cd = (e.event_data||{}).cycle_day;
    const m = (e.event_data||{}).mood;
    if(cd==null||!m) return;
    moodByCd[cd] = MOOD_SCORE[m]||0;
  });
  const cs = cycleStart ? new Date((""+cycleStart).slice(0,10)+"T00:00:00") : null;
  const startDay = (weekNum-1)*7+1;
  const colorOf = score => score>=3?T.verde:score>=2?T.oro:T.rojo;
  const days = Array.from({length:7},(_,i)=>{
    const cd = startDay+i;
    let lbl = "?";
    if(cs){ const dt=new Date(cs); dt.setDate(dt.getDate()+(cd-1)); lbl=DOW_LABELS[(dt.getDay()+6)%7]; }
    return {cd, lbl, score: moodByCd[cd]||0};
  });
  return(<div style={{display:"flex",alignItems:"flex-end",gap:6,height:60,marginTop:10,marginBottom:8,paddingBottom:18,borderBottom:`1px solid ${T.gb}`,position:"relative"}}>
    {days.map(d=>{
      const heightPct = d.score ? (d.score/4*100) : 0;
      return(<div key={d.cd} style={{flex:1,display:"flex",flexDirection:"column",alignItems:"center",height:"100%",position:"relative"}}>
        <div style={{flex:1,display:"flex",alignItems:"flex-end",width:"100%"}}>
          {d.score>0 && <div style={{width:"100%",height:`${heightPct}%`,background:colorOf(d.score),borderRadius:"3px 3px 0 0",transition:"all 0.3s"}} title={`Mood ${d.score.toFixed(1)}/4`}/>}
        </div>
        <span style={{position:"absolute",bottom:-16,fontSize:10,color:T.grisL}}>{d.lbl}</span>
      </div>);
    })}
  </div>);
}

// Detalle diario: una fila por DÍA (no por evento). El bot graba múltiples
// `checkin_complete` events el mismo día (mood + energy + friction como 3 eventos
// separados), antes salían como filas duplicadas/vacías. Ahora se mergean por
// cycle_day en un solo objeto antes de renderizar.
function WeekDetail({events,cycleStart,weekNum,cd}){
  // Etiqueta del día por cycle_day + cycleStart (igual que WeekMoodChart) para que gráfico
  // y detalle coincidan siempre. Fallback a event_data.date si no hay cycleStart.
  const csD=cycleStart?new Date((""+cycleStart).slice(0,10)+"T00:00:00"):null;
  const byDay={};
  (events||[]).forEach(e=>{
    const d=e.event_data||{};
    const k=d.cycle_day;
    if(k==null)return;
    if(!byDay[k])byDay[k]={cycle_day:k,date:d.date,mood:null,energy_plus:"",energy_minus:"",friction_reasons:{}};
    if(d.mood)byDay[k].mood=d.mood;
    if(d.energy_plus)byDay[k].energy_plus=d.energy_plus;
    if(d.energy_minus)byDay[k].energy_minus=d.energy_minus;
    if(d.friction_reasons)byDay[k].friction_reasons={...byDay[k].friction_reasons,...d.friction_reasons};
    if(!byDay[k].date&&d.date)byDay[k].date=d.date;
  });
  // TODOS los días VIVIDOS de la semana (no solo los que tienen check-in). Los días sin
  // responder salen con línea vacía (Vanessa). El día 13 se marca aparte (ruptura, no fallo).
  const startDay=(weekNum-1)*7+1;
  const endDay=Math.min(weekNum*7, cd||weekNum*7);
  const rows=[];
  for(let day=startDay; day<=endDay; day++){ rows.push(byDay[day] || {cycle_day:day, empty:true}); }
  return(<div style={{marginTop:4}}>
    {rows.map((d,i)=>{
      let dt=null;
      if(csD){ dt=new Date(csD); dt.setDate(dt.getDate()+(d.cycle_day-1)); }
      else if(d.date){ dt=new Date(d.date+"T00:00:00"); }
      const dowLabel = dt ? DOW_LABELS[(dt.getDay()+6)%7] : "?";
      const isD13 = d.cycle_day===13;
      const friccionStr = d.friction_reasons && Object.keys(d.friction_reasons).length
        ? Object.values(d.friction_reasons).slice(0,2).map(f=>(f&&f.text)||"").filter(Boolean).join(", ")
        : "";
      const missed = d.empty && !isD13;
      // Check-in "en seco": hubo check-in (no missed) pero sin mood/energía/fricción. Antes se
      // pintaba en blanco → indistinguible de un día SIN check-in, así que el detalle parecía tener
      // menos check-ins que el contador (V: 2 y 3 check-ins pero solo 1 día con nota se veía). Ahora
      // se marca con ✓ para que el detalle cuadre con el conteo. Bug 8-ago.
      const hasNota = Boolean(d.mood || d.energy_plus || d.energy_minus || friccionStr);
      const bareCheckin = !missed && !isD13 && !hasNota;
      return(<div key={i} style={{display:"flex",gap:8,alignItems:"baseline",fontSize:11,padding:"5px 0",borderBottom:i<rows.length-1?`1px solid ${T.gb}`:"none",opacity:missed?0.5:1}}>
        <span style={{minWidth:14,color:T.grisL,fontWeight:500}}>{dowLabel}</span>
        <span style={{minWidth:18}}>{isD13?"🎲":(MOOD_EMOJI[d.mood]||(bareCheckin?"✅":""))}</span>
        <div style={{flex:1,display:"flex",flexWrap:"wrap",gap:6,color:T.grisL}}>
          {isD13 ? <span style={{color:T.gris,fontStyle:"italic"}}>día 13 · ruptura</span>
           : missed ? <span style={{color:T.gris}}>—</span>
           : bareCheckin ? <span style={{color:T.verde}}>Check-in hecho <span style={{color:T.gris,fontStyle:"italic"}}>· sin nota</span></span>
           : <>
             {d.energy_plus && <span style={{color:T.verde}}>+ {d.energy_plus}</span>}
             {d.energy_minus && <span style={{color:T.rojo}}>− {d.energy_minus}</span>}
             {friccionStr && <span style={{color:T.oro}}>⚠ {friccionStr}</span>}
           </>}
        </div>
      </div>);
    })}
  </div>);
}

// CycleDiary: diario POR SEMANAS del ciclo (Vanessa jul-26: "el diario ha de ir por
// semanas para ir acumulando y ver comparativas"). El user escribe la semana EN CURSO;
// las semanas pasadas quedan como historia de solo lectura arriba (acumulación). Autosave
// debounced a 1s. Persiste en events.user_note (event_data: {cycle_id, text, weeks{}, updated_at}).
// El bot/api.py hace UPSERT por cycle_id — siempre hay UN solo evento user_note vivo por ciclo.
//   · weeks: {"1":"...","2":"..."} — el mapa por semana (fuente nueva).
//   · text: blob legacy del ciclo entero (pre-jul26). Si existe y no hay weeks, se muestra
//     arriba como "Notas del ciclo" de solo lectura para no perderlo.
// Esta es la única excepción al patrón "Dashboard solo lee de Supabase" (planeada en CLAUDE.md).
function CycleDiary({userId,cycleId,initialEvent,wk,chatEntries}){
  const ed=initialEvent?.event_data||{};
  const legacy=(ed.text||"").trim();
  const curWk=Math.min(Math.max(1,wk||1),4);
  const[weeks,setWeeks]=useState(ed.weeks||{});
  const[status,setStatus]=useState("");
  const timer=useRef(null);
  useEffect(()=>{setWeeks((initialEvent?.event_data||{}).weeks||{});},[cycleId]);
  const save=useCallback(async(nextWeeks)=>{
    if(!userId||!cycleId) return;
    setStatus("Guardando…");
    try{
      // Auth (20-jun): pasar JWT del Supabase session. Sin esto el backend
      // devuelve 401 (auth real para evitar escritura cruzada de diarios).
      const {data:{session}}=await supabase.auth.getSession();
      const token=session?.access_token;
      if(!token){setStatus("Sesión expirada — recarga");setTimeout(()=>setStatus(""),3000);return;}
      const r=await fetch(`${API}/api/user-note`,{
        method:"POST",
        headers:{"Content-Type":"application/json","Authorization":`Bearer ${token}`},
        // text: mantenemos el blob legacy tal cual (no lo tocamos desde el flujo por semanas).
        body:JSON.stringify({user_id:userId,cycle_id:cycleId,text:legacy,weeks:nextWeeks}),
      });
      if(r.ok) setStatus("Guardado");
      else if(r.status===401||r.status===403) setStatus("Sin permiso — recarga");
      else setStatus("Error");
    }catch(e){setStatus("Sin conexión");}
    setTimeout(()=>setStatus(""),2000);
  },[userId,cycleId,legacy]);
  const onChangeWeek=(w,val)=>{
    const next={...weeks,[w]:val};
    setWeeks(next);
    if(timer.current) clearTimeout(timer.current);
    timer.current=setTimeout(()=>save(next),1000);
  };
  // Entradas de chat/audio (diary_entry) agrupadas por SEMANA (cycle_day → semana) para tejerlas
  // dentro de la agenda semanal, no en una lista plana que crece todo el ciclo (Vanessa 30-sep).
  const chatByWeek={1:[],2:[],3:[],4:[]};
  [...(chatEntries||[])]
    .sort((a,b)=>(((a.event_data||{}).cycle_day||0)-((b.event_data||{}).cycle_day||0))||(new Date(a.created_at||0)-new Date(b.created_at||0)))
    .forEach(e=>{const cd=(e.event_data||{}).cycle_day||1;const w=Math.min(4,Math.max(1,Math.ceil(cd/7)));chatByWeek[w].push(e);});
  return(<div style={{marginBottom:14}}>
    <div style={{display:"flex",justifyContent:"space-between",alignItems:"baseline",marginBottom:8}}>
      <p style={{fontSize:11,color:T.grisL,letterSpacing:2,textTransform:"uppercase"}}>Diario del ciclo · por semanas</p>
      {status&&<span style={{fontSize:10,color:T.grisL}}>{status}</span>}
    </div>
    {/* Blob legacy (pre-semanas): mostrar arriba como referencia si existe y aún no hay entradas por semana */}
    {legacy&&!Object.keys(weeks).length&&<div style={{marginBottom:12,padding:12,background:T.glass,border:`1px solid ${T.gb}`,borderRadius:8}}>
      <p style={{fontSize:9,letterSpacing:2,color:T.grisL,textTransform:"uppercase",marginBottom:4}}>Notas del ciclo</p>
      <p style={{fontSize:12,color:T.crema,lineHeight:1.5,whiteSpace:"pre-wrap"}}>{legacy}</p>
    </div>}
    {/* Las entradas de chat/audio (diary_entry) se tejen dentro de cada semana abajo (Vanessa
        30-sep: "tiene que ir ordenado") — no en una lista plana que crece todo el ciclo. */}
    {/* Las 4 semanas SIEMPRE visibles (Vanessa jul-26: "faltan las semanas 1, 3 y 4 aunque no
        haya nada"). Todas editables — el diario es del user, puede escribir/retomar cualquier
        semana. La en curso se resalta; las próximas se ven en gris pero se pueden escribir. */}
    {[1,2,3,4].map(w=>{
      const isCur=w===curWk;const isFut=w>curWk;
      const label=isCur?`Semana ${w} · en curso`:isFut?`Semana ${w} · próxima`:`Semana ${w}`;
      return(<div key={w} style={{marginBottom:12}}>
        <p style={{fontSize:9,letterSpacing:2,color:isCur?T.oro:T.grisL,textTransform:"uppercase",marginBottom:6}}>{label}</p>
        {(chatByWeek[w]||[]).length>0&&<div style={{marginBottom:8,padding:"8px 10px",background:"rgba(255,255,255,0.02)",border:`1px solid ${T.gb}`,borderRadius:8}}>
          <p style={{fontSize:8,letterSpacing:1.5,color:T.grisL,textTransform:"uppercase",marginBottom:6}}>Lo que contaste esos días</p>
          {chatByWeek[w].map((e,i)=>{const d=e.event_data||{};return(<div key={i} style={{marginBottom:5,display:"flex",gap:6}}>
            <span style={{fontSize:9,letterSpacing:1,color:T.grisL,textTransform:"uppercase",flexShrink:0,marginTop:2}}>Día {d.cycle_day||"?"}</span>
            <span style={{fontSize:12,color:T.crema,lineHeight:1.45}}>{d.text||""}</span>
          </div>);})}
        </div>}
        <textarea value={weeks[w]||weeks[String(w)]||""} onChange={e=>onChangeWeek(w,e.target.value)}
          placeholder={isFut?"Aún no ha llegado, pero puedes dejar notas si quieres.":`Semana ${w}: lo que descubres, lo que cuesta, ideas, dudas…`}
          style={{width:"100%",minHeight:isCur?110:70,padding:12,background:T.glass,border:`1px solid ${isCur?T.oroBorder:T.gb}`,borderRadius:8,color:T.crema,fontFamily:T.font,fontSize:13,lineHeight:1.5,resize:"vertical",outline:"none",opacity:isFut?0.7:1}}/>
      </div>);
    })}
  </div>);
}
